<script setup>
</script>
<template>
  <main>
    <div class="px-4 sm:px-6 xl:ml-auto xl:mr-0 xl:pl-8 xl:pr-0 mt-[70px]">
      <div class="flex">
        <div class="w-full xl:mr-[32px] xl:w-[calc(100%-393px)]">
          <div class="w-full">
            <div>
              <header><div></div></header>
              <div class="flex flex-col gap-8 sm:gap-[60px]">
                <section>
                  <h1 class="sr-only">SME IPOs in 2025</h1>
                  <div
                    class="relative -mx-4 flex flex-col items-start gap-8 self-stretch overflow-hidden px-4 pb-8 pt-6 md:pb-[52px] md:pt-12"
                  >
                    <div
                      class="flex flex-row items-center sm:justify-between sm:items-start w-full"
                    >
                      <div
                        class="flex w-[64%] flex-col items-start gap-3 sm:w-[70%] 2xl:w-[50%]"
                      >
                        <div
                          class="text-2xl md:w-[70%] sm:text-[40px] font-semibold not-italic leading-[110%] tracking-[-0.24px]"
                        >
                          <span class="mr-1.5 inline">SME IPOs in 2025</span>
                        </div>
                        <span
                          class="relative inline-flex items-baseline whitespace-normal text-left align-middle text-dark-1 outline-none text-sm font-normal not-italic leading-[150%] tracking-[-0.12px] sm:text-base"
                          >Explore all SME IPOs and discover potential
                          investments.</span
                        >
                        <div class="mt-7 hidden md:block">
                          <div
                            class="flex w-full flex-col items-center gap-4 ipad:flex-row ipad:items-start ipad:gap-3"
                          >
                            <div
                              class="flex w-[-webkit-fill-available] flex-col justify-between text-sm md:w-full desktop-sm:w-[55%] desktop-md:w-[60%]"
                            >
                              <div
                                class="item-center flex w-full items-center rounded-full border border-gray-300 bg-white px-3 py-[11px] focus:border-black"
                              >
                                <div
                                  class="flex items-center rounded-full pl-2 font-semibold"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="22"
                                    height="16"
                                    fill="none"
                                    viewBox="0 0 16 12"
                                    class="mr-1 h-auto rounded-[3px]"
                                  >
                                    <mask
                                      id="mask0_680_15926"
                                      width="16"
                                      height="12"
                                      x="0"
                                      y="0"
                                      maskUnits="userSpaceOnUse"
                                      style="mask-type: luminance"
                                    >
                                      <path
                                        fill="#fff"
                                        d="M0 0h16v12H0z"
                                      ></path>
                                    </mask>
                                    <g mask="url(#mask0_680_15926)">
                                      <path
                                        fill="#F7FCFF"
                                        fill-rule="evenodd"
                                        d="M0 0v12h16V0z"
                                        clip-rule="evenodd"
                                      ></path>
                                      <mask
                                        id="mask1_680_15926"
                                        width="16"
                                        height="12"
                                        x="0"
                                        y="0"
                                        maskUnits="userSpaceOnUse"
                                        style="mask-type: luminance"
                                      >
                                        <path
                                          fill="#fff"
                                          fill-rule="evenodd"
                                          d="M0 0v12h16V0z"
                                          clip-rule="evenodd"
                                        ></path>
                                      </mask>
                                      <g
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        mask="url(#mask1_680_15926)"
                                      >
                                        <path
                                          fill="#FF8C1A"
                                          d="M0 0v4h16V0z"
                                        ></path>
                                        <path
                                          fill="#5EAA22"
                                          d="M0 8v4h16V8z"
                                        ></path>
                                        <path
                                          fill="#3D58DB"
                                          d="M6 6a2 2 0 1 0 4 0 2 2 0 0 0-4 0m3.5 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
                                        ></path>
                                        <path
                                          fill="#3D58DB"
                                          d="M7.997 6.43 7.58 7.967l.245-1.573-1.006 1.234.863-1.338-1.421.718 1.332-.871-1.59.078 1.572-.254-1.485-.575 1.54.407-1.123-1.13 1.24.999-.565-1.489.727 1.417L7.997 4l.089 1.59.727-1.417-.566 1.489 1.24-.998-1.122 1.13 1.54-.408-1.485.575 1.572.254-1.59-.078 1.332.871-1.42-.718.862 1.338L8.17 6.394l.244 1.573z"
                                        ></path>
                                      </g>
                                    </g></svg
                                  ><span
                                    class="text-gray-primary ml-1 mr-3 text-sm"
                                    >+91</span
                                  >
                                </div>
                                <input
                                  class="w-1/2 flex-1 overflow-hidden bg-transparent pr-2 leading-6 placeholder:text-sm placeholder:font-normal placeholder:text-gray-accent3 focus:outline-none"
                                  placeholder="Enter your number"
                                  autocomplete="off"
                                  autocorrect="off"
                                  type="tel"
                                  name="phoneInput"
                                  value=""
                                />
                              </div>
                            </div>
                            <button
                              class="group cursor-pointer disabled:cursor-not-allowed bg-primary-base text-white hover:bg-primary-dark active:bg-primary-dark2 disabled:bg-primary-base/50 rounded-full w-full shrink-0 whitespace-nowrap text-base font-bold leading-6 sm:shrink ipad:w-[40%] ipad:shrink-0 flex justify-center items-center gap-2 px-10 py-3"
                            >
                              Apply for IPO
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        class="absolute sm:relative -right-14 top-6 flex h-[142px] w-[163px] sm:right-0 sm:top-auto sm:h-[251px] sm:w-[289px]"
                      >
                        <img
                          alt="sme"
                          fetchpriority="high"
                          width="163"
                          height="142"
                          decoding="async"
                          data-nimg="1"
                          class="w-full h-full"
                          style="color: transparent"
                          src="/next-ipo-assets/ipo-sign-up.webp"
                        />
                      </div>
                    </div>
                    <div class="md:hidden w-full">
                      <div
                        class="flex w-full flex-col items-center gap-4 ipad:flex-row ipad:items-start ipad:gap-3"
                      >
                        <div
                          class="flex w-[-webkit-fill-available] flex-col justify-between text-sm md:w-full desktop-sm:w-[55%] desktop-md:w-[60%]"
                        >
                          <div
                            class="item-center flex w-full items-center rounded-full border border-gray-300 bg-white px-3 py-[11px] focus:border-black"
                          >
                            <div
                              class="flex items-center rounded-full pl-2 font-semibold"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="22"
                                height="16"
                                fill="none"
                                viewBox="0 0 16 12"
                                class="mr-1 h-auto rounded-[3px]"
                              >
                                <mask
                                  id="mask0_680_15926"
                                  width="16"
                                  height="12"
                                  x="0"
                                  y="0"
                                  maskUnits="userSpaceOnUse"
                                  style="mask-type: luminance"
                                >
                                  <path fill="#fff" d="M0 0h16v12H0z"></path>
                                </mask>
                                <g mask="url(#mask0_680_15926)">
                                  <path
                                    fill="#F7FCFF"
                                    fill-rule="evenodd"
                                    d="M0 0v12h16V0z"
                                    clip-rule="evenodd"
                                  ></path>
                                  <mask
                                    id="mask1_680_15926"
                                    width="16"
                                    height="12"
                                    x="0"
                                    y="0"
                                    maskUnits="userSpaceOnUse"
                                    style="mask-type: luminance"
                                  >
                                    <path
                                      fill="#fff"
                                      fill-rule="evenodd"
                                      d="M0 0v12h16V0z"
                                      clip-rule="evenodd"
                                    ></path>
                                  </mask>
                                  <g
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    mask="url(#mask1_680_15926)"
                                  >
                                    <path
                                      fill="#FF8C1A"
                                      d="M0 0v4h16V0z"
                                    ></path>
                                    <path
                                      fill="#5EAA22"
                                      d="M0 8v4h16V8z"
                                    ></path>
                                    <path
                                      fill="#3D58DB"
                                      d="M6 6a2 2 0 1 0 4 0 2 2 0 0 0-4 0m3.5 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
                                    ></path>
                                    <path
                                      fill="#3D58DB"
                                      d="M7.997 6.43 7.58 7.967l.245-1.573-1.006 1.234.863-1.338-1.421.718 1.332-.871-1.59.078 1.572-.254-1.485-.575 1.54.407-1.123-1.13 1.24.999-.565-1.489.727 1.417L7.997 4l.089 1.59.727-1.417-.566 1.489 1.24-.998-1.122 1.13 1.54-.408-1.485.575 1.572.254-1.59-.078 1.332.871-1.42-.718.862 1.338L8.17 6.394l.244 1.573z"
                                    ></path>
                                  </g>
                                </g></svg
                              ><span class="text-gray-primary ml-1 mr-3 text-sm"
                                >+91</span
                              >
                            </div>
                            <input
                              class="w-1/2 flex-1 overflow-hidden bg-transparent pr-2 leading-6 placeholder:text-sm placeholder:font-normal placeholder:text-gray-accent3 focus:outline-none"
                              placeholder="Enter your number"
                              autocomplete="off"
                              autocorrect="off"
                              type="tel"
                              name="phoneInput"
                              value=""
                            />
                          </div>
                        </div>
                        <button
                          class="group cursor-pointer disabled:cursor-not-allowed bg-primary-base text-white hover:bg-primary-dark active:bg-primary-dark2 disabled:bg-primary-base/50 rounded-full w-full shrink-0 whitespace-nowrap text-base font-bold leading-6 sm:shrink ipad:w-[40%] ipad:shrink-0 py-3 px-10"
                        >
                          Apply for IPO
                        </button>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div
                      class="no-scrollbar sticky z-[3] flex w-full flex-col overflow-scroll bg-white xl:flex-row xl:items-center xl:justify-between xl:border-b xl:border-light-4 top-[60px] xl:top-[70px]"
                    >
                      <div
                        role="tablist"
                        class="no-scrollbar flex justify-between inter-display-font scrollbar-hidden no-scrollbar bg-white flex-nowrap overflow-scroll xl:gap-7 gap-6 px-0 xl:border-none border-b border-light-4"
                      >
                        <a
                          class="relative flex flex-shrink-0 items-center whitespace-nowrap border-b-2 py-[18px] text-base font-semibold leading-6 -tracking-[0.18px] outline-none transition-colors border-primary-accent3 text-primary-accent3"
                          aria-selected="true"
                          role="tab"
                          href="/ipo/sme/"
                          >All</a
                        ><a
                          class="relative flex flex-shrink-0 items-center whitespace-nowrap border-b-2 border-transparent py-[18px] text-base font-semibold leading-6 -tracking-[0.18px] outline-none transition-colors text-dark-7"
                          aria-selected="false"
                          role="tab"
                          href="/ipo/sme/current-sme-ipo/"
                          >Open</a
                        ><a
                          class="relative flex flex-shrink-0 items-center whitespace-nowrap border-b-2 border-transparent py-[18px] text-base font-semibold leading-6 -tracking-[0.18px] outline-none transition-colors text-dark-7"
                          aria-selected="false"
                          role="tab"
                          href="/ipo/sme/upcoming-sme-ipo/"
                          >Upcoming</a
                        ><a
                          class="relative flex flex-shrink-0 items-center whitespace-nowrap border-b-2 border-transparent py-[18px] text-base font-semibold leading-6 -tracking-[0.18px] outline-none transition-colors text-dark-7"
                          aria-selected="false"
                          role="tab"
                          href="/ipo/sme/sme-closed-ipo/"
                          >Closed</a
                        ><a
                          class="relative flex flex-shrink-0 items-center whitespace-nowrap border-b-2 border-transparent py-[18px] text-base font-semibold leading-6 -tracking-[0.18px] outline-none transition-colors text-dark-7"
                          aria-selected="false"
                          role="tab"
                          href="/ipo/sme/recently-listed-sme-ipo/"
                          >Listed</a
                        >
                      </div>
                      <div
                        class="flex items-center justify-between gap-5 py-3 md:gap-2 md:py-[9.5px]"
                      >
                        <div class="flex flex-1 items-center gap-4">
                          <div class="xl:hidden"></div>
                          <div
                            class="flex flex-1 items-center rounded-full bg-gray-100 px-3 py-2.5 shadow-sm"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="none"
                              viewBox="0 0 16 17"
                              class="shrink-0"
                              stroke-width="5"
                            >
                              <g
                                stroke="#525252"
                                clip-path="url(#web-ipo-search_svg__a)"
                              >
                                <path
                                  stroke-width="2"
                                  d="M14.667 15.167 10 10.5"
                                ></path>
                                <path
                                  stroke-width="1.333"
                                  d="M11.333 6.834a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"
                                ></path>
                              </g>
                              <defs>
                                <clipPath id="web-ipo-search_svg__a">
                                  <path fill="#fff" d="M0 .5h16v16H0z"></path>
                                </clipPath>
                              </defs></svg
                            ><input
                              type="text"
                              class="inter-display-font ml-1 flex-1 border-none bg-transparent text-sm font-medium text-dark-10 placeholder-dark-7 focus:outline-none focus:ring-0"
                              placeholder="Search IPOs"
                              value=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-4 xl:mt-6">
                      <div class="flex flex-col gap-4">
                        <div class="flex flex-col gap-4 xl:mt-6">
                          <h2
                            class="inter-display-font text-xl font-semibold leading-6 text-dark-10"
                          >
                            Open IPOs
                          </h2>
                          <div class="block xl:hidden">
                            <div class="flex flex-col gap-2">
                              <div
                                class="flex flex-col items-start self-stretch rounded-lg bg-light-10"
                              >
                                <div
                                  class="flex items-center gap-2 self-stretch border-b border-b-light-4 px-4 py-3"
                                >
                                  <div
                                    class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[1px] border-gray-300"
                                  >
                                    <img
                                      alt="ipo logo"
                                      loading="lazy"
                                      width="40"
                                      height="40"
                                      decoding="async"
                                      data-nimg="1"
                                      class="rounded-full"
                                      style="color: transparent"
                                      src="https://assets.upstox.com/content/assets/images/ipo_logo/INE0PQ601019.png"
                                    />
                                  </div>
                                  <div
                                    class="mr-4 flex min-w-[104px] flex-1 items-center gap-4"
                                  >
                                    <div
                                      class="flex w-full flex-col overflow-hidden"
                                    >
                                      <span
                                        class="relative items-baseline text-left align-middle text-dark-1 outline-none text-[14px] leading-[20px] -tracking-[0.09px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap font-semibold"
                                        >Balaji Phosphates IPO</span
                                      ><span
                                        class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] text-dark-2"
                                        >Fertilizers, SME</span
                                      >
                                    </div>
                                  </div>
                                  <div
                                    class="z-[2] flex shrink-0 flex-col items-end"
                                  >
                                    <span
                                      class="relative text-left align-middle outline-none tracking-[0.01px] flex items-center whitespace-nowrap text-xs font-bold text-error-1"
                                      ><p
                                        class="text-stroke-ipo-card font-inter-italic text-[14px] font-bold italic"
                                      >
                                        0.09<!-- -->x
                                      </p></span
                                    >
                                    <p
                                      class="text-stroke-ipo-card font-inter-italic -mt-1 text-[10px] font-bold italic text-dark-2"
                                    >
                                      subscribed
                                    </p>
                                  </div>
                                </div>
                                <div
                                  class="flex flex-col items-center self-stretch p-4"
                                >
                                  <div
                                    class="flex items-center gap-6 self-stretch"
                                  >
                                    <div
                                      class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                    >
                                      <span
                                        class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                        >Open - Close</span
                                      ><span
                                        class="relative inline-flex items-baseline text-left align-middle outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] text-dark-7 whitespace-nowrap"
                                        >28 Feb - 04 Mar</span
                                      >
                                    </div>
                                    <div
                                      class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                    >
                                      <span
                                        class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                        >Issue size</span
                                      ><span
                                        class="relative inline-flex items-baseline text-left align-middle text-dark-1 outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] whitespace-nowrap"
                                        >₹50.00</span
                                      >
                                    </div>
                                    <div
                                      class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                    >
                                      <span
                                        class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                        >Price range</span
                                      ><span
                                        class="relative inline-flex items-baseline text-left align-middle outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] text-dark-7 whitespace-nowrap"
                                        >₹66.00 – ₹70.00</span
                                      >
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="flex justify-between self-stretch rounded-[0px_0px_8px_8px] bg-light-4 p-4"
                                >
                                  <div class="flex items-center">
                                    <div class="flex items-center">
                                      <span
                                        class="relative inline-flex items-baseline whitespace-normal text-left align-middle text-dark-1 outline-none text-[12px] font-bold leading-[16px] tracking-[0.01px]"
                                        >Closes on 4 Mar</span
                                      >
                                    </div>
                                  </div>
                                  <div>
                                    <div class="flex items-center">
                                      <button
                                        class="group cursor-pointer text-sm disabled:cursor-not-allowed text-primary-base disabled:border-primary-base/50 disabled:bg-white disabled:text-primary-base/50 rounded-full active:text-none flex items-center gap-1 p-0 disabled:bg-none"
                                      >
                                        <span
                                          class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-[12px] font-bold leading-[16px] tracking-[0.01px] text-main-2"
                                          >Apply now</span
                                        ><svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          fill="currentColor"
                                          stroke="currentColor"
                                          viewBox="0 0 14 14"
                                          width="14"
                                          height="14"
                                          class="shrink-0 ml-1 mt-1"
                                        >
                                          <path
                                            stroke-width="0.5"
                                            d="m7.433 4.417-3.129-3.13.825-.824L9.666 5 5.13 9.537l-.825-.825 3.13-3.129H.332V4.417z"
                                          ></path>
                                        </svg>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="flex flex-col items-start self-stretch rounded-lg bg-light-10"
                              >
                                <div
                                  class="flex items-center gap-2 self-stretch border-b border-b-light-4 px-4 py-3"
                                >
                                  <div
                                    class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[1px] border-gray-300"
                                  >
                                    <img
                                      alt="ipo logo"
                                      loading="lazy"
                                      width="40"
                                      height="40"
                                      decoding="async"
                                      data-nimg="1"
                                      class="rounded-full"
                                      style="color: transparent"
                                      src="https://assets.upstox.com/content/assets/images/ipo_logo/INE0VNH01014.png"
                                    />
                                  </div>
                                  <div
                                    class="mr-4 flex min-w-[104px] flex-1 items-center gap-4"
                                  >
                                    <div
                                      class="flex w-full flex-col overflow-hidden"
                                    >
                                      <span
                                        class="relative items-baseline text-left align-middle text-dark-1 outline-none text-[14px] leading-[20px] -tracking-[0.09px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap font-semibold"
                                        >NAPS Global India IPO</span
                                      ><span
                                        class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] text-dark-2"
                                        >Textile, SME</span
                                      >
                                    </div>
                                  </div>
                                  <div
                                    class="z-[2] flex shrink-0 flex-col items-end"
                                  >
                                    <span
                                      class="relative text-left align-middle outline-none tracking-[0.01px] flex items-center whitespace-nowrap text-xs font-bold text-error-1"
                                      ><p
                                        class="text-stroke-ipo-card font-inter-italic text-[14px] font-bold italic"
                                      >
                                        0.0<!-- -->x
                                      </p></span
                                    >
                                    <p
                                      class="text-stroke-ipo-card font-inter-italic -mt-1 text-[10px] font-bold italic text-dark-2"
                                    >
                                      subscribed
                                    </p>
                                  </div>
                                </div>
                                <div
                                  class="flex flex-col items-center self-stretch p-4"
                                >
                                  <div
                                    class="flex items-center gap-6 self-stretch"
                                  >
                                    <div
                                      class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                    >
                                      <span
                                        class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                        >Open - Close</span
                                      ><span
                                        class="relative inline-flex items-baseline text-left align-middle outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] text-dark-7 whitespace-nowrap"
                                        >04 Mar - 06 Mar</span
                                      >
                                    </div>
                                    <div
                                      class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                    >
                                      <span
                                        class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                        >Issue size</span
                                      ><span
                                        class="relative inline-flex items-baseline text-left align-middle text-dark-1 outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] whitespace-nowrap"
                                        >₹11.00</span
                                      >
                                    </div>
                                    <div
                                      class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                    >
                                      <span
                                        class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                        >Price range</span
                                      ><span
                                        class="relative inline-flex items-baseline text-left align-middle outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] text-dark-7 whitespace-nowrap"
                                        >₹90.00 – ₹90.00</span
                                      >
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="flex justify-between self-stretch rounded-[0px_0px_8px_8px] bg-light-4 p-4"
                                >
                                  <div class="flex items-center">
                                    <div class="flex items-center">
                                      <span
                                        class="relative inline-flex items-baseline whitespace-normal text-left align-middle text-dark-1 outline-none text-[12px] font-bold leading-[16px] tracking-[0.01px]"
                                        >Opens on 04 Mar</span
                                      >
                                    </div>
                                  </div>
                                  <div>
                                    <div class="flex items-center">
                                      <button
                                        class="group cursor-pointer text-sm disabled:cursor-not-allowed text-primary-base disabled:border-primary-base/50 disabled:bg-white disabled:text-primary-base/50 rounded-full active:text-none flex items-center gap-1 p-0 disabled:bg-none"
                                      >
                                        <span
                                          class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-[12px] font-bold leading-[16px] tracking-[0.01px] text-main-2"
                                          >Pre-apply now</span
                                        ><svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          fill="currentColor"
                                          stroke="currentColor"
                                          viewBox="0 0 14 14"
                                          width="14"
                                          height="14"
                                          class="shrink-0 ml-1 mt-1"
                                        >
                                          <path
                                            stroke-width="0.5"
                                            d="m7.433 4.417-3.129-3.13.825-.824L9.666 5 5.13 9.537l-.825-.825 3.13-3.129H.332V4.417z"
                                          ></path>
                                        </svg>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="hidden xl:block">
                            <div
                              class="table-wrapper no-scrollbar overflow-x-auto"
                            >
                              <table class="min-w-full">
                                <thead>
                                  <tr>
                                    <th
                                      class="bg-light-10 px-4 py-3 text-left cursor-pointer !shadow-none"
                                    >
                                      <div class="flex items-center gap-[2px]">
                                        <span
                                          class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none -tracking-[0.09px] inter-display-font text-sm font-semibold text-dark-10"
                                          >Name</span
                                        ><span
                                          ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="none"
                                            viewBox="0 0 16 17"
                                            class="shrink-0"
                                          >
                                            <mask
                                              id="default-sort_svg__a"
                                              width="16"
                                              height="17"
                                              x="0"
                                              y="0"
                                              maskUnits="userSpaceOnUse"
                                              style="mask-type: alpha"
                                            >
                                              <path
                                                fill="#D9D9D9"
                                                d="M0 .5h16v16H0z"
                                              ></path>
                                            </mask>
                                            <g mask="url(#default-sort_svg__a)">
                                              <path
                                                fill="#111"
                                                d="M5.333 9.167V4.383L3.617 6.1l-.95-.933L6 1.833l3.333 3.334-.95.933-1.716-1.717v4.784zm4.667 6-3.333-3.334.95-.933 1.716 1.717V7.833h1.334v4.784l1.716-1.717.95.933z"
                                              ></path>
                                            </g></svg
                                        ></span>
                                      </div>
                                    </th>
                                    <th
                                      class="bg-light-10 px-4 py-3 text-left cursor-pointer !shadow-none"
                                    >
                                      <div class="flex items-center gap-[2px]">
                                        <span
                                          class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none -tracking-[0.09px] inter-display-font text-sm font-semibold text-primary-accent3"
                                          >Open - Close</span
                                        ><span
                                          ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="none"
                                            viewBox="0 0 16 17"
                                            class="shrink-0"
                                          >
                                            <mask
                                              id="sort-up-arrow_svg__a"
                                              width="16"
                                              height="17"
                                              x="0"
                                              y="0"
                                              maskUnits="userSpaceOnUse"
                                              style="mask-type: alpha"
                                            >
                                              <path
                                                fill="#D9D9D9"
                                                d="M0 .5h16v16H0z"
                                              ></path>
                                            </mask>
                                            <g
                                              mask="url(#sort-up-arrow_svg__a)"
                                            >
                                              <path
                                                fill="#7132B0"
                                                d="M7.333 12.5V6.367l-2.4 2.4L4 7.833l4-4 4 4-.933.934-2.4-2.4V12.5z"
                                              ></path>
                                            </g></svg
                                        ></span>
                                      </div>
                                    </th>
                                    <th
                                      class="bg-light-10 px-4 py-3 text-left cursor-pointer !shadow-none"
                                    >
                                      <div class="flex items-center gap-[2px]">
                                        <span
                                          class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none -tracking-[0.09px] inter-display-font text-sm font-semibold text-dark-10"
                                          >Issue size</span
                                        ><span
                                          ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="none"
                                            viewBox="0 0 16 17"
                                            class="shrink-0"
                                          >
                                            <mask
                                              id="default-sort_svg__a"
                                              width="16"
                                              height="17"
                                              x="0"
                                              y="0"
                                              maskUnits="userSpaceOnUse"
                                              style="mask-type: alpha"
                                            >
                                              <path
                                                fill="#D9D9D9"
                                                d="M0 .5h16v16H0z"
                                              ></path>
                                            </mask>
                                            <g mask="url(#default-sort_svg__a)">
                                              <path
                                                fill="#111"
                                                d="M5.333 9.167V4.383L3.617 6.1l-.95-.933L6 1.833l3.333 3.334-.95.933-1.716-1.717v4.784zm4.667 6-3.333-3.334.95-.933 1.716 1.717V7.833h1.334v4.784l1.716-1.717.95.933z"
                                              ></path>
                                            </g></svg
                                        ></span>
                                      </div>
                                    </th>
                                    <th
                                      class="bg-light-10 px-4 py-3 text-left !shadow-none"
                                    >
                                      <div class="flex items-center gap-[2px]">
                                        <span
                                          class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none -tracking-[0.09px] inter-display-font text-sm font-semibold text-dark-10"
                                          >Price range</span
                                        >
                                      </div>
                                    </th>
                                    <th
                                      class="bg-light-10 px-4 py-3 text-left cursor-pointer !shadow-none"
                                    >
                                      <div class="flex items-center gap-[2px]">
                                        <span
                                          class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none -tracking-[0.09px] inter-display-font text-sm font-semibold text-dark-10"
                                          >Subscription</span
                                        ><span
                                          ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="none"
                                            viewBox="0 0 16 17"
                                            class="shrink-0"
                                          >
                                            <mask
                                              id="default-sort_svg__a"
                                              width="16"
                                              height="17"
                                              x="0"
                                              y="0"
                                              maskUnits="userSpaceOnUse"
                                              style="mask-type: alpha"
                                            >
                                              <path
                                                fill="#D9D9D9"
                                                d="M0 .5h16v16H0z"
                                              ></path>
                                            </mask>
                                            <g mask="url(#default-sort_svg__a)">
                                              <path
                                                fill="#111"
                                                d="M5.333 9.167V4.383L3.617 6.1l-.95-.933L6 1.833l3.333 3.334-.95.933-1.716-1.717v4.784zm4.667 6-3.333-3.334.95-.933 1.716 1.717V7.833h1.334v4.784l1.716-1.717.95.933z"
                                              ></path>
                                            </g></svg
                                        ></span>
                                      </div>
                                    </th>
                                    <th
                                      class="bg-light-10 px-4 py-3 text-left !shadow-none"
                                    >
                                      <div class="flex items-center gap-[2px]">
                                        <span
                                          class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none -tracking-[0.09px] inter-display-font text-sm font-semibold text-dark-10"
                                        ></span>
                                      </div>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr class="cursor-pointer">
                                    <td
                                      data-key="name"
                                      class="px-4 py-3 !shadow-none"
                                    >
                                      <div class="flex max-w-[210px] gap-2">
                                        <div>
                                          <div
                                            class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[1px] border-light-3"
                                          >
                                            <img
                                              alt="ipo logo"
                                              loading="lazy"
                                              width="40"
                                              height="40"
                                              decoding="async"
                                              data-nimg="1"
                                              class="rounded-full"
                                              style="color: transparent"
                                              src="https://assets.upstox.com/content/assets/images/ipo_logo/INE0PQ601019.png"
                                            />
                                          </div>
                                        </div>
                                        <div
                                          class="flex w-full flex-col overflow-hidden"
                                        >
                                          <span
                                            class="relative items-baseline text-left align-middle outline-none not-italic tracking-[-0.14px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-sm font-semibold text-dark-10"
                                            >Balaji Phosphates IPO</span
                                          ><span
                                            class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-xs font-normal not-italic leading-[150%] tracking-[-0.12px] text-dark-7"
                                            >SME, Fertilizers</span
                                          >
                                        </div>
                                      </div>
                                    </td>
                                    <td
                                      data-key="dateRange"
                                      class="px-4 py-3 !shadow-none"
                                    >
                                      <div class="flex flex-col gap-1">
                                        <span
                                          class="text-sm font-normal text-dark-10"
                                          >28 Feb<!-- -->
                                          -<!-- -->
                                          <!-- -->04 Mar</span
                                        >
                                      </div>
                                    </td>
                                    <td
                                      data-key="issueSize"
                                      class="px-4 py-3 !shadow-none"
                                    >
                                      <span
                                        class="text-sm font-normal text-dark-10"
                                        >₹50Cr</span
                                      >
                                    </td>
                                    <td
                                      data-key="priceRange"
                                      class="px-4 py-3 !shadow-none"
                                    >
                                      <div>₹66.00 – ₹70.00</div>
                                    </td>
                                    <td
                                      data-key="subscription"
                                      class="px-4 py-3 !shadow-none"
                                    >
                                      <div
                                        class="flex items-center justify-start gap-1 py-1.5 z-0"
                                      >
                                        <div class="flex flex-col">
                                          <span
                                            class="relative items-baseline whitespace-normal align-middle outline-none font-bold tracking-[0.01px] flex w-full border-r-green-600 text-base leading-[16px] z-0 text-error-1 text-center italic justify-center"
                                            title="0.09x"
                                            ><p
                                              class="text-stroke-ipo-card font-inter-italic text-xs font-bold italic leading-[22.15px]"
                                            >
                                              0.09<!-- -->x
                                            </p></span
                                          >
                                        </div>
                                      </div>
                                    </td>
                                    <td
                                      data-key="apply"
                                      class="px-4 py-3 !shadow-none"
                                    >
                                      <div class="flex items-center">
                                        <button
                                          class="group cursor-pointer text-sm disabled:cursor-not-allowed text-primary-base disabled:border-primary-base/50 disabled:bg-white disabled:text-primary-base/50 rounded-full active:text-none flex items-center gap-1 p-0 disabled:bg-none"
                                        >
                                          <span
                                            class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-[12px] font-bold leading-[16px] tracking-[0.01px] text-main-2"
                                            >Apply now</span
                                          ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="currentColor"
                                            stroke="currentColor"
                                            viewBox="0 0 14 14"
                                            width="14"
                                            height="14"
                                            class="shrink-0 ml-1 mt-1"
                                          >
                                            <path
                                              stroke-width="0.5"
                                              d="m7.433 4.417-3.129-3.13.825-.824L9.666 5 5.13 9.537l-.825-.825 3.13-3.129H.332V4.417z"
                                            ></path>
                                          </svg>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr class="cursor-pointer">
                                    <td
                                      data-key="name"
                                      class="px-4 py-3 !shadow-none"
                                    >
                                      <div class="flex max-w-[210px] gap-2">
                                        <div>
                                          <div
                                            class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[1px] border-light-3"
                                          >
                                            <img
                                              alt="ipo logo"
                                              loading="lazy"
                                              width="40"
                                              height="40"
                                              decoding="async"
                                              data-nimg="1"
                                              class="rounded-full"
                                              style="color: transparent"
                                              src="https://assets.upstox.com/content/assets/images/ipo_logo/INE0VNH01014.png"
                                            />
                                          </div>
                                        </div>
                                        <div
                                          class="flex w-full flex-col overflow-hidden"
                                        >
                                          <span
                                            class="relative items-baseline text-left align-middle outline-none not-italic tracking-[-0.14px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-sm font-semibold text-dark-10"
                                            >NAPS Global India IPO</span
                                          ><span
                                            class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-xs font-normal not-italic leading-[150%] tracking-[-0.12px] text-dark-7"
                                            >SME, Textile</span
                                          >
                                        </div>
                                      </div>
                                    </td>
                                    <td
                                      data-key="dateRange"
                                      class="px-4 py-3 !shadow-none"
                                    >
                                      <div class="flex flex-col gap-1">
                                        <span
                                          class="text-sm font-normal text-dark-10"
                                          >04 Mar<!-- -->
                                          -<!-- -->
                                          <!-- -->06 Mar</span
                                        >
                                      </div>
                                    </td>
                                    <td
                                      data-key="issueSize"
                                      class="px-4 py-3 !shadow-none"
                                    >
                                      <span
                                        class="text-sm font-normal text-dark-10"
                                        >₹11Cr</span
                                      >
                                    </td>
                                    <td
                                      data-key="priceRange"
                                      class="px-4 py-3 !shadow-none"
                                    >
                                      <div>₹90.00 – ₹90.00</div>
                                    </td>
                                    <td
                                      data-key="subscription"
                                      class="px-4 py-3 !shadow-none"
                                    >
                                      <div class="text-start">---</div>
                                    </td>
                                    <td
                                      data-key="apply"
                                      class="px-4 py-3 !shadow-none"
                                    >
                                      <div class="flex items-center">
                                        <button
                                          class="group cursor-pointer text-sm disabled:cursor-not-allowed text-primary-base disabled:border-primary-base/50 disabled:bg-white disabled:text-primary-base/50 rounded-full active:text-none flex items-center gap-1 p-0 disabled:bg-none"
                                        >
                                          <span
                                            class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-[12px] font-bold leading-[16px] tracking-[0.01px] text-main-2"
                                            >Pre-apply now</span
                                          ><svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="currentColor"
                                            stroke="currentColor"
                                            viewBox="0 0 14 14"
                                            width="14"
                                            height="14"
                                            class="shrink-0 ml-1 mt-1"
                                          >
                                            <path
                                              stroke-width="0.5"
                                              d="m7.433 4.417-3.129-3.13.825-.824L9.666 5 5.13 9.537l-.825-.825 3.13-3.129H.332V4.417z"
                                            ></path>
                                          </svg>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div class="flex w-full justify-center xl:hidden">
                          <button
                            class="group cursor-pointer px-4 py-2 text-sm disabled:cursor-not-allowed border border-primary-base text-primary-base hover:bg-primary-light active:bg-primary-base2 active:text-white disabled:border-primary-base/50 disabled:bg-white disabled:text-primary-base/50 rounded-full w-full pt-3 font-bold leading-6"
                          >
                            View more open IPOs
                          </button>
                        </div>
                        <a
                          class="hidden xl:block"
                          href="/ipo/sme/current-sme-ipo/"
                          ><div class="flex items-center gap-[2px]">
                            <span
                              class="text-sm font-bold leading-[18px] text-primary-accent3"
                              >View more open IPOs</span
                            ><svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              fill="none"
                              viewBox="0 0 20 20"
                              class="shrink-0 h-5 w-5"
                            >
                              <mask
                                id="right-purple_svg__a"
                                width="20"
                                height="20"
                                x="0"
                                y="0"
                                maskUnits="userSpaceOnUse"
                                style="mask-type: alpha"
                              >
                                <path fill="#D9D9D9" d="M0 0h20v20H0z"></path>
                              </mask>
                              <g mask="url(#right-purple_svg__a)">
                                <path
                                  fill="#7132B0"
                                  d="M11.665 15 10.5 13.792l2.958-2.959H3.332V9.167h10.125l-2.958-2.959L11.665 5l5 5z"
                                ></path>
                              </g>
                            </svg></div
                        ></a>
                      </div>
                      <hr class="my-8 h-[1px] w-full bg-light-4 xl:hidden" />
                      <div class="mt-8 flex flex-col">
                        <h2
                          class="inter-display-font text-xl font-semibold leading-6 text-dark-10"
                        >
                          Upcoming IPOs
                        </h2>
                        <div class="mt-4">
                          <span
                            class="text-sm font-semibold leading-6 text-dark-7"
                            >Date announced</span
                          >
                          <div class="mt-2">
                            <div class="block xl:hidden"></div>
                            <div class="hidden xl:block"></div>
                            <div class="m-auto w-full text-center">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                width="150"
                                height="150"
                                fill="none"
                                viewBox="0 0 150 150"
                                class="mx-auto pb-6"
                              >
                                <path
                                  fill="url(#empty-state_svg__a)"
                                  d="M0 0h150v150H0z"
                                ></path>
                                <defs>
                                  <pattern
                                    id="empty-state_svg__a"
                                    width="1"
                                    height="1"
                                    patternContentUnits="objectBoundingBox"
                                  >
                                    <use
                                      xlink:href="#empty-state_svg__b"
                                      transform="scale(.00195)"
                                    ></use>
                                  </pattern>
                                  <image
                                    xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAALWHSURBVHgB7Z0JYFTV9cZPSEJCQiDsazW4ICpLxAW0KoHaigqI+q8iasGd1iruS92g1qrVimBdUOpSq0KtCuLaqoBaBdcoWBEVYkVAZAmQkI2Q//3uzJ3ceXkz82YySWYm3699zszLe29eQjLn3LN8R4QQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCSHOTLoQQQghpaQap7Si1bVRbhTQDbYQQQgghLUl7tR2uti5qO1iaCToAhBBCSMvS23peJs0EHQBCCCGkZbEdgDXSTNABIIQQQlqWAv9jtdrWSzNBB4AQQghpOfqrra3/eYk0I3QACCGEkJajv/X8S2lG6AAQQgghLQOq/03+H8V/zRb+B3QACCGEkJbhEOv5cmlm6AAQQgghzQ9W/3b4v0SaGToAhBBCSPOzn/V8ldp2SDNDB4AQQghpXpyr/4+kBaADQAghhDQvyP3n+Z+3yOofZAghhBBCGkOe9by9/zFL6vv72/pfm2Pt1X+LGH9AB4AQQgjxRpHaevmf20a9MWAKIDoAqqWZoQNACCGERKa/BK/cg8jJaS85Wb5AQPvsPP06LwePHf1f7yg7d26TRctecJ4KRwJOQLPXAdABIIQQQsIDIx0Y03v2yVfI8MEj9fPuXft6vsiUaccFnsNB2LkzMPgPDgBUAJttEiBgESAhhBASHhhovbwfOWycjBt1ljb80Rj/ua/Mlh82+YT+unbqJb87b4b9ZTgYh0gzQweAEEIICQ2K+vTqH6v2CcddINGyact6WbjoicDrW6c+LAf2P1SGFY60D0N6oZc0I3QACCGEkND8wjw5bfSFUa36DTP+flMg3I8IgrnGOSdf7Tz0YGlG6AAQQggh7mBV3hVPELZH6D9aUPT331UfiLmGHUHo3rmXnBYcUcBgoGaLAtABIIQQQhoSCP0DhO2jBaH/Oc/+KfB64phfN4ggjCs6S6cWLJotCkAHgBBCCGlIQK3vhBET4xL6x+YkJzdPxqrrWyAK0F+aAToAhBBCSDAF4jfCOvQ/cmK05+uq/1ChfychogBtpYmhA0AIIYQEc7h54ha2jwRC//NeeiDw+rxTrgp7DUQBJo6+0N6FyMMgaWLoABBCCCH1YPUd6Pl3C9uHY2f5Drlh1jmB10gfDCscFfG8E0adJV27BtX/wQFo0igAHQBCCCHER6DwL1LYPhTzXn0oSPDnvF9e7fncSyf+3n5pJIKbDDoAhBBCiI+x5kksof+XljwpL/gFf5DTj7ZzoId6P0ctQJNOCqQDQAghhFih/wP2Hhp16B95/6esvH8sokE435oPsEJtq6QJoQNACCGktRMk9zv1rN9HdbLJ+xvjjbx/tKJBEAyyJgXiQk0+HZAOACGEkNZOIPQfy8p9znN3BuX9Tzv+19Gc7usaeOUBe9citVVJE0MHgBBCSGsmqOo/2pU7+v3Nyt3k/fNy86K6BkL/xoEQ38p/vTQDGUIIIZHJ928F1r5StZX4HwlJRhpV9b981QeOfv+rXaMHOG7j1vUyZO+h0tXxdRQONnfo30AHgBDiRpHaxqttiNoKxWf8QwEHoFhtn6ptsdrmCyGJD9rsYq76R9j+vqduCrzGUB+3wkFECGwn4exfXiXjRpwRuIZdOKhYKM0IUwCEEAOM/M1q2yq+HORU8TkC+R7OK/If/7z//EclOFpASKIRs+CPKfozYfthhSNlwgm/cT32w4/fCHr96DN3yud+iWC7cFB8K/8mbftzwggAIQQGHMZ7mvMLBQUFUlRUJIWFhbLnnnvq1/n5+VJSUqK//umnn+rnixcvluLiYvt6k/0bogEzxRcZICRRgM6/FtlB6P/sk6+K5lyZ9fRNQUV/54y/IuSxXXv0kW/WB3fz/XHOZXLMsJPsvP86acbQvyFNCCGtGWP4g1b5kydPlkmTJmnj7xU4AtOnT9fOgHEQ7C+rbbraHhNCWhbk/RH616v/2dNejCr0b4f0UfQ34+q5Yc9/9Jk/yQtLngp3SYQAEPpv1tU/YAqAkNZJkfjy9veIZfxh8NesWSOPPvpoVMYfIDqA8xYtWqQf8dr+svjSAmvEFxkgpKUIGH/k7WM1/uCSib+PeH7BHgMkAh9KCxh/QAeAkNZFgfjy+9iGBHYqYw3Djc1huKN/A3U+IgjGkQjjCMwQ1gmQ5gVT/gJ5/1B5ezeWFb8ZZPzhPHgZ8pOT1d65C6H+TeIL+y+WJlb7CwcdAEJaB6bA7xPxrf59O1U+/+abb9bGOtoVvxeMI/D88887r1+gtkvF5wiwYJA0B4Mkxrw/qvVnOSr+vToP/fbY37lrs9qeU9uL0oLGH9ABICT1QZ4fhnaaWOH+qVOnauM8bdo0aWrGjx+vowt4PzgFDiZLvSNQJITEHyzDh+JJtGI9MP52tX64in83unfu5dzVpCN+o4EOACGpS5H4Qv0N8vyo2L/nnnt0BKA5MXUCYRwBk56YLITEB1P0l4UXXvL2BmP8TbV+Qd8BctHp0c0JAD26BjkB0ckENiF0AAhJPQrE148PQ1oU2Gnl+YcMGSItie0IzJgxw1knUCQsGCTx41ixiv685O0Bev1vfeiyoHa/6867K2qZXxdapODPDToAhKQOdp5/fGCnP8//ySefNEmevzHA8F966aVeCgZvFtYJkOhB0V8XPMGEvmhC9+j1L1m7Uj+H8UfaINohQQBSv1a/P/II30qCQB0AQlKDyeJiJJHnR46/uUP9jeGxxx6Txx9/XOsJuH1ZfHoCJUJIeA72bzp0P+PauZ5PfPTZP8sLi57Qz1Ez8IdLHpZ+ffeXaEEKYertvzT1A9Vqe1YSKAJAB4CQ5KZIfIa/KGinWulj1Z9oK/5ogAMARwAOgQvYCYXBYiGkIQHjj9X73df+w3Po3tnr/3tl/Af1P1SiBSmEy+881V79v6e25ZJAMAVASHJSID4j2CDPj5Y75PmT2fgD3H+EgkGkOvD9jxdC6kGrX8D4R1Px30Do56zfx2T8gS0XLL7e/4Qy/oARAEKSC6Pbf6lYlf0I8SPcj3x6MoX7owHywiY9QKlhEgK02E02L+5SK/+9+/b3dKLT+EfT6x/hWlvU9k9JQBgBICR5wEoXq95pYhl/rI5R4Jdsuf5oQXQD36OHgsHJwoLB1kqW/WLTlrWeToqn8V+07AX7Wkj+vyYJCh0AQhKfIvGFutHaVxDYqULkIXT3Ux5bahiTCi0KxOcILBIqDLZGquwXa75bGfGEeBp/FP3NefZP5iWK/lpkyI9X6AAQkrhgOQ+9/AZ5foTCUyHP31hM9AM/C6gNWhRIsMJggZDWAIzuJvNi9fqvwh7sWK032vjbioHi0/lPWOMP6AAQkniYfn4Yr0sDO61+fozqJfXAEULxYwSp4SBHiqQcef6t2uxonxW6+A/Gf9YTsen7O0HFv60YKL6ivxJJcFgESEhiUSQuK1asbl0U80gIUCQ4ffp03UrIgsGUpb9/g9BPlvOL4cR74mn8wWW3TwiIBonP+H8kSQAdAEISAySyEe4vsnemQj9/SwLjDycAzkAYR2C+2kqFJAuo9P+F2nrbOyHYk6NW/Kj6L+i7n5xQdJZr+x+U+eY8c2fgdWONPxwJOBR+MN1vsSQJdAAIaVlMuP/SoJ3+cD/a+kh8QN1EGEdgsVBhMBkwg30C2v6jho3zLNEbz4I/YCsGiu9351+SRNABIKTlQD//NGll/fwtjYkIUGo46dhPbcPVloXV/mmjL5Rxo87yfHK8jb9Lrz8q/qskiaADQEjzUyQueX6jfMc8f/Ng6gTCSA0/LkkUzk1xMNQHCn86t/+7C++OSpufxt8dOgCENB8F4jP8RfZO9LGjwI95/pbBOALz58+X0tIGpQCYNYCZA48JaQkQ8sc4Xz3R74C9h8q1F8yMaiRvE4f9k9b4AzoAhDQ9zPMnAR4LBh8T0lz0El+xn67wP/vkK6IK+QNHgV68C/7Wqe3fkqTGH9ABIKRpaZDnB8bwM8+fmEQoGHxMfOmBEiFNBfL9I/AEIf9oh/KgL//Wv14u/131QWBfLA5EmOslVbV/KOgAENI0FKntHrUNCdrJPH9SYYYPsWCwWUGuHzn/sL38oYAi360PXWb35WsHYuSwcRILRuHPIfKTFH3+kaADQEh8KRCXPD8MPgw/8/zJSXFxscycOZMFg00Pwv5o84vZ+NvGGt0Cf7jk4agKBm3WrP1C7phzuW3835MEHOsbK3QACIkPIcf0Ms+fOkToHFgsPkfgMSGxENTj/3tluKMJ+y9X4fnb51wW0OKPxYGwcQgGQV4YU/3WSwpBB4CQxuOa50c/f6qP6G2twBEw6QEWDMaNIvFJ++pwPcL2XnGq+zXG+CPfP+/Vh+xKf3gUCT3VL1boABASO0Xiq+4vCtqpwvz33HOPDBkyREjqE6FgEHUgC4R1ApHA6n+ieTF72ouejbejLS+mVkGDS/0Aiv0Q9k/aSv9w0AEgJHoKxKfbHzx/lnn+Vg0LBhtFkcSw+r9+1vlBlf4njJgo5/3yaokFtPfNefZP9jjflMr3u8FxwIR4x/TzfyKW8Td5foyipfFvvWAM8aJFi/QWZiRxAwVIoulsngzqf4inE1Cg52zzi8X4I+SPKAJ6/P3GH/95VlLc+IN0IYR4YbLaXlHbaLVlm53I80NBbvTo0UIIQCQI45vhBGzbtk13EFhg6iMqQovUtk1tK4WAo8yTE4omSo8ufSKe0KlDN6ko3y7pGZly3YV3y/AhP5NoQeHgH2b/Rj7+73/MrhVqe0NSMN/vBlMAhISnSELk+Tmml3gBtQGoCVmwYAELBt1Bsv508+KSidNk5BHjpalxSASjyh8h/y+lFcEUACHuFIjvQ3mRWMYfq7vnn39eh3lp/IkX8DsDBwApIhcRKLxAWgDpgcnSOtMDWG1XmxfffL9KmhIU+qF2wDL+kPRFyL9VGX/ACAAhwYTs5+eYXhIvInQOLJbWVzA4Rm298QTiPTOvnitdY+zfDwfaBZ9Sht+f64fTAUW/lM/1h4IOACH1IO6I6v4CeydyuZjWR8NP4g06BqAwiDoSFx6T1uMIBBQAQUHfAfL7ix+OqZXPDeT6H3nuz3Z7H1b9S6SV5PpDQQeAEOb5SQvjQWFwuqS+1DD0/weZFz069ZKLohwCZIPq/kUfviDvfrrY7hZo9at+GzoApDWDJT2EWibZO5GjhYLfpEmThJDmxDgCiAy00oLBg/1bgAOUA3DMsLEyaO+hYdMCMPjrt66Vld98rI1+ydov7J5+GH4YfVT5p6SoTyzQASCtEeb5SUID4w8nIEydABwB5A1KJfWAIBDEANo7v4D6gAL/YB9ECMqqdki5MvIbt6yVTZsayPTD6G8S34o/pTT84wUdANLaKBIXMRb0bSPPzzG9JNFoxQWDqAvYT3zFge09ngODv0F8OX4Yfa72CSFagAUtfXX2pvL7dYsWLaojJNHB7yl+X52/w/4t1RUGs8TnEBSIL0Jgb9gXn2pBQkhKgVg+KvuDPjBViL9OrazqCEk21qxZUzd58uRwjkCREEJIKweV/VvFYfhvvvnmuq1bt9YRkswYRwC/09LQEcC8islCCCGtjCLxKas1CPfjQ5OQVAK/0zNmzKgrKChwcwSMwiAhhKQ0BcI8P2nFPProo+EcgZuFkwgJISlGyDw/VkaEtDbgCLTigkFCSCsB/fxBeX5szPMT4uscYMEgISTVKFIbBq0zz09IBCJ0DiBtNllIq4NCQCTZKBCXlQsEfDBqlbr9hIQGYkIQFnr88cdbq9QwISQJQZ4fRUzM8xMSByIUDCK1ViCEENLCuOb5p06dyjw/IY0kTMEg/uZYMJjCMAVAEpkiCTGmF+F+6vYTEj8wfAipgRAjibEzVWcOEEISiAJx6edHuJL9/IQ0LR4KBouEpATpQkjigDz/NeJbbQwI7MzPl2uuuUbmz5/PVT8hTQz+3jAdUzkBsm3bNiktLdWbnwLxdQxg2ya+ThxCCGkUk4V5fkISDvz9RSgYxN9ugRBCSJQUCeV7CUkKIjgCLBhMMlgESFqKArVNU9ukoJ3s5yck4UHB4PTp0/WjC48JCwaTAjoApLlBnh9tfZf6n/t2qryjCvfLpZdeqp8TQhIfiAnBEQjROTBfbTPVtlhIQkIHgDQnk8VlIhmKjWbMmEHDT0iSYhwBRARcFAYfU9tlaisVklDQASDNQZGE6Oe/+eabGe4nJEWA8TfpAYcjcI/4nACSQNABIE0JlvT4w2+Q58eKH61GhJDUY8GCBW5/39PEVxtAEoQ2Qkj8Mbr9qAwOGH+E+LHi/+STT2j8CUlhiotd5QGmia/jp0AIISlJkfgMf1CbEJTFOKaXkNQGrbuFhYUN2gQPG1zkbBksENLiMAJA4kWR+Lz7IA8f+X31oUDtfkJSGCgFXnbZZTJy5Mig1X/3Lr3llkseluvOnyGnHXeh2V0gvs8JVv22MKwBII3FhPsvDdqpwv333HOPTJo0SQghqcvMmTNl2rRptlyw5ObkyZgRE2XC8VOCjn1z2Qty799vNi8Xq22kkBaDswBIY8Bf8lyxqvuNbv/cuXNl+PDhQghJTT799FM5/fTT5cEHH5TKysrA/gP3PVhu+s19MmxwQ9ver+9++vHzrz/CQ4H45gksFdIiMAJAYqFIXGQ/UdiH6n6G+glJXbDSN6t+G4T7Lz5jugzc95CI17j94ctl2WeL9OXUdpBQNbBFoANAoqFQbTOE/fyEtErQ43/22Wc3EPtBfn/syDMkt12ep+uUV+yQC28+QT8KUwEtBosAiReQ54fh/0Qc4X6s+FHkR+NPSOoCg48CP2y28Ue4/+5r5+pcv1fjD3DsmJETzcsicSwqSPNAB4BEArr9aNsJKvLDin/NmjVau58QkrpA1e+ggw4KGvyDIr9zTr5S/nDJHOnXZz+JhbFFQREDCoO0AEwBkFAUiUueHyt9tvQRkvqECvePLZoop0W54g/F3FcelHkvz8ZT1AL0E84LaFYYASA2toJfUD9/YWGhDvVjo/EnJHVBkR8MvzPcjwp+9PSfc8pVcTH+AFEAP/jsYRSgmaEDQAwm1D9NLMNv8vyQ72Wen5DUBtX9/fr1Cxrva8L9d18z11OFfzTAkbCuOUJIs5IhpLVTIL5Qf5HzC1OnTtWtPhzTS0hqYyb42Xl+cNjgkXLuKVdK9869palAIeGKrz7EU0QAzhbSbNABaN1g1T9NHJKczPMT0jpAuB+GH6qdNtH09DeWgfscIvNE1wHgc6hAqAnQbNABaJ249vPD4MPwM9RPSOozf/58rd/f2J7+xmLUAf0Uqe0xIc0CHYDWBTxss+qv36lC/CbcTwhJbWDwUeTnDPcjFH/Jmb9v0nC/G3A0unfuJRu3rMfLAiHNBh2A1gPya8j1B4X7mecnpHVgJHwR7ncO7jnn5Ktk1LCxEi0rvv5QXlz0lKz5/kttyKEJgAgCUgjR0K/vAOMA7Cmk2aADkPq4TutDmB8fBEOGDBFCSGoT757+8p07ZN6rs2XhoieD9q9Z+6We+Ddq2LioHIGcnPbmaYGQZoMOQGpTII5+fqz0oeJHBT9CUh/T0498vw3C/ROOmxJ1kR9W/BDugaH36/i7AicAlf2jho+TkYeNjegIWGmHAiHNBh2A1GaaOP6gsBLgqp+Q1MdM7HOG+08b7SvyiwZj+P3tekF076Ly95vXN9i/ccs6mfvyg/Lm0he0I4CIQCiaq+CQBEMHIHUpUNskewdW/jT+hKQ24Xr6LzlzelTGduPmdfLIc3eZ0b1B2K2CMPbzYOyXLWx4DcsRQLrBrdaADkDLwFkAqQsae6faOzC8h739hKQm8ezpR47/xSVP6Ry/W6gf14QssLNjIJwjYEDb37Xn3R2UFkDK4N6/o1RJawD0E9Is0AFIXeCyF9k76urqhBCSekC6Fz39znD/mBETo+7px2r/kWfv0sbcjVDG3yaSIwBnBNcw0AFoGZgCSF0KnDsQEqTIDyGpQzx7+sPl+Q1ejL8+Tn39YvX+ue06yMLFTzZ8L/UecBKaW3OABEMHoBWBoiA6AIQkP6an3yneBQONwT3DVL7fK6Fa+px4Nf4GrP7djL9BdwkMGyek5eA0wNSlgbIPWoGQIySEJC9Y7R900EENjD96+jGxLxrjP++V2XLhtBPibvwRTbj37zcFXj///POydevWIMGxku+/FNKyMAKQurhK++FDA2FDdASwIJCQ5CFcuP/cU67SKnxe0Qb6iZtD5vltUEsQjfGHRsDtD10eeI35IuPHj9fPCwsLA/dftrNMSMvCCEAr4GJH6w8KhkaOHKmjAU5lMEJI4oFwP1b9tvH3SfheKX+4ZI5n44+2vhtnnS83zjy/SYw/rn/7w5cHOgew0Jg8ebKQxIQRgFYA8myourWrcmH4EQ2AM4A/0EmTJjEiQEiCAYOP6v7i4uKg/SPV3/S5p1wZVXX/wsVP6c+AcAp+Nsb4R+tcGMcCxj/cgDEICJGWhRGAVoKpyp09/aUgIQ7jCCAi8PjjjwshpOVBkR8MP/4ubeNvcvHRCPog3A/D/Mizd3o2/gDaAU1l/AHFf1oeOgCtDOMI3H3tXJ07NMARQCSgX79+dAQIaUEQ7sffoS3ooyV8j7tQZk97ybOgD6r7oeKHcH+41j43YPy9FhPifRD2N8Yf0UQvo8XZAtjy0AFopcCzR+4Qqwk6AoS0PJ9++qle8WNQly3og79PVPdPOH6K52th1X/5HRMiVve7gboCaPd75d4nb9bjgAHajJFW9AIjAC0PHYDUpMDrgVhNwBG49vxgaU46AoQ0Dybcb1fIAxPux99ntEV4Xov8nEw4LrpBQfacANw/2v1I8kAHIMXx+sGBcB/Ci+gYoCNASPNgevqd+v0I92PVH41+P4r8sOp3G9zjBRj/06KIMsx9pV48CAXEMP52nz9JfOgAkCDQMUBHgJCmBX9PCPdjs1txdbj/Wl+432uIHH33sRT52cRi/NFRAGD8Fy1axC6iJIQOAHHFiyPgFCQhhEQG+hvx6OnXEr7KEGPVH22Rn020xt+0EwIa/+SGOgAkLHAEsGFaFz5skGMEZgWDoh+0/HDGACHhgcGHkp9TfAsSvqdFseIH0Sj5hSNa4w8dEUQaAML9kBen8U9e6AAQT4RyBPChZqYMQvKTHwaEBGOK/JzV8f367qdX/dHk+U1rH/4OGwv0QKIx/kg1GOMP8Pc+ZMgQIckLHYDUpECaiHCOANICSA9wzgAhPszEPrutT/f0j46u2h5Eq+QXDhh/6IF4xQj9mPeeMWNGQN+fJC+sAUhxmkpuE04AWpRQrWzXCGCVA0fALdRJSGsBDrFbT/9hg0fq6v5ojL8xvo0p8rPBPTTG+MPBx/dFkh86ACRm0GKIamU6AoT4sCV83Xr6r4PeRhQKePEo8rNB2gEywl6JReKXJA90AEijsR0Be84AoCNAWgsoiHP29BsJ32h7+lHkd+HNJ8jcOIX8AYw//ka9Fhui3sA2/lOnTqXxTzHoAJC4EWrgEKAjQFIV0xFz0kknNezpvya6nn5bv7+xFf42iEBA7TOaTgPb+EPf3ylWRJIfOgAk7tARIK0BhPtD9fTj9z8aCV8ABb8Lp50Qk35/OEz6IZp7sfX9IfHrVd+fJBd0AEiT4cURwAcoHQGSbBgJX2eFP3r6IaDl/H0Ph8mzQ8M/XuF+QyzGHyp/by71tRkaoR+SmtABSE0KJIEI5wjgAxThUzoCJBnA7yhC/W4SvjC055xyVVRh9ngX+dnEavydKn/U909d6ACkON0695FEIZQjgA9S2xEgJBFBTz9W/Sj2M9gSvtEW+V1++4S4FvnZxMv4U88jtaEDQJod2xEYNrgosN84Ahw4RBKJcD39CPdH09NvF/mZHHu8gVMSrfGHxK8x/ljx0/i3DugAkBYDH1DXnj9Df1ghhGrg5EGSCHjp6Y9Wvx/h/ngX+dnEYvz1XIG/3xR4je+Vxr91QAeAtDgInSKEig8u9Cob6AiQlsIUqcajp98U+cW7tc+JMf5epwkC6Pvf/tDlgdfU929d0AEgCQM+VPHhGm4EMR0B0pSYnn60qdrh/lh6+gH0+5uqyM/JxWdMj8r4wzGxOw+g8oe/M9J6oAOQmhRIEoM5A8it0hEgzYXp6cfvljPcDwGdaHv6sbKOp35/JGD8hw0e6fl4SvwSQAcgxWmqYUDNAR0B0hzYPf026OnHqj8aw2qK/Jpr1Q/QhTBq+DjPx9P4EwMdAJLwRHIEnEVahHjBhPvdevrvvnZu1D39zVHk52TCcRdG3YWAsL8t8Uvj33rJEEKSBDgC2N5c9oIWUMFKBsD4YysqKtKrGTwSEg6E+1HgZ+f5dZHf6OgMKoBRhXQupHybExj/046fEtU5tsTv+PHjKfHbyqEDQJKOSI4AogJwBNjKRJzg9wOtfcXFxUH7Ee4/LcoCP4Aiv3lNJOYTjliMP1ITxkmBvj8q/knrhikAkrSY1ABas+zUAAcOESd2T79t/E1Pf7ThfpNHb64iP5tYjD9U/kxqAo7x888/T4lfQgcgRWlVf9lozcKHOB0B4gYkfEP19MOBjKanH+F+RJ0wta+5ivxsYjX+lPglbtABSE0CDkC0Ic1kBS1atiNgQ0egdfLpp5+6SvjaPf3RYIr85vqNaXOD+RnRGn+TogA0/sQJHYAUp7U4AAbjCIQbQUxHILUx4X7kud0kfKPt6bf1+5tSyS8c+F3G/IxogL4/UhQA4X4MMaLxJzZ0AEhKEm4EMR2B1MX09NvhfhCLhC/AChrh/uZs7XOCoUPRGn8IEdn6/pT4JW7QASApDR2B1kGknv5oJXxbssjPBrMxLjkzuhHZ5t4NMP5o+SPECR0A0iqI5AjAcKA3nI5A8oF/N6z67XA/ivygkIdwfzT6+ABFfs2p5BcKGH+kLGJxXKjvT7xAHQDSqjCOAIqpUByFPCmA4YciGpwBfGBCIY350sQGBt8tehNrT78ei/vEzS2W57cxMwhiMf6U+CVeoQOQmuwpJCxeHAE8whEgiYUp8nOq2GHFjFV/tHl+3dr36uwWzfPbmGLFaAsVafzjz6JFi3pKfVdVJTYVLdwgKQIdgBQnmg+R1ojtCMz6+03y+Vcf6f1mzgA+ROkIJA7o6ce/RzwkfAGU8e79+80tmue3icX4A9v4U9+/cSijX5CVlTWgtra2UL3Mdn79nXfeKW3Tpk1JVVXVYuUMlEoSwxoAQsTnCCBfjA9fFI4ZOHkwMUC4362nHxXyqO6P1vibcDkG4yS78bf1/dH6SH3/2IDhf+uttyZnZGRMVsZ/uLgYf1BXV5cP50Add+nbb79dJEkMHQBCLBA+hiOA/CtHELc8toSvW0//dfh3itJgorUvEYr8bGI1/lD5e3PpC/q5Efoh0WEb/rS0tAKJjiIVERguSQpTAIS4gBnw2JwDh5gaaD4gXIMiP2e4f8yIiXrFH0uR3yP/vCuwWk4U8D3FavydKn/U9/fOf/7zn0Ks5GMw+kGoiECRelgqSQgdAELCEGryIB2BpgM/Wxh+e8UPkJq55MzfR20oE63Izyaexp9dK5FRP6dstdLHin347t27s5Xxl9YMHYDUhMuAOOPFEYDgSlFRkZDYwEofRX5Q8XOu+s85+aoG+g1eSKTWPifG+EerU2Dr+2PFT+MfGdvwS4jcfiNIytU/oAOQmtQPA8ppXbMAmppwjgDy1HAA0IJFRyA64t3Tj38XFMclUp7fycVnTI/a+KNrwej7A/zcaPzDo4x/fmZm5mQU70l8qVQRhMVHHnkkHQCSmLS2YUDNRShHAB/I2OAAICLAD+fwwOCjyA/5fhuE+yccNyXqnn5gVsiJUt3vBow/akyiwafvf3PgNfX9vaGM/4Q4G3/oASzdtWvXUuX0V0oSQweAkEYQzhFAxwDSA4gI0BFoSLx7+mEgMbUvkVf9AGJFo4aPi+oc/F7ZLYszZsygxK9HlPHvKXFArfZL1bWKU8HwG+gAEBIH4ARgtYqWrEXvLww4AujJNvLCdAR8wDmCfr+zyG+k+hmee8qVUUetErnIz8mE4y6MWbPAVvmDHgLxBkR7du/eXSAxoox+SW1tLYz+Skkx6AAQEidQyY2pc1jd0RFoCFb6MPzOUb3ogUdIPJZwfyIX+TmB8Uc9QzRQ37/xVFdXz4+lBsBv+KH2VyIpCoWAUhN2AbQgxhFAhTdHEPsw37dt/HW4XxlFKPnFot+PkPiNM89PWeNvvkfz/U2dOpXGPwYg11tTU/MYwvdejofhV2H+x44++ujHUtn4A0YAUhM6AAlAqIFDoLVEBOLd0w+SocjPJhbjD2yJ3/HjxzeInBDv+DX75y9atGixeixIT08foB6zERVQuX3k80vVar9EPRanSn7fC3QAUhwOA2p5WqMjYHr6nStWhPtRBBdtBTxIhtY+J40x/mj5A9D3R8U/aTx+R6DYv7V6mAIgpJkwjsDs6S+FTA0gR57sqQGs9g866KAGxh89/Qj3R2v8dZHfK7PlwmknJJXxx79xLMbfqe///PPPU+KXNAl0AAhpZsI5AjCaEBRKRkfAiCFhs+8d4f67r50r55xyVUz6/RjcM9evfJcs4N8V/8bRQolf0pzQASCkhQjlCMB42o5AMoD7xKrfzvX7JHyv1NMVo1W8w6ofPf3JUuRngxHFNP4kGaADQEgLE8kRSOQRxHa43xb0Qbh/9rSXYhL0gagSwv3J0NfvpF/f/eSSM6N32lAXYuv7QxmRxp80NXQAUg8mC5MU4wigfRBhc4MZOJRIjgCMPSR8EaUoLq6vpzJz7WMJ95ued8jdJkuFvw2MP773aL9vn8TvTYHXyPlT4pc0B+wCSD3qBwFxDkBSgp74P+w7Rxe8IQwOAwESZQRxKAnfMSMmav2DWECRH1b8yWj4ARyfa8+/O2anx9ASEyXx74hIzrfffhvkzCECMWLECN2FwCLE1IQRgBSGDkByA0cAVfMXq5AyDIyhpSICn376qV7xQ4bWNv66yE/dZyzGXxf53e4r8ktm44+Vf7Qtt8b4m+8bbaDNpe9v2jTx79mrZ1/54+/+Ii8/vUwq13YMbO++8qVcfN51+uutTbiqtUAHgJAEB3MGkE9vKUfAhPuxErSL/IzhQ5FftMbPLvIzYjfJSGONf3NL/Bo55gMGDJTnHntTDuj8c7n1gqdkwjGXyLGHTZBBew2Tdlm5UlFdLpVV5dKubY4ctv/P5F8vLtG/Z/g9sJ0/ktwwBUBIkhBq8mBTpgZQjIYPfefq7zT/UJtYokwQuEnWPL9NrMYfzk9LGH+Tuhm233Fy0Yl3akMPYOiXr14mH3zxhmwuX6tTEAeNKpQ99/yp/vq2bdvUv/9e2vmDGiF+J9ihkBrQASAkyYjkCOBDGuNiG5NLbgoJ32RU8gtFvIw/nLWmNv7m3/K7rzfLRePvlM553QNfe6v4BfnX+3Nl2OGHypy/3xvxdwbXQgQBqYOWrEMh8YEOQOrBap1WQihHAIVc+IDGhzkcgmg+pGHwFyxYoJUJnUV+p42+MKa2PpBs+v3hwM8iFuMPHnn+rkDKAykV/JybEvx7Tpxwpl71jz3pssD+r79fIfNenymDhx4g/125wvNqHsehUNGIPuEREQySnNABSD3quwByWATYGgjlCODDHxuK9mBs4BDsueeeQR/2+ABHiBdOA0K7bvld9PRD0jaWcD+K/B75511Jnee3aZTxf+6uIIlfhNGbEqzUZ959v5x9wu+kT9d+gf3z35oj321bLs8umBdzlAj3/8knn2gnANAJSE7oAKQwue3aC2k92I7AwsVPSsnaVXq/afNyhvPDYdr6Rg0fF5Ox0/r9r85OSjGfUBjjH62qIZj7Sv3Pwhj/pmytg/F/6C+Py29OvjUQ8t+6faM8+tIf5ZgTjpYX7vmk0e+P8/F90AlIXugAEJJiGEcAeWbk21F0h+c/blmvDbMb3bv0kgJl2Abue6gycP11C2KsYNV/7xM3J52EbyQuPmN6zMa/OSV+beNvCv1g/O9//nq5cfp1OiIUL4wTADVIaAY0t4YBaRx0AAhJUbByN86AATl4OAQmVYCw/t//9JbEA1wPYW4zxjaVgPGPZYSxqX0Axlg2t/Fft2mNPPXmnfLnmXeE1RlApAib6fjA/SJ1FAkch7oAFBoiLUDRoOSBOgCEtCJg8OEQGKlhOATxqMqHocPUvlQ0/hhohFRItOBn8cizd+rnMIpIwbSU8X/ltZdcjb8tCNSpUyfd628mOmJVj30nnXRSxPQRVv7jx4/X1yLJAx0AQlo5jQnVG0EbGLpUqPB3MuG42DoffPr+9TlxtGU2pb4/DK8u+Bvzu6CwP3L+MP7O9zaCQDD4SAmEMvA4DsWhcAjgCIRTA0QNgLN7hCQ2dABSjwIhpBmAkcOq30QQuub30FuqAON/WgzyxnCKbn/48oBDBOPflBK/ujf/pj82KPhDzh9hf6fxh7MAw++c5xAJ4wjY8wJsEOXA98koQPLAGoAUJoezAEgTYevYZ2a0lYF7Hyw/6bGX/trOynL58tvP5LsfVkuy0hjj71T5i2fRnRPTj3/6MVODBH6w8r/4sl8HOR4w9sjTw5A39v1Qy+BWHwDNCaQO2BGQHDACkMLktusghMQbp/E/YsgxAeMPcrJz5aD9DpdjDhsftD9ZiKfxb2qVP8g079fjcNm7z8DAvteWPS3/d8a4oPeG4YZhbozxN8CROH70GNd0AGocnDMjSOJCB4AQEhW6g8Bv5GD8O+Z2cj3OOAI4Jic7OTQpYjX+aK9E2N/8XKZOndrkxh+h9uUffiO/OGxCYN8HX7wpqzYubWD8sWpHkd7zzz8va9askbq6Or1t3bpVr+YRKYimQDGttq2OJriB94GaJEl86AAQQjwDkSFsYL89B4c0/jZdO/ZQ0YATtTOQyI7AqGFjYzL+4PY5lwfUDmEAMY+hKTF5f0zxMyDv/6/3nw4SGTLGH9EI1CLg3mxDj+NQwY82PpznNXRfWV0u3321yTXfjzRAU0sck/hAB4AQ4pl5L8/WjzDk++05KJpTdTogUR0BGP+Lz/y9xII94AjhbxjTpgYV+ccednpQ3v+19+dqoR9j4G3j76UIEechcoBe/kjRgC3K2Ri493DXQkI4FTg/VLEgSRzoAKQeVOEgTQIU/kyIu3+Uxt/GOAJwIBLBEThs8MiYjT9U/mx9f4TYm1oIB6vrXTuy5dD9RwX2IfSf26M2UHAIowzjj1REtB0IcGK8SBWv+3G1dMntK48//niDryGqsGTJEiGJDR2A1CPwV9s+h7MASPxYtHShfoTR3iMOxX1IIRwx+JgWLRTs13c/ueTM6RILzS3xC8w43hOPOjewz4T+7cgDigMRio+1A8E4M+FYsXqZHF04zrWwEK2HjAAkPnQAUotstfU0L9gGSOKJCXPH02C3ZMcAjD+G+8Qy5bAljD+A8UfVvzP0j5Y/8/44Bo5CY4sQsYoP50BUVJVr0aFl733QoCMA59IBSHzoAKQAdXV12Vu3bi06+uijL01PT49+WgkhEYDojwn/d83vLvHGdgR6dv2JNDXdu/SWa8+/Oybj/+ayhUH6/lgBN4fxh5Fd8NzLcogV+sfq/8eKbwLGHscgRRCvOgTUD4RLBXz9/Qp1Pz9rUPWPn0c41UCSGNABSHKU8S9QD1PUH2nRwoULszmNizQF5ZX1Mr9eKv9jBY7AYQcc3eStg1j5xzLm2Cfxe1PgNfrdm1Li1wYre2fh3/y35wSt9JH3x2uvDgmMNCr50dKHtAHy+bbhhvEPFwVY9+MaGbTXMNc0AM6lE5DY0AFIUmD41TZZPcWmXfQOHTpI586dhZB4A5EbQ0ZGW2lqmrJ1cOSwcTEZfyP0Y8Aqu7mMv1n924V/WH2X7f5B5/oBHAQsAMzrcHz66afaWfjpYT+T5x57U9Z9USULn3ldFwyagUDoNIBDgELCUFGAdZtWS++u/VzD/XBCOBcgsaEDkGQg3K+20eIz/AVCSArTFK2DE46/UKLFVj8EXlvr4oVZ/dv8a9nTDUL/Xvr4seI/ZcxZckDnn8sVE2bIgWoF/83a5fKTfbtq/QIU/+E66AbA9aEgGCqyiHZAkLY7q8FqHw7At99+KyRx4SyAJEF92GSfe+65w6urq4e3adMmW22Czcm6devYBkhSDjgCXVRU4LsfvpFvvv9Sdu2qlliIdfVvqx82h8SvDcLrWP3fMOnhwD6s/mszy4JW/1ipRwr9I9S/Xq32f3PSH/Trt4pfkG3p38icv9/bwMjjNb5XpAbCCRtVVJdrKWJEFZzvzwhAYsMIQBLQtm3bAU8++eSU4447rkh9GKDS39X4O4nlg46QRAX1AWgdLBp6fMwdA2NHTpRosdUPsepvTuMPYIAjrf5RixCp5Q/Gv2ptx4B08Py35kjhqL66gyFc7RAUBMNdG4WInTt0d40AkMSGEYAEBnn+DRs2FKkPgILXX39dh+S6d/cVAO3evduTE0BIqmE6BuAMRDN1EJX//fpE3yRj1A9h0Jp7yh3C+tu27AzK/cPg2qt/GPZITgkiBKWrM+SoIb7rYGDQqPFDG8wMQDU/Vu3I+Z944okBI47vG5EIt6I+tAOiMNHtaywCTGxoQRIQf55/vHo6WRn8gieeeEK+++47nZs7+uijJSMjg8aftAiZzVAA6BW7dbBrfo+Ixxf06S/RgpW/Cf1HU10fL2C497Em/QH0/RvDjZU/jGy4wj84Ee+98qUy/mN95yvjf/hx+wVFEFD0h+I/Y7Bh7PEa7w/gEIRqLTR6AAz3Jx+MACQQMPzqYbh/C4T6scHoE9LSZGZkSqIBRwCKgogEfPntctlZWeZ6XI8uMeT+rdW/l+r6eALDDYN8xuTrA/uw+v9q/Udqdf5P/RpV+uFW/zj/L3f9VSaOukq/Ru3A/of3CJyDvD3C/8Z4I9wPzIof0QUYf9QX4Dg8dzP02coB+IKr/aSDy8gEQRn/AeoBo8iKxG/8CSHeidQxEK0ypj37oLnz/gCr7737Dgrq+4cBx0Q/02OPCEA4x+S6a26Q0Yf6vg7nYdnXC4KMP3L7ofL/ZnywPfCnOTsfSNNDB6CFUX98BSq0NrmysnLCrl27Gl3Bv3HjRnYBkLhjDGEyEK/WQTP7AIwYMUKaE7P6P3TAqKD90PzHahzAQQjnmOAaW7/dHXAgkDp4dsG8gPMA4x9peBGcAzgCZuxvKGchR0UA3GjqwUikcdABaCHUH2724YcfPr66unryFVdcUXDXXXfpUD+K+7yCY8Mdn8tZAKQVA0egMfMF7BG/LZH7R17dLv5bt2mNdOico+8HYPUfzjGZdfcDgYp/rP4PHPaTwPeB0D5y+l4MNCIMRukv1PvtrCpvsM8UE5LEhYnlZgZ5frXaH15bWzt80KBB2f/+97/lmGOOCbTZeC3uU9GCwCPOadu2YXEWHQBCYsOefdDcxt8U9tnGH7xVvDCw4sfqHqvxUPeGr2NokAGr/3+8PEc/96oZYMD74H6MQXfWAaAFsM7lPDoAiQ8dgGZEGf9CtWIvUsZa/1UgtDZu3DgJJerjBKt9GHzlQMgjjzwi7733npb+veiii2TAgAHsDCAkTtgpD7Pibi5Q2AcG7jU8aP833y8PrMBxTLiWRKz+zyzyFQ/aq38YcmzRtjPiswrn4WcRqhDQCY7v2LGjkMSFDkAz4B/YU6S2AhPmt421V8Ntznv//fflqquuCuxTeX958sknXaMAhJDoaamaByPpi/D/wL2GBfaj+G/w0AOCjHiofDwiCOFW/7FoGeB9UTRo0iF2f38nFQHAUCA3FUBGABIbOgBNiDL8+O0vUlvQEgKreGOso1m1oxUQ544aNUoeeOABHQGAMBBydNQGICR+GM3/5gbGG+zdZ1DQ/hWrl8kpk8cHjgmn3IfowN59f6qfO1f/IJaURrgVP4oMv1m7Qno6jL2JGJDEhRajacju2bNn0e9+97spq1evLrQL9aIp8nPDGHq048AJuOWWW3T4nzoBpDloyhG9RALV9vbqHzjD/6Fa/2Co3379o0DlPyIH9ryAaFf/RiQo1CwA5P/Blh0bg1b7FAVKDugAxJlVq1YVqrz8FPUHUHTnnXdmI1xvCva8EKmy3wCDjyiC0/Bv2rSJMTdCkhCM1DVjdffuW6/+h1V829w6vZqGYcUxoSIAqNa3Wwe/2/ZZ4Fic63X1j2PhMEAN0EQl7K8ZOnXwKTBiKqC92ufqPzngsjFOIM9fW1tbhMdXXnlF1q5dK127dpUjjzwyqhx/dXW1Ph6Ffu3bt/d87roffsi+bcYDw3aUVwQcgO5dOAyIxIeWCom3JkzxX++u/RqI/xgjvmTJkrDhf3zdDv/ve+Ce+jk0/sOdZ4MohC3+A+A4mBW+vR/36nuvH4IK/jAGmPn/xIcRgEaCPL/a0Gw7OT09XRf5wfNFdb+b8Xdb3SNCAMMPr/mkk06SPn36yFFHHSXPPfec3h8pIvC7W+4a/rOTz5r60uuLi4SQJoAOQNNjVtp9uvUL2v+N5QBEyv+vWvFtwHlYvmaZrt4HiAx4ETNCuB8tycbI470wLRDXMQbeLgDs43cAoFFgr/jDRSlI4kAHIEb8A3uKxCffO8DsNz354YryQtUEfP3117J06VL9x/ff//5XPvjgA+0chEohzJ3/0p6HH/9/F85d8OKxVVXVlA8mJEmBUTXhf2f73/ebVgeMdzjxH5xfU54WeL3im6WBY/GZ4iUkb5wQrPjRjWBGBePaON/cowHOCoYBZbXLDFrx47ghQ4YISWyYAogBtSrHX9JoiVGz387bGycBj/hDe/vtt7XxR/rgiCOO0M6E05H4eMV/86+88dYTS777vsDsq6tT2+5aIYQkH3ae3RTWARhX5P9hkGHEw+XWEXa3uwe69+kYtmcf+xHuNyp/wAz+QRTAGcLHa7yHAa2KSAEgReG8J+MwkMSGDkAUZGdnF9TU1BSNGTOm4I477pCBAwfGpfreGHgYe1T0G1Efp+FHnv/6P/x5xJL33g8sEWD44fPvqq6UnaU/yu5a7wWHhJDEwOT/jVE1fG+F1iMZVTgRxnlASH6/A/YNeR6OhRxwiWOC3yeffNKgUBDHmH22o9K7216B9yoaVRR0PGANQOLDFIAHkOf/3//+N6Fnz56Ts7KyClavXh1VZb/BVPiHy+nDoXBLH5g8v238QRqsf5q+uIoA1NEBICQJMaF1Y1QN31irayPEE+4axnmwq/JxnjHgpq0PW4nL+F63LgG77sBOAZhWRWgA2GmJSPdJEgc6AGEweX5lsKf06dNnwBdffKF/uZcvXy5Dhw71tPqHowCDb0Z3wnmIRrAHef6DRo2dGinPn9kuRzr06Bu0j7MACEl88LlgwvT26h9AYc8Y03DqfwDXaOefyofIgTHmRpHP2daHfTNmzIg44hcdBCeeeKK+jh0BMAWA0CiwDX6kQkWSODAFEAJl+LHSLlJbtpHvVSkA2WeffTydb6/0X3/9dR1ug2QvwB/dlClTwjoQbnn+SDgdCzoAJN60oxBQ3MGiwmDn/8GWHT/Innv6Wvmw+oYhDsW2zTsDz1E7YKr2YbhNN4ABeX60+sEJwGdTKOxwPhwBA+R/9+4zUIf/hx1+aFC4Hw4AJg2SxIcOgANbt9/eH4vMrnEcINeLoT1btmzRfyjo7zcOgpc8v+++fI9paUIISSHsIrw+ESIA4ULr27bVF/tBA8COABiwMocaoNcVOoy5iRDY97lPH59QkS4AHBosAOS144C0PHQA/ChvOP/yyy+Hm1wgccA27CgW/Oijj2TdunXaEcjJyXFd/V987bQRr7/97nA71I+8/q6aKl3kl56RKRlts6VNeroQ0pz8uHm9kKbBzqt3siIAbup6XgvrKqrKgl7DGUDk0RkJiASKE9EKaIYUGUyrIloNL51+b2A/w//JRauvAVizZo2K7GcX/eEPf5iy1157FcBIxxNTzQ+Dv8cee7i29Zk8P4R8gvL8atVfXbFDyrb8IJU7tkn51k1q+1E7BXW6708IIUmMWTEbbAVAW1/frsSPFpyHcH+0xh8G36z+7dw/nBQUACLKUJtZFmTwkSaI9n1Iy9GqIwDI82/durXovPPOy/7ss8/ksMMOi7qtD0V+kc4JlT7416J3et4+64Fjw+X50zPbSobaamtqVPg/TTKyjH+Q5qv+t2AHACHJhV2J78z/O8P4sToAqCFAlCHUAKFQ92VW/wAFhAY7/O9c7TP/n1y0SgfAzvN36tRJ7r3XF8Jyy8mHAseWlZXJv/71Ly3cM3jwYD2mt0OHDq7HmnoAsG7jxuwbb727QZ6/AWlwALKlfZeeyAWIDtgoJyBUHQAdAEKSC7sAMLttbtDXKqrLZYBLHj8UHTrnBJ63y6ov1kQawUwZ9AoMvjHkiATYjsqh+/9MP37wxRsy5/r68D9W/3gv9v8nD63KAUA/v3oImef3YvyNEcfjiy++KOeff35AE+C2227TClrO69hqf1fedPuIN/4TnOcPh8/Yp6lof3pUBYDdO3MQECGJjp3/d3ZYoJLfNqaRIgA4FmkDpBGys3ID/f8wykZq2EtxHpwFRA3M+xmRImCq/93C/ygSjNRSSBKLVlEDYPXzXyoxFvk5q/bx/Oijj5aJEyfq1sAJEyboCIDtINjnPvXsgj0Li1Se/w1Hnt8jrP4nJPVwE+MxoAjQOADbtm2TSMC4Q5QHQKPfvjYWJl6iAHAaEMZHzQDA6t92PI497HT9+Nr7c4OMPSIUcADCtSmSxCPlIwAqvz/8+eefLxo7dqzu58dq3U1mNxTG6DuPR96/Z8+eMnv27CBjbx+H95q34KU95zwxr6jku3UF2AdD7tPt3yVV5TtkV3W1CvNnStt2uZLRNktiwbQI1rEokDQxmemZQuJHUA1AXrcGXzcOwNatWyUSUON7ZObzcqj4ignt6AL6/iEChBV7uFoAOArq8zJwb1j9GwcAq/9D9x+ln0P8Z9KkOYHzYPxR/Mfwf3KRshGAp59+GqN5pygPdvQll1yS/b///U/vD2f4bfEePGIUrxnVax7NeF6zOaf1mVz/2nUbss+deu2xN/xxxmRj/FG2j+p9LOard5b7HYBK9XyHVGzfoqv7DdpJ8LgBrQjMKAFpYjIz2gqJH+EiAJWWmA9qlSIBA/yhyssjdYAwvXPIj1H9swv6gKkvgJMA42+MuKkDMB0AhwVy/2/KuJOPD4oMwFGIpsiQJAYpFwFAnr+2tnZ8VVVVwWuvvSYffvihDtWjBQ/YBj7Uyh1G3qz6TdTAHGPn891Yt+GH7D/cff+wN995b7i6TjZscr1Z91lovM5UK34U7dXuqpF0FU3IbNfeHx7wHRbJmGvD77f+aW1o+QlJNsIZf2D38sMRiFQICMMNVb4Vq5fplXqX3L5Bffkw/jjmsssuk3vuuScwYRCPZuyvAcYf43yREsB9YvV/iH/1/6/3n5Y37nwt6PuIJFNMEpOUcQCQ51eGerjaivAaIXr8Qjp/KSOF/2H8IdkLb3nFihU6v3/rrbfq6v5Ixh/9/HfMenD8tu078v33pFv3tBNghedh3NukZ0hOfhf/ft9xXqnF5L/t22T3rmp1oTTJUs5Ddl6+1FRVCSFNwcbN3wuJL14q+w3hxvraQOXvlBNP0336A/cerg25/RmIKAE2pAeM8XcWF2I1j5QDrmVkgrH6R1oBq//BQw8IKibEe5iaAZJcpIQDYHT7ldHXxXWh8vZuOFv/4Di8+uqr8pe//EXvf+utt2TvvffWuTHgdk0Y/ocef6rI2c8Po27G9fpe21+zHz0af78TUaXSB7tqKvXrtLo0qSjbLm1z2osda+jepZcQQhKXSAa9U4cegedwACJFDACMPQz0grfnyIlHnSe3Pv50ID9vE6obAMYfxyMVYNT/nKv/ZxfMCxyPY3A8nAWSfCS1A4B+/pqamvFq1Z9vi/FEo9vv1rJ3wQUX6AI/iAP17t1bfvWrX7k6FKF0+wEci7S0+uPjkp/3FxBm53XEjUqdSh+goiArJ1elAdLFsyNBCEk4tuz4scE+U/1vwvVeQN4e437/texp+cWw0/UqHgY/UhshugQ++eSTQP+/yf2j8t+s/o8edURQRAEOA5yLWEWKSMuSrA5A/hFHHDFerdILYKyx0kboHjK78WLcuHEyZswY/dzN8N8244Fhtm6/Xukr+7urukoqtm9V4fkavSOnY1fJzM6O2zAfXeyn0gft8lAU5CsYYPEfIcmHc0VfUVnW4Bjb6JsoQCRja3L6cAJWrFkmVVU1+jnC9G6FejD0COOji8DW+8c+u/Ifq/+PPl0WdC6ON2qBJPlIKgcAef4PPvig6MwzzxyO4j4U56H/HgN2vEr4msp9u8gvFG5fe+Cxp/Z76G9PjzZ5ft+N1a+9a2uq1Fbtz/+L1Kg/asj3RmuknTUD9S/sfbT8hKQKldXlQa8hDWw7AEbQx8tqG8esWbNGG2go9OE6SGOi+A8reFNTYFoFnRMCjfrf9ZMf1q9fU9EEZ+U/jsE5XP0nL0njAJg8/8EHH5z973//WxtxhOkxWc8LxvCDnTt3Bo3k9eI8hMrza/yheZjjrNwOkp7RVlf3IzKRmZ3r2Uz7KvtrVfRgl1rlp+uwfhqNPCGtAgj/2LTLyg1yAGBoUZUfTbU9Kv+NYA8MOlb7prIfDgVa/9wMOFb/xw7zhf6h+rdq41KZPa9+pY/zcQxX/8lNwjsAft1+VLDoFTdW5X379o0qz28M/apVq3Q+7Ouvv5ahQ4fqnNeAAQOCVP7cwv2XXn/LsR8WrwiroWmv0tPbZuvN/x14WqjD+Pv0ALZCLUCfkpmVIzn5XT13CHAWAGlqcrJzhTQdRsoXtGubG5QmgMoePrNgtGMBht6LVC9W9tu27JRfjJ2gX9///PVy96w/Nej75+o/+UlYByCcbn80xt9m7dq1usUPQ3wwwGfLli0Bw++MArjl+etvTupX/S622ezzhfG9WH/fA1IH9vV9Br3O0zXwXrrugBCStKz7cU3AAYCc7xvFjwW+hhU7VvCICjSV4h4cjt9de4P85uRb9WsT+rdrB0x3QGNX/7k5eUJaloRzAJDnr62tLUJPfzSSveEw1xk9erT+pUUqANX9Jn3gfA/XPL8gklArdbtqdXi+ja66D+0ERAWEf9R1oAuQkZ2jDH+NLwKA9EFam4jv4Usd7Fb/rw3s69a5jxASL8oryoTEF7fVMyIAhk7KEbAjADD6cAKQt28K0R28F4oFRx8yKWToHyD0Hyp1EA257egAtDQJ5QCoVXiRyusPP+OMM7LxS2aq+uNZ3b/XXntpB8At7x8qzw8Du6u6QnaWbvK396VJu7zO/t778JGAujpvK3hzSNvsduqcdmLX+HlY/+vUQTU/pEkTUV6xQ0h8cVvFY5jP0UPG6ueoAUjbnRVU+IeWO6QB4u0AIKpw0kknyX49DtciQjD+CP2j59829Oj5RxTCtApGi+3QcGJpy5MQswCQ51fh+UvHjRtX1KVLl2yFNvow0l6Nv63Lb0v8uuEW7j/1vN+e+Ls/3DnZrcgvYMjrdBOeXpXbQj6hVuduKQAvg3vS0sS7NpD/PVA3AHVBQ3nFdiGEJC6uDsD3y4NeQ9MfRXsGhOKNil+8wLWw8u+Rtb/84jBf3v/Rl/4oF1/26yBHA8dBRtgMC4r1vUC/vvsJaXlaNAKgjGpP9TBabQW9evWSefN8ClNeW/qAKeDbsGGDzul3795db6FW+TZh8/wO2qrQfGZ3rM5rIb7vSxvUebpFXwShcqfUqpw+nIe27XL0NeKBcT5yO3ZR95gr235Yq1//uGW9EEISFzcHAIN8vvl+hTb8AHUAWHGbMbs4B4V8iALEQ33Pzfg//fpMOe+iXzWQ90VUFvcRSkXQy3sZB6BbZyqVJgItEgFAnl9tMPxTxF/kZwrxohnTa1b6L7zwggwaNEgOPvhgOfbYY7WHbCICoaIBt82cPeSE08+78KXXFxdFMv4GDN3BKjtwjxFX6T4PoWL7Zikv/VGH6Xeq59s3bQh8LW4jfHXLYTvJ8HcfbNy8TgghiQuMuVse/WvlABgG9hsWNNUPIP9u+vQbA84/6KCDGhj/Aw/7SQPjDycE99EYzX97PPHAfQ8R0vI0uwOgDH+ReoCw/nC3r3t1AOwCwcMOO0x7pYMHD9Yb2gThTLg5FMjzjzrpjEkPP/G0NbRHtD2OmzF2kJGZpZwHX9oAff2IJpj3DVncZ6cKrPsKjAAOca8YCgSQs924hU4AIYmMWxQAI30NEAPatqWiQTEgnAAzqCcWYMyPGH6kFO5xjDb+GD1sjL+tBgjw3ngvFFA3pvsAgkQGOgCJQbM5ACpvVFBdXX2pWpEXqZeeVtxegIFHRf8bb7wh//nPf3RxSteuXRsY/o9X/DffLc/vK/CrlMqd23Whn5ccfTTAvrdt1146dO8reV17qcfefiMdQcLX/zV0BOzcvkXKNv8gZVs26nsNpy3QLq9j4PmatV8KIfEkIyN+BblEXIv5IAj0jRUFgBQv+u5tzHAyhOWjASF4GPNzJl0op4+6So4aMtZX8Pfc9fLTXwxqYPwBjkftQWOr/s1sge5deku/PqwBSASa3AGA4c/Ly5t82mmnTZ4yZUo+NPsjFelFi4kGmMJB2/gjz3/xtdNGnHHhpRfaYj5mJV1dvl0Z1h+kUoXnyzZv1GI88YsEpPnF+32TAdMz2+oUQrjCQScV27ZIVfkOqVGGv6ayQjsBddAHCHGPEA4yfP71h0JIPGmbkSkkfoQyqui/N+zTZ2CDNABAMR4MthcnwCj3HTBgoKz/okpumPSw9OnaT1asXiZ/fXWaXHn9JVom2AnOGTJkSKPH/eL9TQrgwH24+k8UmqwI0PTzq234rFmz5Ntvv5Vf/vKXMeX5Q4n1OHEL998x68Hxzn5+YAxwZrtcaVtdpQv0YJwzVXg+LS36CIA99rf+iccWwDDXzGyXE5gtgEvp+2uTEfKy+B4QYajcUSrLPl0s55x8lRBCEhMM4HEDEYB1m9ZIb2WkURAIhwAraDtigHC8GfpjdPmRCoXBBjC66CCA4V363gcyonCcXHTinbq9EKt+hPx/sm9XeXfpOyHlgHFdTAhsLHYEY9SwsQ2+zjbTliHuDgAMv/jy+8PT09Oz1abH6WLlj/Y+L9iGH0N/Pv74Yy3is8ceewScgEhOxMXXTS966d+LRkR6rzbq/nI7d2tgq72s0KG8V1G2XYvw4ISsnDyd7wcBB6IRPgDuAddsm425Bb4OAt/Y3/DeSXb7jtoBQA3Aiq8+ZL6NNAp+ODcdMNhmMI+T+W/NCSjyQZcfBtmZMoDhhoHG17CCh3Hv3a2femyvpYTx/ICuP5exF1ymj0eBIcYEby5fq7sITCrBCQy2UfuLh+qgSS0g/O/2eWTVK8Wvv5FEJK4pAL9uPyr7i8TK88NYR2v8wcsvv6yr+q+66ioZNmyYbNq0KXBMOFDhHzD+YQrmgojBSO+E+M7OMqmu3Kkey6Vih0/HPyh6EHsAoP4SbVT6QIVe4azojEJI4QGf49GxR9/ArveXLxJCGgMdgKYF4j5uIAqAED1AFOC7rzYF8ug2MNAzZszQ0/9OO/2XsrlsrX+0cJ1uK/zgizd0jv+uf/xGvtjyb7nrL7foY8MZf4T8YfzjofVvdyycdtwU12NK1q4yT78V0mzEJQLgN/xF4qLbHy1mZY8WPni7t912m/5l/fnPf67H/oJIqYB/LHixyHdjEniIgx1uQE6HTlKhjLGe/KdW5u1U6B3G2TcKGI8N3zWQKgikGXbrzoC6SEWBhgiFg9pBQBqgvUoDlJXKm0sX6j86ym4SkpggDeBWfAfmqjD9Faffo2WBEQVAQR5W/G6rchhrFEFjg6Ngdw4g0oCvR1rNQ18AkYR4GX9gahSw+ncL/wOrYHmxkGajsQ5AtlqdF5WVlQ3HeN14YRf0TZlS7zF6EQj66LMV+cj5767dLVU7d8jumio9ma+tyvXr8bpx9ATaqFV5bqduDfr5zArd+V52ZGBXdZXs3LZFF/Thvtrm5Ep2bgd9kjku0r2GayPs1HtPWb+qVK/eXlz8ZEjPmxDSsiACAIU9tzQAVvBYvV8+4R4dBdhj9WBtULHiD0csUsEm5x9P4w+HItLqf8XXH9pRpsVCmo2YUgDI86tVeVGvXr0uvffee4ffcsstniR4o745SxzIszrgbn2Dskv94SAPXl1ZoUPzgUl5MRT3RcRvhU1nQajNVP/X+bX7UdyHnxkiCKj0311b683419VHEhBtcLtHFAIaTYCFi55iGJeQBMWo+4Vii79Nb+uOjXLiUefKP/6+IOr2v3CYOQCIGiC6EC/jD8NvOgvCrf4XqSilOUVtxUKajagdAIT7ldGa0rdv36LPPvssG78wt956q0Qzuc9o9mPzdJNRTAQ8uHBgaVZW2ypM0svp1EWFwjvoVXo6xHii0tiv8w/yqasX34l8VuDyaQ0KCuus12l68l92bp5uDURlf07HLnrKYJqEny1gZgshcrBLRTd8I4TNvQbTqdee+tFEAQghiYmR+g0FOgKME3D2Cb+TmXffHxcnAEYfaoDoHIhXwZ8B92dW/9eed7frMVAsfXPZC4FThDQrnlMApq1PLAU/5OSxRWP4cez27dvlkUcekeXLl+vc/oQJE6LS/4/Eiccdu/gfC148Nqtde18pYjRhfyMMpKIHu5RxzVCpCKyk0zOzJfLoX99QHv1oTQF0GwrUJj1T2nXsLO3M29ZFDvmbL1f4iw/NZEK0/rXv3F3SHD9DEwXA94IowJiiM1gLQBpFRjqFgJoChOyxuRX5GRAJ+MNj52thoNOPmaqcgJl69Y5q/mgNt1H3wyNqBuI9XdCkE8DIYeNCDv+Z98rswC0Jw//NjifLrYxZfk1NzRT1qI2/We1Hs+o3vfx4/Prrr/Uv7dy5c+W+++7zPMXPeb1Q3H7jlUuPPmLYUv0iCuOvV9jqsaaqQq+uwa7qaqmu2Bl0TJgrSL3CX1rQWzuNe6TXrujCwVqpqSgPfP9wNJBCqKmucD3FjgLc+/ebhZDGkJlJB6CpiJTXN3zwxZs6GgAhn9kPPKxX8E6lwFDAwUC4v1+/ftr4Y9Ufb+MP7QEjHITQ/7mnXOl6nGP1j2+gREizEnHZ7Z/YN1mtNLNtoxtNWN4cb5wAVKSish+/gAMGDNAFf9GmD3COuZ4bj82647WLrpte9YoHLQCDMcLZuR11aB7hdbTfZfq1+yPl5f1ZeV8ro+4MyNCte76IgEcjH+ke26Sr1EY3HQFAIaFPvKidlht2ew9EACBDvH3jWln22SJ5X22HDR4phJDEAp+LaM1zU+Rzw7QIlpSU6xoCGF2nGBAiBBBhgxgQ1ARNoSHy/PEs9jPgM91ua7zlkoddo47lO3fIjbPOD5ymtmlCmp2wDkBZWVlPZcwmS5y0+42xRrjfTh9EY/w/++wzuf766/Uv2i9+8QsdaurQoYPrNe677ebFH5/+y+LbZj0w4qPi5Z5nWKalt9FdA6I2r4a7zp/jx+ocIffdu2vVeemSldtestrnB9QFvVT263sIc1xG2yy92eeEOx4dATu3bZJdVZUyS0UB7r5mP+2ZE+IFDpVqPhAZhaGOZdIfzgnVTmgDJwEywvHM95v3hyqhufdzTr5Sund2/5yZ9+ps+/fqbCEtQkjLqzzK/PXr109QRlcbf3u13dhqf1PV71UW2Iz2BRADeuutt+R///ufHgNsPNpQKYShgw8ofWbOvQvOO3PCgo55eVGrTHlftfsO3FVTg29Q5/ix+kcdAZQCIxYRWoWGvur+8Md6vUetSaAiEV339OXgkAq4fc7l7AogJAEx8r7xNs4GTBFsius7jf+E4y6UsSPPcD12rsr7L1wUKEpG4d9iIS2Cq/VFwd+jjz46WYWH8t2MtJvRhvGF3G801f2eb9JqBxw1apROH7zyyis614TRv3jvSM7E7y6dUvzS03NmHzRo/6W7qqqUTY5Py6LdhoeCvHbtO0i7Dp3UCj1b2ubmSS6G84TQBfBdoL6yHz2Mu6oq9GRCDCXCJEBzTBBRpBJwT3hfCAN16N5H74PoxiPP3iWEkMTDhOfjaaRxLaz6vaYXosFp/McWTZTTjnfv+Yfxn/fyg+YlJhxNE9JihLKYRWprYPzdVtj2vg0bNuiBP/hlePDBB5tMFwCpgyOOOEIgPmQiCZHAvTz3z2cq35w/97VNa1bMLP3hu9Kayp2u7XPRYMvy6kupHH1G23a6wl+nEaDfH07lL82cWyc7t27W0/4qtm3VIkE7Nv0gtZYz5eVWQ7Us4v27/GQf7QgAFN/QCSAkMUEeP149+cjJ41qhJIcbg9P4o9f/nFMaDiAzOX/L+H8qDP23OA0cAFT8i9XqF3SwIwXgfEQ4Hs/XrVsnlZWVOhKAqIBXvDoM0aQPDLgXOAxlZWVSU1VZmlFdNvPnRw7XaQHvff4+6kKG4H1fCGgBmE6ASO19xglosNSv86UPpC7i/dm1A4HruZzTY58DJSPLV9KxcPGTdAIISVBMJCCcSFA4kOvH+Vj5x7vYD7gZ/4vP/H3QMTD8aPW7cNoJejAZOPjgg9GhVSQc/NPiuC2di+wXbrl/89o2wDCwBxxwgDz77LOBY6Mx0jh/48aNsnPnzsDUv2g7DcKBroGJEyfqFAIclJ49eyJ9UPzZf1eW3DbrwREfFa9wLxI0wjtQF4RyH6SFM9tKekZbtbj33V+9oU2rfwic5y1ij0gCevlrKiukVr0H9PwzlaHWo38lci0Cug4gfVy3u1bfq+kMcHYgoGugV/8hsn7Vp7ooEE4AinF0wQ4LAwlJKIy+/6RJkwIT+sJhVAUhLBTv9j6bSMYfhv/FJU/pXL+pN8rOzq4888wzlzz88MPz1ecdjX8CEOQA+Ef5BhlCr0bYbvPTF/Yo7GMK/DDyF+kDRBGGDh0qCxYsCIT44wWcADgXvXv3Dtzn0MEDS5+Z85cFH3/23yXnTr1m0rYdO4ITb37DWbF9i1SVl/l2qX1tc9qrXH9nMX3/xsj6agJsASD7a5ENOQw3tsB51j24od9vd52Ub90YlC6AlgEukJXbocF7oj7BdgLQHoi6ALTs0Akg4cjJyhXS/BihIGgFoKVvyZIl+rMSG5yEPffcU6cNsDU1bgV/ds4f6cV5LwdV+ctPf/rT4jvvvHPJ4YcfDsO/QUhC4LSuBW4HmZU/jHGo3vto2vns65prw9gfcsghsnLlSjnssMMCEYBwvf5u1/NyrJtTgW6BTxYtnHntLXcNf+3NJcNsRwCGuI1/HC/0+mFR26iVuW/iX7Chb2CtLSserQ6Al+P1PUCCuA30BnbVn4d7VPccCqcTgD9WhOnGFp0hY4om0hEgJAHBCt84Ay1BOOOPoT73PnFzkOHfd999S+64447XTjrpJNvorxSSEDgtYU/7hTHOWKFv2bJFG+mcnByJF8ZpwPUhCIT0ge0URJM+ePPNN/UvZf/+/eXoo4+OOX0AFcFTTzx+pa0doKvoczpI22zoAvjkd7XBtfLuoQrvsBtOA6r6odjXBpP/2uVIett2jRcG8isX4nvN69pTpw+0OBBqJJSBR7g/HNoJ2GewbPhmhaAgEiAlgIgA/qhDDe8ghLQ+Qhl/GH6s+E2OH8DwX3nllUsuuOCCErNv1apV8tprr5VecskldAAShLAOADDSvccee6zO0WPyn/qHjWt+3qzIzQo+mrA/igzvv/9+ueqqqwLnoejlmGOOiTl9YLQD7n/0yS8f/tvcY3U0IE38qn7p9Qe6hPht9GsVnt9ZusknLez/OsLzyPejlqBR4kBpVryhLjh9YJ8X9rrqornqXiBehA3Ag7/37zfpil06AgSSraR142b8D+x/iK7sj2T4URCODrFDDz0Uc2A47S+BcFrxIMU/Y4zRa3/jjTdqwz9mzJio2/u8Hh+NU2FqB3B/qBlASAy5MLS67LXXXvqYxuoR/ObsM1YiLXDcz0cusff7wv513iYLq+8pMytL2qSl+wy22tLbZunVecD4h7pQnV1EWBdy9K/GxYkIN1XQkK5TG5laMri9iiLYUQPjCNz+8OU0AoS0UpzGf+C+h6hV/0dy48x649+7d+8Ns2fPflyt8h+3jb8pBocNmTBhAlYYS4UkDM4lsmtlJkL/v/rVryLq7zsx4fwPP/xQTwBElwB+EcIRTdGhqRGAJoAKLQXeL5pBRbgvaBZ8+eWXcuCBB8qZZ54pXbt2DTq3XlL4fqtbINi6Bqn4BX9Fstt3krY5ef7j6rTR9X/J7VKB4wDC+kgfIIKQnt5Wt/DBWOvTYkwhmPP0o4pqdOjWS6cA0EnQoWsvHQnYvmm9rg0ASAlgGzVsnJymPH/WBxDSOnAaf2Cv+Dt16lR67rnnLrnzzjtdV/Z2mvfee+999aGHHqoUkjA4HQDXfxy77S+aVTqOhWzv2LFjdage2v3PPPMM2kEkXti/YLFMKLziiiuCWmugMmimctnX8aUF/rLgj/fc/+0zC14ZESgSrJPACGD/S02gE9Bvbe2VdWDlH8aAQ0Fgd12tVOzYKnW1u/S14ATs2qUcAeVRowvBM3XmXkK/lxYt8h+LzgGkBUrXfSs7NtfX7qC6F44AJD7hCBBCUhcorSKi6jaXAC196nN92V133bV0jz32CNgNswhzpl/V68Xqs5C5/wTD6QBsCLfCj2b1b0Bo/q9//at88cUXcsIJJ+hfDNtYe8HL+8aS74dTgpnYaKXBbAGkDs4///xAZAE43/d3l/6m+Fennrzy1hn3DX/1zbdHONf7oQoCncdEBDUHGCakDH1V2XYtCCQ6fZCti/e8srtW/UHWVqv3bKO7AtJMZaI47rwu+Hl6ZrZ02XM/6dhrTyldXyJlm3/QX0JP79yXH5Q3l77A+gBCUhQYf3x2m1krhlCGH5/pyPUjSmxeA//n8lL1ubNYSMLhtJorzWraaVBjMf6GU089tUF4PhI4FuH5OXPmyDfffKPDULhOPEEkYvjw4fL0008HogjmvUM5FPha757dK+9VaYG7/jyz+M/3P3RaWnpGT4gCtc1up0L0/iI8vydgNAFiDddnt++onIA8f/5/ty99UBesKdBAmRD3qY6t3L5VqiF3vHu3TyGwTbrWLvCNN/ZFLSLqEqiUQ7eCAXqmwea13wTSAnah4LXn3y39+u4nhJDkx834o7PolJNOWuI0/DD6qA976qmn9Ocn0rHXXHONbukGtbW1S9Vn6atCEpIgK6e8tEplaEqUMSyw90eKChjCGfZoV/zYkJvH6F8Y4+eee066d++uf8GMlxnu/FADi8INNjI6B3ZXgvMYsx+/+G+8/mpp6brVs1VOvrBtbscRdbtr8/XqXK22fcV7wWmBIKxVuG2EXaMHmCeQVqeulh709VCRBt18ABlmv/Gvv+9ata9cdwqkBbUQhMY4Gu06dpWfKCegTKUEtq7/NsgRuPyOCawPaAXkZFMEKNVxM/5HHj2i+K67/rxk2KEHB3aaxdKLL74of/nLX3Q0FZ+LeA01Vwi5IeyPTUjC4rbMXawM3mR7BwygM28f70E/9nXNtS+55BJdkPfdd9/JsGHDtPH3Ig7kZrCjeW6PFrbTAbY8MZwQpAvwmJ+fX7z+hx9LMjt0HvHVt+sLTU1AyOL+OrNKr1X5/Vot+1s/VCgthGqgF2tdf1h6ZqaOHFTt3K6VAn3331brGaR5CEfgnF3VFSp94PtDh/Qx0g+5nXvqIsSyTT5HwID6AGwTVFpg5GFj6QgQkmQ4jf+AAwaVXH3NNUvOmPDLklBD4VDXdemll8o///lPvX/gwIGoq8IF5mdmZpYISWgaOADKOJSoKABaNfRAIHh2dnGdMdDYP3/+fJ07h8Y+JHbjgf2LBuN6zjnnuEYZwhlyHPPZZ5+h6lQXsMCJuOOOO3QHgq1m6Fz9R8J2CrCNGzdOb/7r4Jd+wUefrljy66tvmrRte5kuEgyytVYxXsWObVJVvl3vhLFFER4mCLZJa0TKIM1+mqYNdXb7DoEoQJso5JnLt2wM0i4ASEfgmohydOxVoNsGnYWCrA9IPYyWO0ldnMb///7v/xY/+eSTS9w6v2xb0KFDB60Nc/PNN+vPa7V4KlaPryKaLCThCbWMXlxRUVGKUI4x9ma6n/nHx0AdiO8g/3PnnXc26Ln3GiEwDgXON5sdBTD77OPtY2yjbK/QFy5cqPNS77zzjrzwwgvy6quvBs0psJ0ae5Xv9p6BH5bVcWBem3vCzwj7hxw4oPT9156beeq4417DpMGgC/ij7jDIvlHEu3VuH8Z+V9VOHQ2QKAx/2FHGfs0B1CbA8Hsx/vpyaqutrpLamuoGuYvqivKge4Yj0LVgP/nJoGGBCYPA1AdcePMJKiqwUEhyQwcgtXEz/vPmzVvi/Bx2fqbbTgFW++r1Y1lZWfNp/JMHV6vgrwWYq/7RJ6uX2cYgwglAKgAGFBXzGDUJaWDoBADnStw5LhiEq7C32w2NsxFu/oAT+33gnOy99946AoBCvyOPPDLie5v3BJs2bdK5LEQP8P3Zxt75h4B7NJ6y4bYbr1p68phjV971wJzgSYPaMLeR9p266igA8vKw+Zjch7C9F/RkQmWkd8NIK0ucAWEhTCeMsdDQd9H6DgYYc7QCIn1gCg3S01VKIa+j678DHIGfDBzmWh8AR+Dzrz5kfQAhCYjT+P/yl79crBZOS/BZiNHpGDyEz0FouNgjha3PgRJ/i1+JkKQj5LJQ/YNuUIbmVbWyHa8P9Bs520jDCXAaeucYYNtwGgOMtMH06dO1xDDGVk6ZMkWHkoJuzFqxei0etFfzcFSQmjD77Ty+E7tDAb/4f/vb33TxIf4AYPyvu+46XY9grm8PKjLFLyZV4g+D6X0HDxlYOu+hWQsefPzpeklhc68ZmZKrnABPWsB+fNLCtVJW+qMyslUBsQFIFOd07KI7EGJ2AixxIHQutEP6QBl8FBP6WgjTI16ifZee0lY5Dpu/+0qqy8sC9QOmPoCFgoQkDm4rf2P8MVvloosu0p/V5jMTSrAI9eNzDsXi6enpNPxJTljLqv5xi2tqauYro1YJg+rMvxunwEQFbCfBWTNgOwTwKlEtCoVACAPF/Zty5Pe9tB/a6QGoCmL4ETxfPL799tuB69jHGsz3jQ1Og52mwLGhJIU1UVhs08JfW1NjKQ2JDsvvqq4MU3bowJphEGqIkZlgiKiEF+Nv2F1bI9m5+T5noF2wWBGcAGiHz3tlthBCWo5QOX8TBUUEdO3atUGf4f/973+lqqoKK/7HsNH4Jz8RE8NqBVysvD1UeU1Qm17Bel2Rhzr25JNP1iN/MVwIUQSkEaIRB7JrBWzHxMt7RzoOK/mHH344MPwIYS9UuhrsSIaJBpgogNkHBwepBzO603RQ1EsK108ajBas9vO69JBKpA+wwkYKQIXs26nVupcCAj2ZsKJM5/ixsse5ARVAB7FEE9pm56moge89cjp1k+wO+VKFgsedvjwy0gIsFCSk5XAa/1NOOWXx008/rRcnZpGDz7zHH39cT2hF6lftLxkxYsRiFaktEZIyeCoL96cDHlNPi9QWk+Fygop8bKFW1aGAtPCkSZO0cYYTAWO9zz77SLwwEQx0H7h1HDjrFIxokikMnDVrlhYWWr16tf7DwR+SvydWf91MGvzjPQ9++8yCl0bYaQGvYIpgbuduEi3Q+t+x+Qddd2CiAFXKUKMgMbdT5Ot5yVag6DCnQ2edQoCDgtdpfdKlfMsPrvUBLy56UgsJMS2Q+GRmtBWS3LgZ/7lz5wYikyaFicXLhAkTUBNQkpmZqUP9KKQmqYXnpbz6BShV23z1FFtpuGPdiv9C3oDHVb+5HroPoBAI44r8lAm3R8JEDNyqWZ3YNQz2PTrvE9cyfzDGwGOWACIanTt31l9DKA336+R3l04pfunpObOD0gJ19ZX4XqP5UaGst+4c8KcO0tqk+bsS6oIEg1wJpA3qpxK6pRAC6QMVXYCj0savcYCUAAoFuxXsF9QxsOb7L+XCaScoZ+BmThxMcOgAJDduYX9j/J0t0aaqX32GMdSfwkQtoI+6ABSAiEs0wITBkTt3dgZEkzZww1xH/dLqVTUiAL1799bG1nw9klohHj/++GNtlHv27CmFhYUx35ddNGg6FWDwb7vtNt16iBQAIhzHHHNMgwJHQ++ePSp9aYFTin9z9bTTNvzwQ8/qnSo8r1bqaNuDYh/EexpX3u+jrs43kAjpA7zHLryH2t9GGWn09kcSB4LRR1i/Sp2LSII27MqByG6f71p8GOpyWkhInbNt41rZvvH7wH5bSGhM0UTJbZcnhJD44DT+Ki25WKUul/zxj3+U8847T38e+hcxJWpjcV8rISbrZ0UD7lGbnvAEA/juu+/K4YcfLv369dPVotEO/Ql7o1boHavrAQMGaMMaanXuPBfbrbfeKj/96U/lpJNOkp/97Gdy1113edYrEGmYCrAlg03UAPl+OCi//e1vda1DKONvM/iAAaUv/v3B2TWlGxZU7NhSin77yrJtsuPHDbrdry4O0YC0gEJgWz0PIK9zD8lRW7sOnTwpA9ZU7dSTCVE7AGcATsqu6mrZuW2zcgiqfQdFuE+TQoCiYOe+e2v9gDwVGbBBfcDlt0+gfkACQR2A5MZp/P2DeZagEBsiPvgsrK2tLVH7sNrnir8V0SjL7HcE5oo/LYCCPqyCYZzz8upXcNEYWfscN+EJt/59rw5Gly5dAkWD2BBBiPZ+nFoHxgkw9QCxjDo297/PHr2Lq7ZveVwZ1GJfX36arvCPZv1fF6q038YfpvcaWKjz30sDA59mov3pQTLEbuf7nuzWDgQ6BZB2wMRBCAn1OeDgkEJCK77+UEjLQgcgeXEa/z333HOx+mxeYj7HEM1VMNTfSol+hq4LSAuoB6QGit5+++3h6pcr8GkejYgPWugQoh88eLAuQokXxnD/5je/kcmTJ2v9gf79+4stcxnqPk3dANIa0Lv+6quvZNCgQTJmzJhA+gGYWgAT9Yh0XRt8HYJDKB5cvHhx6erVqxeos5Y8++93Ju0o3+npB1FTVSHVZTv0FEA4DZkqLJ/VHhES7y18bpi5BRlZOSp8311qkD5QUYm09HQdTcC4YnQmhL4Atlop31YquyrL1c/D5w2gOBCzCiBVjHbBUEJCN848n/oBhMSAm8jPP/7xjyUo5rv//vtLFi5cuFjtLqmFAilplcTFATAgtKScgGJl0IqU4SuMprhv7ty5cu655+qWOqhOLVmyJG5OgF3Nj9oE5P7t97aPce43DsCvf/1r7QAArPpHjRqlNQzMit8UF5qOAHNeNOkPRCRQeet3GkpvuqHNzGtvuWv4a28uGRaqWwAGGivq8tJNys7uDqj5IU+PJ9kq3O9v6Q9LqAp/sw8PGA2spx06vhYWdUxVeZmuOwh6P/U9VpZvU+mATHXdXH2t9p176mLB0nUlsm3j9xQSIiRGQhl/9bRk9OjRi4877rgSIa2exifnHZj6AGXAUB9Q6vW8o48+Whf4QbIXuXNnJb4bbmF5s9+JnbN37o/0HjgPeTKs+PEcj6h1wLlmRoKtmQ1MYaA9PMlLt4KtNAhuv/HKpX+decfjBxcOKnY7Xuv9p6Wrc7LEGaWHiE+9qI8Du4pfb77wfJ3Lz9P5fvajFxAhSHP8nM2cgnQVoTBOi7nP/N4FOi3grA8wQkKsDyAkNBjS5mL8Hxfm+ImDuEYAbOAIqId7VEQAy+0i8YsIuQFjh4r5J554osEQIC9T+tBm99xzz8mXX36pBXywwrcLBGPBVgYESB386le/0mpYqHEwXzOdAMbQIyIAY29fQ4X15cknn5RVq1bpY8444wwtf+z13ox2wP2PPtlAUli/T3obLSuMYjwU5sGwZmS3Cx/+N4OJlOWt2F4q1SrP68vV1+nQPir10YXgeqrD+EfSB8jMbi/t0zN1+qCmxnd/6RmZWoAoPTPL9Zp60NCe+0n7rr3kxzVfaKVDYOoD5r38IIWECHEA8R58VhmGDh36mDL+02n0iRtN5gAY/G2D6BTAeOGiSMfbhtdL7hwG9YorrtD6/Xh9zz33yOzZs7Wxjnf3Ad7LpA+w8sc+owKIGgD7eBP+R+3A2WefLRs2bAjUA8ARQJ3DEUccEdU9QlIY20XXTS965d+LRthf00ZVGU0U1gUm+0RCHQbDiqE/dt0gnIiK7VvUtXqo+8sInT4wegIYaVwXeoyxnhyoDH16xyzJ9p+YFupgqS8axHVxf0gLoAWxckdpIC1gHIFFKipw8RnTmRZoBjLSqQOQyDiNv2L6xx9/PC0tmnAdaVXEPQXgBqYL+ltPkBYo9nJONPUDU6dO1blz1A6ceuqpuvfeC3au3u26ztcmKmEG/8AJgKNiV/7ja2Y2gPk+Lr74Yl3PgOeoQcD9mSiCFxDhgHYBiiQBtAP++cj9M13TAjrk7/EPPg3Rg0w9STDIyKdh1Z6jnIrwxl9nDuBEqMhDjTLQRmLYtQkhLejBuADut2U6FPwyx3BuUCjYoXtfycnvqjUIDCu++pBCQs1EZiYdgETFzfirbZoQEoYmjwDY+NMC8/0RgdESJi3gBbOihjFF+sAuuvOS2weQ7H3ggQf0qhy6/xdeeKF2JOzrA9tJMGkB58RCY/ztr6Ne4NJLL9UdCBAHQqGfF20A856IaEDuGIM5cC04OtAziIekMEhX99i+c3epra2R3UhdoE8/I0unAdLCtPXpvD26I1SkoKayIvA1iAOhAwGG2rnyCLysS2t4PX1Aw/fKyumg0wXQRkBhY0bbznryIXQS0DVgQH3Ass8WydiRZ+hCQRI/djoKOEliQeNPYqVZHQCDMgxwAFZ6qQ8IhzHOZrXtpV4A2IWDEMJAB4Jt7GfMmNHgWqZlENiOht3uZwr/7NoFW6gIjorXlkgje4yxySbygIjDI488ooWW4FTgWpAUnjzhpJW3znxwuEkLBAy0x0wAivR0K59KIXjS+/d/HeF52/j73rtO76tVX0tvixqCOlehoXpnQMJ2KeC4THUdOBU+R8GXd8jr2lM69d5TStd9Kzv8jgD61TloKP5QByBxofEnjaFZUgCh8OsHPCaOtIBbdb8JvcciKuSGMco33nij/gNCPh6PV111VdjpgnZhIe7FPylL5/rD9fxHU5BojkO0AIqK0AgAUECE/gC6JWyMpDDSAj26dd2gbak/DL+rpkoP+8EKus7Dzy6adGF62yxlnLOCz1ebKe7zhfJDtSCIzudXlJVK2dYfZWfpJqks3+5rX2xwU9a9paUFXutCwYL9pFf/ISGFhNas/VIISUVo/EljaZEIgI2VFlisHkcrIxpIjmPYz7333quFeyDhe8EFF+gweKiWPjfcjLJZsQOoF6Jo0KtgkTkfzsjLL7+sUw9btmzRRvrEE0/UIXoTCTDHxoL5/i6//HL9fWP2ARwApA9Cfe+FAweU/uelf8y+feaDhfNUWmD9t2vyIRAEjPFE+Lytyu97sfThogH4GkLzuV16qrx/lexG7l8djM4Dnbd3O9GqDaiu2qmNft1ua2dauVSmbZPc/C66BsErmGUQSkjo8jsmUD+ApBw0/iQetLgDYPA7AnNNWkAZ0HyE5pEDh8FDKx20AjACOJoCQfu5c8Kf2R+N8bcHHiFV8P777we+tnTpUt1/i5bGeHQgmPuE0fdSN2De8+qLLyju1qFdyZXX3TgiPTOz0PT7I3xeVb7DZ1zr6iQtTBV+WqBNMIJAECr8EQVwRAIaXlTsCkBlpCuCjb85Rnbr1EJmVo7vlHAdCIGndYGJg6g92P7DWu0IGOxBQyMPG0tHgCQ1NP4kXiSMA2CwZYXPPvvswsGDB+ejQG/o0KEyfPhwT9ew0wcmH2+v+t0cgWgwRvnPf/6z3HfffbqQcI899tAFhF6NP+4FEQ5U9yOqYQoP4wG+37MnnVX6v5LVC56b/8KS738snZSekZGPPH/E4T9+g7+7tlYb6VoUPyIPr3LwWPGnxerYBNUkpGkZYEgK19bUBB3TBvoAOe3DGn/UGeDe4MzotkB/5AGOTVt13fxeBdK+a8+g+gDA+gCS7ND4k3iScA6AwcgKH3/88UVqK/R6nmnRw2oc+XNU3kNdEMV0MNLREipyAA455BD561//qt/TDBnyAtr57rzzTh3dQA0BzoW+wIIFC+ImfwwnAAWOF198MSIrM/9035zhr7/17rDtO8pCvkFdwPjvkrItG7VxNsWElTu2qdx+jrRTKQQv36db5KD+dZ1yJtpKXtfeygmoUOmDGm3woVyYkZmtOwnCXbNaGf6d27cGfW13Wo3UVKEeo1baqZSAqQ/I772n/PDN5wEpYgoJkWSFxp/EmxYtAoyEY+ywJ1lhVOvDQL355pvyzjvv6FU2VAJff/11/fVoQ/2hdAJMUZ9xELxc11TzA6Q0kEYwg4Y+++wzHUmIV5GjoXv37nr7083XLv3rzNtDSgqD+ur+6oDgjpHoxde0QyCRhw2KX1EQK/WgY+uCn/rmC7STrNwOesNzN+NvDzg0o4jd1AhBrX98stngCPTZ/2DpppwBt0JB6gd4JycrV0jLQONPmoKEjQDYRCMrDGCMb7rpJhk9erSW7kX6AMp7XjAGH+I7OHefffbRBtS0/jkNvV3wFwlzLEL+iABAHhjvgWp/FBAiDeDFkcC9YZb3Rx99JN26ddO1EehiCAeue/DggWElhQ1Y6dft7iRVFWV6dY6UQRt17+06dPZUPFijVvXV5WV6NV6nNtQIIDSfkVlfJ5DmEB5KC+NU2MdCcRBFf+hugJNi1xEggpDdId+1rRD1Adi2rF0tOzat56AhkjS4GP/LxLcoIqRRJIUDYLDrA5QhLYpkLFEwiM0Ldt3An/70Jy22Y3r7kUowfffhzgt1XbcUAtIHcEzMPq+RCWgDnHDCCbJy5cqAkiFSCChIRLeAF6ZMOj2kpLAhKzdP5+JFGdg6HQFoE9721/mK8ZCbL/dX95v0AeoIEJ7P7dTN7wS4VRU6Lhem+DBN5fs7dOutV/u1ysEQ/IzVvxPSCuFqFBA9aJuTq+sDICtsTyiEEwBVwVHDx1FIiCQMLsb/bPG1ThPSaBI6BRAK1Adg2mBtbW1xPELmdicA8vnfffddYHof9r/99tthz3W7ln3NUNMJnZP/IoH7Qf0A2g6dGglIIxhNgnD3alIQeB5WUlh8Pfxp6b77jLjw9/f8I01gVuV2+L/OHw0QI1IQYsUfCN+rY3GPDToF/O8FtA5BVo52VBDqh5MSEpNCwL9JeobuFoC0MCSGDUgLoFAQ+gGcOFjPxs3fSzKyrXyrbNj8nSQrNP6kqUmqCICNpR8A4zUebYOxtt7ZLYGoIYA08EknnaRX2QMHDtQhdqM2GOpccz4M8Ycffqhz+kg7IIWAEL/5emM6EOAsQK4YqQN8OKC+AbMFjjvuuLAjlG1nBCkHaBesWLFCRw6OOuqo0kfvuW3BrDl/b5SksCGrfQdtoKt2Qnhol3qaplfsiCggxx8w/A1W/L4vVO3coav7sarHvjaZbSVLrdrRNeBGUKti+OYGTY6KQpRv3qjrCIwjgNqAyrJS2b0reNDQi4uelGvPv5tpgSSjRv3bfvntZ7L6+5WSrND4k+YgaR0Ag3/M5T1qxV6oDFyReJAVDtcOaL6G+gFsXrCLBc8//3xddGj2IQXx73//W+f9zbHRGH7n8XBEkO83LZEmTRHqmnZEAB0RP//5z3UEwXzPqCXAGGXl9BT/6tTxK2+7d/bwUGkBs3APPyNA5ehzO0p2+45SV1vrTx/4xxKnifvKX2sUpOlhQhXbHNX9Kte/s7RKOwOYC9DgvdPC2v36w/yFAZhumNetl25BxA2jFqB9l+46NVG2daOUWkJCa77/Ug8aYn1AcgDDD6O/+vsv9PNkhcafNBdJmQJwQxlGIyu8NNxxRk7Yrbo/2pC8wVzLTPuzhwHBYDvnAni5nnNzu09z/XDXdDo5aDO0ZxZgHyIBeN27Z/cgSeEGF/OH7xGWdwvNB4yzEQnCjAG1+k9z+ZqYyn5/O4BvsmCda3W/TkVI/XyDcEBKuLpip95qtZFveI+4XqZa9fs6EPL0rAGkD/K69NSywp167Rl0DuoD4AjMe2U2dfETlM3bfpAlH7+kV/4w/rkqYgSnbWzRREkmaPxJc5L0EQAbf1rgVWVI4AQUqS2gHwADh+p5tN/hEWF56AOAaIrw3DAGGe+B9MEZZ5yhp/fBsI4bN86zUwHJ40cffVSnEKBZgGK/448/PvAejbk/bEgfLFy4UEsfQ4AI6Qq8B9IHNpg0+N4r/5z9x3seLERaoHS7Ly1QXb5dqvxT+fSoXhWex0o/IytEYZ8hzWWHY+UOw6wFgJSFr64s1+F4nT5IVw4KWgTb5QaOcwNSxBU7SnWxYZ3lJUC8qF3HzsrIZze8j7SG94dagvzeFBJKFmD4v/x2uWwq/SGw77DBI+XcU66U7p17y9xXHpRkYebMmbrY2ILGnzQpKeUAGKz6gBLxywpj5f+Xv/xFbrvttkBxH5T8MKY3WuywvJsOAByLSKF55/VQ3X/sscfqvL7Zh1QChIbgRJhIgNcZCM77NPTv31//DACuZSslOsGkwZ8ffWTJHX95YMTS9z8ohIGtq2/I18a2VhnevO591PkeAvGha/80On3Q3qcJoEIM/iW/b8RwuKJBHFZRtl3M3APfxXzvhzHHVWXbJKNTW1+RoC1JHOY+0zN9QkIdevTRQkL2fAEjJHSOMjLDlLFpLWRmtJVEwS3Pf+C+B8uE46bIwH0PkWQDQmXTpk2zd9H4kyYnJR0Ag9U2OFytxoerFXA+evphbLEaxiCgaFb/kVr+7OtEM6wIYNAPVv0bNmwIqBlCbhhFiHhtpxLczrfrGuxxxG71Dqag0RQ9huPQoQNL//nIfQteePHlJedfNHVS9a5d+bYYUFp6hq9gT1fgh58vUIe+ffyvttY3LTCE0+Ar6PPfr8sqvcGxgpV+hlS7iQ6ZFEJgeEFwi2F9sKBOzyCA7oF2tDIzJV2lCNAlEGrQ0O0PX96q6gMyVTSlpXHL8yPcf87JVyVtVIbGn7QUKe0AGNSH/1LlBKw888wzi/7v//6vsLS0VBvcaFboOOf++++XzZs3S5cuXeScc87REwAjRQMiYY6FIX7ttdd0igKT/2D0MfbXTD90XtPpiED1ECHEjz/+OJDewAdLOIniaO5zzPGjSz/6z6KZl19z/fBPPv9i2PYd5fkIl2P0b33vfQjjr+61YvtWHdrXeX59aBvJUiH/7Pb5IR2BaNBRA3VN3duvFQhrlXOSKW1Vrj9LpSlMNMGoGtrU1lTKzm1b6ucS+KMHuj4iL1/XCeR29gkJla4rkW0bv6eQUAuAcP8nX74nO9XvEYDhHzNioowdeYbktsuTZITGn7QkrcIBAPbY4Z49e05Qz3t6Oc8Uy1122WXyj3/8I1A4+MYbb8grr7wSdFw0kQQ3RUFwzDHHBI6JFEUwq304DJMmTdLpA5yDCEdxcbHk5eXJDTfcIF4wUYZw74VBR/948vGlHxSvWPmnWQ+M+PDTzwsjiQPBmPqK8soD6QOfUvBuqSzfrkcTt0E0wEsGwUQd3ASC1P3BCUC9QJ26Nl7rQkW9+g8vLIR7CxpK5L9v/BtUlm+TzOx2unsAhKoPMEJCY0Yqg1R0hqQSG7esl5bELc8/UjlcE46/UOf5kxUaf9LSpEwXgFf88wVQGYQZAxHnC5gwOdrnkDIwk/vOOuusoOO8zgKAoTXXjSQQFA5bYAjRjFGjRgWt9rHP1A64zTKwvz98HUWB0C6AToCpkQh1j4cWDix9RqUFrvjNufM65uUF/wztMLzf4KLivsEqX71MT/dNF/QZ6NDVAYgg1FRW6F59bHiONIITowVgIhJ4T3tscYPr+jsR0u3ctv8a5pyMjCytY1BnH5+ZLV323E/6DjxMRzAMSAs88uxdFBKKEwjxF6sV/38+fT1g/JHnv+WSh+WSM6fT+BPSSFpNBMCJLSssvo6BBphVOB4nTpyoNyjxGUOLr5l8fTgwiAhSvajyR3j+17/+tYwZM0ZfJ9SMAS/Y56FY8KKLLtIdDkhXQCsAKYpw1zadETfeeKM89thjWkkQx+Ier7vuOjnvvPNCngd+e+5ZK7EFSQq7rbLTMySvax/d57/bn7fFfACM7zW5/lC1A+gGKN/qE+4xg4l8RXqZPhGfzAiFaabNsC50GyG6D9LVdSAP7FMfrNWvcY8+AaK0oPkC5hpIgXTpu5ds3fCdOndrIC1gCgUXqajAxWdMZ1ogStzy/PgZnnZcanRf0PiTRKHVOgAGM3a4tra2SD0vDKXUZ56jz9/O+YcqCjRfg4MAY4rcPIATgFHFn3/+uS76c9YPOK/hvA+3Y020wMwWsAmlDAjgfOBe5syZExSZQCoB7YynnnpqyPHE9n3fe+uNiz/45YnFd9378IiPln8eaL0MhOylPkRvyQBIuJ4AbbDVY2XZNnWfjvC8iHYIqlQKIb1jV4mIixaAY48uSszt3EO/sXZG/I5GOOEjuAVVO8t0HQQ2ODjaifA7AkgJUEgoOjZsXisrvvkwbnn+Hze3bPrCCY0/SSRavQMArPqApTU1NRMyMzODrF4oI43noYR4zLH4OtIFCLFjg0G98MILA/LA4Vbn5hpYmSPPj3NNUaCbwxBt8SEcBygVotjQrm9A+uCUU04JRDjM8fZsA1N/gK9DVlilD0rPOunYBfkdcr/98LMvAtoBfjsqZiluDKpPUyitwapaHMdiBW6KB412QJ2/QC8ru31gZR4qx79bpQpq1Pm+CEKd1gWAAFC6I3JQL1RkXSTNvazR7iDIbJcju2p8PyN0DCAqAMcEm8EUCk44fgoHDYUg3nl+/LznvTxbR2MMO1tYxInGnyQadAAslCOAqi4tK6ycgCLnfAGn7r/TINqY1AH2Q2tgypQpOtyOCIIptvOi4PfII49ovQIIC+F6EO1BHz8cCLcIgdtwIjeMscf9PPzww7rIcfXq1XofJhWiXdKoDbpFILDBKZk6daq88MILgfuAIuOks89eWdu24/B/LfnPiHoPwC03YD1NC/6CMeiYBdChWx+fOFDNLl/tgNqHIUBt0v33FcL419ZUSdmWH7UTEHg/dWxl+nZpl9dJdyGEI+BUhNAOwNcgTwyjj0gF3iddpTtw3bQefaVi2xYKCUUAIf7P1Yr/fz+sDuxrTD//iq8/1IYf0RcnZdb0x+aGxp8kInQAXIARg4gQ9APUy+Fmf6RwvzPfbjsH2LCyNvu9AKU+UztgroOV+tlnnx3I79s4V+n2frOF6lYoLCzUm60hEO4+cR3cF+ob7GMRrXj+2Wcr//Of/yw+58zTiqf+7venbfxxU88QM4DqjavDyNrFe5AUzs7pICEFfNz21/kGEu22iwWNhlHtbqmpKNdDhkJeNKB3VBfQEnCLMqDQUKcPOnUPfBNpfo8E44/bd+khP377pauQ0MVnTZeB+ySfaE08iHee383wo/0TBahlm31Rhfc/W6T+O12aGxp/kqjQAQiBU1ZYGbxCYxztqnqEwDFcx9YVcDO2zoiB2Wc/AvvruB5y8VdccYUu7MNrGH+E7d3mCzgjEjDGqOpHiL5nz55aBRCdDG6RA1uPIBImtYGag1/96lfyt7/9Tb8XgGOCaAciFHvskVH67sv/mH3bPQ8UPrPw1RHbHZMGdXi+Yqf6eVZLGib/qWtmaV2BdJd/EPGMMdTZuXlSW12pQvQ1QdfBfAJIGIfULfAb/11VO7WuAHL6+JnpwkBMJ8ztGNTVEHAKAimN+q9BRyCUkNCNM89vlfUB36nVPlT84pHndzP8mO7YpUffynGn/N+yNhWllbMffPBY7MccB3RnNGf0hcafJDJ0ACJgyworo1ekjL82YnACsPrFH7jpv0cV/tVXX63PM90BXsL8oY7De6CaX62m9XNTbxBJIwDHoFsB2gAIzxuDD6N833336Q6EaCSFQ4GahHvvvVf/DDA6GWD8sR2dwH1ff/lFxccdM7LktlkPjPioeHkhDCym/GH6nh4s5K+2S1MGAbK9GMrTJj0zKqPvBoSAIN5TU12h0gG7tPYADHiGSh9EEh/yTSbcEtSeuLu2QssN16p/25xOXS0BJPOGwS9t3QLcB7oWtv+wVjsCBlMfAO2AMUUTE9IR6N65l9YC2Fa2VX7SQ2ImVJ4fuv3RGv6Nm1Uk5cmbGxj+7n33qhx93Ohl11128dK9CvaoXLZsWb5xAMAjz94p/fr0l35995OmxmH88TlymdD4kwSCDoBHbFlhZVCHwxFA7hyGzxj7l156Sa688kp9PIx1KEMdKncfShzIeZ1Ixh/3g3oDOCh2dAEyw7hHOACR8NqBgOcw+HBUwl0HA4aemXPvgo8/+++Sc6ZeM+nHDTvyd9f6780qqkN4HqN6M9tlerf/YdIHaDPMzMoVzAKKBsgC11ntA4EWQrXVVFfWKxqGuB+f2FG9c4MbbJOeEVJIaOHiJ2WZClEnYn1Av74DtAOwvXxrTOdjpb9KrfjjkeeH4cdURjhNhjbq76Fz372laOQxxTP/cMNr3bt3rTS/o4cffnjpvvvuW/LVV18V4DWiAJffMUFHXkYOH9tkKRgX4z9SbcVCSAJBByBKjKywMsJFygEo/Pvf/y6ffvqpni1w+umnB6rrI8n3mgFAMMrQA0B43k4f2Dj1/UNhh/8R8p83b57+IEIBIc4dP368XHPNNWGvYe4RKQc4EGoFJT169ND1ARAbslMUoQok7euY5+brcASKFy2cedX024bPn79g2KaNG/N9MwT0D1cZ6lytDxBJGRAFflDwg7MA+4riO4T122RkNtAUSPPsSdSv2lHct3tXrUofVPpVAOoC32e7DvkNV//W+Xi/GpU6QItgrc5v1+m0BvLRUCrM8A8ayu+9px40VO0vTrPrAxLJEYCxhnOClfvOqnLJycr1dF6oPP85J0c/RKl85w55cclTsnDRk4GRzDD8KBAddNBhJffcNm0BfrfM8fbvnHICXlMOQFD7hYm8oMMATkg4Z6CkpESigcafJAuNDLK2bpQjgHTAeLUVmCiAl9A6jPmDDz6oPyhMbv/MM8+UO++8Uw8ACjehzyac/LBdX2C6D0I5GM5zUN1/0kkn6bHE5n7hpCC3j6LE3R5lj40OgvmZOH82KhqQf9uM+0Ys/eijwjZqpQ4j2SY9Pew1YWBrVUi/vHSTIIJgSfzrx/adumvp3kjXiOQUaEdgd62uH6jdVa3VCHULobq20/gHSRSj+NAlfWBAHUH7zj0CCojAWR9ggJGEsWyKtMCsJ2+SRUt9aoUXnzldr4hDAYMLdUM89ur6Ezn0gKMlEvHK87safuXsdezeRwYfMqzk/F+dvuSX444vsWtXzO8x0nbp6emLlUNYIr7Q+6Rw72WcAcg5I7UAVUcA537NmjXiBRp/kkwwAtAI/PUBj6kPmkLUB6jn+ZHOMcWAS5Ys0Xl6s6LGMB/bUEcy7nbhn8FtRY5HOBXmuReHAduqVasC6QTziPkCuGdoEXj5HkPdqx0NeObR+xbc/+iTXz78t7nHbnMUCbphZINN+iCg8Cc+J8CnNNgu0mX8cwJEq/7BoLi+j3JIMrLSdW7ZUdvnck/14kV66qGL8dfH1e6SIDUkf30Atu0b1+pBQ8YRwKobW0sXCsJgn3b8hdogrt/0nc7j77fnINdj45XndzP8GOec1b6DHDh0WMllF/9myeknjSlxylzjNQx/ZmamMfyGyWrD65tDvSciMCYyYIMIAIZ0FRUVSTho/EmywQhAHAknK2wwRhCiQHPnztUri27dumkxHqw0IrXg4XycO3/+fP2I46ENgOK7cGkCr6t2XAMbugdQ4wClQDgl6DyAoiEK/0I5EuZ7w0wBcy7qAzBECHoBGG1s34fzGkGSwmGAca3asU2H2DH4B6CoD0I87fLywy7vYZch0lNTuVOlEar9zkOa7j5ACiEtQgQi/H35H/X0wy1agMj2A3SaomMnLUTkJn2MY3dVVcimb7/UugI2WJ2OGj4ubkJC0UQADDfOOj9QdJejUjU9u/xEOrbvpF+jQHDD5u8CK34Qa55/4eKndBqk3BLuQVqoQ5fupceP/vmSh/4yq9geaW2NtS5Rm9PwOykQ39/oJInwtxp0kvrbXLRokX50AgcB3TlwEvzQ+JOkgA5AnPGnBYrUVhjqGKcxNsN3vIT9cezPfvYzHTEwBhcffvhwGj7cJ1ngJXVgrhXqPe1hQE6DHer6uN77778vp512mq5vMOB4yB6//fbbujYh3DV0WsDfLSAegBE3K/i0CN83DGz1zu2yc5uvmC3NMSMAcr45+V1CziXwXURcdQucx/iK/+p0MaGWF1b3iPB/qGub+6hUjk2FX04YssLoRrCBIxCP+oBYHAAYZIgZvagMdDhiNfxu6n0YttT9J3tVjjt+9JIbr5661GhpABMpC7Hi90KB+P5Wp0qYv9fAwcr4Y4U/ZMgQ7QgjIvb4449rZ9yCxp8kDUwBxBl77LD6cJqsnue7FfXZRNOShxC881oIyaOY0BApfWCH4kM5AbaWQaRr2teFM4LIhDnXnIcUggnXhruO6RaYfuesb/+58OURZeWV+eHscXpmZN0Cm7S09HpJYf++gN6/GScYgsA44926XUE/ol0xMDsg8CY+OSBcDyvXiDUHlhNizodTg7ZBnI9ognPQEFbImIrXnGkBhPDPPeUqXZuAQUerv/9SStau0vn9bp17yaB9DpHD1NeiNfxuvfwo8Ou11/6VJ44/Zdn1l01Z2rN7t0CBhJUiK1G/V4vbtWtXIrFRIr7aAGwF4qvnmep/3vBgtdKfPHmyRLjeSULjT5IERgCaGGWwC9UHVJG4OALRYowxjP2rr74qn3zyiQ6xn3jiiTq87mWFDs0ChOfxYYbrnXHGGXL00UcH1Qk09h7ffPNNefLJJ3UKACu2AQMGyFVXXaU7HdwUE+1z0Xlwyy236PuDEuLurA5FuZ26jshUIee0Rvy2BvLz6n/VKr9sKvTNihyGFvLAIYsQ/at6n85/ma4d0KSJDuljperrQIh4K2EdAr3yV+F/dDhoR0N8x6IuAJEBHVGwiLU+IJYIQLwJZfi79elXedLJpyy78epLl/bu2SPoG/Y7rCUSOdTfGBANuFRtSEcVeDxnsfiMf8QR44QkCnQAmgF/WqBQGbiicCI+TmXAcBoCIFIhoA0+OGFQjz32WB2mt49HZT/mFYQ7P9z9hhIxMqOOjSZCuHvEsagd+PnPf66LIU10Ao+Z2dn5/QYNO7GieleBhMFLdb85TptzbcTTtBOQ5uH7RrvezhDV/Wjxy+3cTReqeXnvUNLCdf5phKgj2OWvUcA14Vzo2QabNgQJCRkwaGjkYWM9OwIt6QCE0utv37m7/Gz0CcU3XXPlErulD5gVvzSt4XcDzsCjEjpFsFh8+sKLhZAkgymAZsCfFliMscP+QsEGHybG2JlHr/32ofbZ2MYXOXjbcYBxNiN/vRYJwkAj7WAGHrmlEOxhSF6vjVZD3Auubxc0duvcufSlp+Y8/tT8lwufWfDKCGe3gG2Pd0NZsBadAGl6Ne9m2H3hdvX1NhmeXWA9gVCF5YNMv5VKgJGObPzRvVAjtVXV6mJp+vj0tln1Pxvr4rjvTKgXWfeHoUOhhISSYdCQm3of0NK9XXuUzJw187XTTj5xg/O82tpau52vuUE4/yDxpQeK1DZEfKH+T/1fWyyEJCmMALQAyhAMUA+j1ZZvDL5pvZs9e7bOoQP04qPCHzQ2NA+MJgBmAyBMj/QBwv8IzdvG3A3c53PPPaelhHGfyOkfeeSRujMAHQIG+z6j0UYwQFnx6aef1kWOuD/cG4oKkeIAziLBgPGv262L5qpU6FxMZ4Cy9BkqdZDToXNE6V8v6Cr96godCUC1PjwJ1BQgfZDdvoOrsxGINqgnO0s36VC+HUGAk4LOhbaYTOhPM6RFFCkQ/ZeLdMD6VZ820A9AoeA5p4QX22nOCICbeh9AuD+/S/eS/v33WXLnH28tQRGrw2EskeZf8RPSaqAD0IJAP0B8q4p8DNNBdT/C86Z4Dgbwtddek8GDBzdYUYfCnBsuzeD8uh11cGKMONQEDz30UC1cZN8HjP/zzz8fGIbkdq7z3r2kLPDzMLMP3IAjcO7UayYhGgB7ipY7iAOJPXbQX92XrYxru46dxQuR0gh2LYGe+4eQfZvwlf2+1sNSqdi+reFBaT5HpUP3vv4ogoR586AgQUQhoXD1Ac3hALj18gMY/oFDDi657IpLl0w4aXyJcwBVC4X6CWl1MAXQgmC+AFqY1NMiZSQLUcyH1iJjOGFc0d9vpwbcsBX37ImFoWSFo+lCMMYbIX8U86Gwz16l4R7dRhPb92YMPu4RjgR0BXA9Iyjk5tggHRAO5Ig/WbRw5h/veVClBV4asWVXdT5C9Lt37QoY/zS/cc1slxuybS8ofYDwvM67t9FGHZK9znMCgkB1ab5Lhoks2JX96RlZOkJQt9sxUroOof0s634aRgDMNXbvqvbPKPB1GfhUCTMCQkKl60pkx5YfAo6AEbVpbiGhUIYf9N5zr9ILpvx6yc3XXhmolLf+/XVI3Z8yI4Q0MYwAJAgoFFS5ztGbN28egBB79+7dtYCOya+HW9HD2EO2d+bMmTq8D+OJuQQo7DPnNnb6H94DqQncGwRPYMSRArDD/06MIwMwMhhSx3AAcK1DDjlELr74Yp3isJUPY0l1mLTA+x9+XKjnA1RVacMMhwCh9YyMtmF/07VwD3ruleHyR+y19W6T3kbyuvaSNm1iFwcyS3Y86PkFKn2AiYJaCljQfZArWbl5YYsQcX+IbujzxJYeTlORjU6S1a69Lx7hTws46wMA0gKQuMXUQdAUEYBwhr9D526V408+Zdltt0xrUNkvNPyEtAh0ABIMOy0QrsreBuHyESNGyMcff6xf4zw4AQsWLNADfLxcw0tYfrdj9RrpmsYBgOOw//776y4EI3qEsC8iBxh1bBydcO9ppy1C3evTz79Y8KdZs0/0Iils0LMFaiqVwdwYHA7wk5WrohUdutRrBYS5TkBYCDvSIhy3uz7XYFIKwSfVv9bV/5t/cO0+QA1BXrfe0sYUIPovAUdg83ff6LoDGyMktOLrD+LqALip9+n7a5NeOU4Z/pkzZyzdo3dvGn6SaECfur/aevmf44+iTFoJdAASFH+3AKT9Ig6yhUFEgR4m/UEjAIZy3Lhxctttt2njGgkYZRhrnAuD2rt378BqvDHFh3BMcD7Ei2688UZ56KGHAvcLB+Dyyy/XPf8glC6AuT+0CEKeGKAgEHURtlNgn+9VUjjwPrW1Ur71Rz1Z0AbGNbdTV11975ZCMAV+RvGvRp2fJr7IAVQF08JEDoIchjRf3aKZaQDMzANcr7Z2l6+A0HF/OAbv065DZz322M1BCVUfAFEfY6z79d1PiwpFo9VvcFPv891bG8g0Lxk7duzSp556qhLpHuvfiIaftCQw9siHwfA7f+nxR7FYbeulFUAHIIHxKitsHmFwUeWP1T+EfcK14Nl5+X/84x9y6623yurVq7VBhYF94oknIgr3RMIU8hm+/vprnT5AegP1BGYEstu9mf0oOrzssst0CsFujcRoY8iw4nt1+z6jlRSuU05AbW2N1FRWaMML3X7UDoSdTljnGyZU5uI86PB8fhc93jhS5MB3vOVQWH+W5tlu9T5IAdQqQ75bHdNGjxfOkgz/aN5Q74H0QdnWjcqB2Ky7JIyioBN0DCAS4NUJCNXLD1S0p3jg4MIlx4/+RSlmXPhrPSrVv89KoeEnzQ8+hGDwC9S2p9qy7C927dRLhhUeI7269pSnXnpARSp1AOAj/5bS0AFIAuAIQFZYbflexYHs/eGEejD69/DDDw+SEsZ7nHrqqdrAejX8TolhAOfCVPJHmz4w10Rtw8iRI7UzYZ+LbeHChTrFEc5B+eM99xf+Y8HLI7ZtL9NpgbQ4/8ZjqBAcgKAZAeJ7jsgBxhPrdkH/PicBYSB0FATX+LuIBAWe1R8VYfDRbqQPtvyg9RFg/H1Khttdj480ZwA5/jffXyjvf7bI1fDvu+++JSqqs+SCCy4owWv/vzsM/1L1cqm610ohpHnoIr6VfoH4jH8QB+w9VAb1P0QO3PdQ9XhoYP/GLevl+lnnqLSlDgCsUtu7aquW2IFHXdXIazQZdACSCGVQdX2A+iDNb2xRn22QVYhW/vznPwdC7Cjsgx7BAQccEPE6cCJQ2AcHYsuWLXLEEUfoAkHzNdsBiDaKYOoFLrroInnkkUcC5+N7P/PMM7WCoSO0HHQugOOA1sqpKi2wedv2EekZmWrVnBM3RwBdBzu3bVarc59tM9fFCj27QyetERDSSOvsART/VPpg506/rgC6FtpLemamhHIC7NRBKMzX8fOrUKv/auWoBO4ZcsPl26S6fIfruYgCIC0Ah8CAFT/6+d3o1KlT6VVXXfXaddddt9LajR8IDT9pLmBoTWi/wSo/J6e9DNr7YBk04DA5+pBxkpcbOtK1U/1dzHnuTj3vQnwpgVjqAhB1OFhtg/zXeFoSEDoASYaKBmQr4zYcssJepgeGwx7WY4YMoVAPIXqvK/Q//elPurofqQfTLgghn+OPP15fCyH6eDgr6D5AiyQcir322kvXAIRKHxjnBsYfY1oxrQ3H1qWl57fLyx/RNrdDYY7K7aenx6ELts5U+Ff60gB1dbr7ICM7J+LPEOF5SAvX7qrWjoRpAYSTkpXbQef3G/sXqqMGyslAHQHEi5DqQG0CFAhRt4DRw7jf6p3R1z2pf9vKMWPGLFP//ksLCgqMkafhJ82BWeF3lfoCviCwyu+3x4EybNDRQat8r8x96X6Z94quW8LqfbH4hKm8gPspsu5pi9r+KQkIHYAkxUt9AHCO9Y1Ube/VoUB4H+kDzBZAbt+OKMD4P/PMM4EiPS8OgFPnINyqPtL1zL0gojFs2DB9r2a/mS0w4hfjhm0tryrYuGlTz1DXsUPuaUb31wshNAecx0B3YLsKNcIA+2YD2AqBmboAMc1DqCJQRyASslsh0gAibG6qgiGozM3NXfbyyy8vPfLIIyv9/1Y0/KQpwEoahhQGH8a+s/95lvNAk8vv13dfOWzgyLCrfK8sK35T5sy/06QEItUFwPBj1W+nHFb4z6mSBIQOQJJjywrb+40RxPQ/rJ6hsY9VsynKi0fkAEBSGBEA5OoR+i8sLJQ77rhDF/k5awCc74kCvxdeeEHfY0VFhR4EhHs0swkac5/m/tB5cO+992qJYVwL9zhlyhTdlYDoxLqNP2a//d4HPdd8tzZ/3fofOhprumHjpk47tm+T5cs/y95VVZUF04qBPNm5HfLzu3SRqqqq7Kqq6ogdGm4ETyYs08V59ca/TtcOIAKAAUN1/j9RN+OtBaC0roAJ76dJ2+x2KnLQ3tNwIzdwLygYxLREM3kQhY743pWjUqk8hWWdunRaeudtt1VOmDABzhgNf+vGGOe2/g1U+7cq67lhR4jr4NwC//WwtbeeNwAh/YJe/fUKf9DeB8kBKpcfD4PvhqMuoER8dQFljvtGR4Ft+JEvg+FP6G4COgApglM/ABuM3IMPPhgI76PqHitzqAs2Nn0AjAiRMe4IuZv8v3kdSs4XXzvhhBPk3XffDYpSoGr8r3/9a0AlsLH3CFCbgHQERgyjrsF0SISLMiClcdxxx2nHxgbnwqFADYJh3YYfsjds3KydgS+/WR3wXraWbssu3bYNbQqinQs/G374sVOdqPB/eWV2RVVlVt2uWtlVWy3btu/Ih4BRTW2dci5qsl1X/0YOuK5Wyrb8KLtqqoK+plsDc/J0a2C86hzaZmZUHjZ4/2XHjDh8affOnSshAKX+fVjc13qB0UNu262NLhJwAFBcZ6+k8aExNtS1sLLfu29/6dp1D72636vPvupxf2lOUBcw7+UH5IUlT+Elvof3xGfw95XgaERSGH4DpYBTBFtWWH0wF8KQofjNGH8YOxhAhMWxOveKMYhurXbOlAKMoyFcSgFfQ9EgUgfGgTDg/ozjECldYd9HOCEjzClAVAG1DZEcH3MtRAzw83J+DY7EunXrgtIRULYz6nZmjK0dJTHHOe/flnA2GClnc59O5wLnoHBwzZpvs2fcdUd2dUWlpGVkdEwTyBdjyGB6p9z8dBly4ADZuqPM73TUydZt27Vj4oxc2F0I4i8uzM5uW9mxQ8fSAfvuVXLsyKO+PO3E40sszQWu+Fs3MPxDxTJ6MNDIsXfv3FO6de2r/n53yI6ybVJWWaH+XrbJD5vWBk7eWVWWV7J2FcLkcB5Mcd0h4jf+B6jroAulfVZ7ZeT7S7t2HZtsZR8NOeoeDhkyUj775mMpWbsSN/QLxyFJZfgNjACkIEZWeM2aNQNQ4a8e9Yr6qKOO0u19Xgv8UHQH7X8YdoTmsXoOpy3gPB/GzU3T30QOkD5AJT9SFHiN4j7oEWAqXKh2RxNtwLXvueceWb9+va5FwPcG8SMYeTgPsXQdODH6CKY7Aj8H/PwgsGS6D9zu03RGoJMCEQ44YXvssYecccYZQdLHdt2Dc1hSqGvbTgXuD90bEEkyBhopGIgrFRUVBY5zuw7UGe+488/Z/3z2eeUQVOjvbeSoUXLJJb+t3Ldfv0qXc2j4ycH+TTNy2Di1jY26wM5RXIdogB71CUfi1qkPS/eukcXLmgOs+pd/9YEs/+YTWbTseaMP4KREbUskQXP8kaADkMKgbTA9Pb0I+gHheuWdwDBdddVVOn1gjBQMBHQBjjnmGFf1PTdsIaBw4Xaz6jUKgaHuyfq+tDYAwvPmuvj60KFD5Y033tCr/Xg4AACpAHwfWPXDQTGpiXAOipFmxlwG+75xLsYnX3311UEDnpzG3x7qFCqCYkAdBX4ecKKg4FhQUKD3h3PUcDxGLL/44ouB+wD42Y8ePVqeffZZ4YqfOECYfqJ5cclZv9cOQKx8vuoDueepm0xePS7XbCy2wV/z/Ur5r7pHJ3BS2ud2RBTA7PqXeO8OSDiYAkhh1Ac6JFeL/bLCqBEIq5FvTxCEETPV8yb0DWMIbAneUDjD9G4pAduRiGSsjYNgNtuwmq/DGBqDFu7+7HPd5gvY9wnHBxvmFoQbm2yfgxU/fn7OezSzEUxxpHlf2wnA/ZjjjPgRntu1FPb7w9nB6549ewZ9H+FaJPFvic0+3vxc8P74Wvv27Wn4ic0h5slpx13QaEN9oIoaPDztFd1rv3zVh1qUpzmNP4z9+q1rZaUK6X/zvy+V0f8gyBmxMaJBw1QKALUH18863/7yZkliGAFoJUQjK2yez507Vz766CNtAKEW+Itf/MLTqhrhbxTyITQNw4XVMCrGcR0vzkM4jBGDbDEiEhiABIOL1fn111+vV8BuK2d7rgBqDxA6RwQBRhYph1/+8pd69QuiiZaEukekTlAsiPtDESJW50hR3HzzzYGfgbNF09wjVvPTp0/XPz/UISCsj1HRmJ1gIhCx3pd5xM8PqQJEAVC4CacDBZhXXHFFpfpZ0vATJ2PEX+U+e9qLCROm98LGTWtlzdpVsmnbem3s13y/yl7BNwDdBQcOGBayu+CMq4806QD85ylJYugAtDL8jsBkkxYIRbiiunDAoKJ6Hrlvu4Bw4sSJ8uijj8Z0zXD3Z6IBxuiHW/kCRAkOPvhgHdJ3fo9LlizRzoCX+gZzjpfjsKJ2ruCdugf26hwOE5wAZ1Ri8uTJ8sADD8RFWMl2PFCQqSIIyPvT8JNQaAeghwqBP3jLK5JowMj/sGW9bNy6Xhn7r3TxIQz9xi1rQ+XuNbZC4B7K8Bf0GRC26HDN2i/k8ttPNy9LxJcCSFqYAmhl+Aex3IP6gNraWi0r7CWsHQnbWNktfMY4YwVsKt6jGf1rG0pnB4IhVKuh81hzXRQKmtkHxghiFWwclnD1A6ZrweT6bc2CUO+La9tFf2YOAwok7VZJ++fljAzgGKdCo9t9mn1wJBAZQdTF+TO3f55qq+zbty8NP4lEs4/IRZi+rGKb7KjcocPzZVVlusNg/aYNAQNfVrktZOjeielW2HuP/aRrx166yyDaSMZ/VwW1BZdIksMIQCunpqamSHypgUaH5g0w9C+//LK8/fbb2vgdeuihWh0w3PXN+Wi/Q/rg1Vdf1e17hxxyiB5zDONnjFtjowfoGoBA0PLly3VEALoIF198sX4MVTxn7g+FfQjPv/POO/r7gbbCpEmTdHeAPZnQ7fuzIyJ2GsA+Bl8z6Q2kEZACQFoDmgnnnXde2CJEgPQG9B8wdRGpB9wffobotrAnRAqL+0h0QOVOT4n62x1vh10lz31ltlqRfy9eKavaIeVqlb5z5w5t0IFXo+5EF+ll50m/PQYE2hKhG9C1U9+4tBPePucyWVa8yLx8DrcqSQwdAGLaBosgJhTP8LIxcl6Ntl2dboMBQ6jut4vlQoX6o4lYOEPsob53s+rHqhrthnBSzLnGiL/00ku6Q8JLWsWOBtgOhyn+szc7EmDODdeBADVFOA7mns3qH+qHyPlDv58CPiRG0AXQHkWAE074jesBUM278KbjpCmAcQcQBcrJ6Rgw8M2pGTBl2nHyg885QYX0Y5LkMAVATFpgvnIAYBhQCVcQ7ng7VO4suLND2SAahwLHQmsAq1eEr3F9rHiPPvroBtcPd08w1Aito3Lfzte73aeXfL5py8O9YDVtCxhhwwodqYBwrXsGHI/6A0QhsDo3UQMzOdFNeMnpTLl976ZrAM4SohMmbWCu+5Of/KQ0MzNzcXp6erEQEhuQwP3FwiVPyTHDxqm/r4bh8+6de+l2vuVWqNwWAgI9XM/zdbHkte+o/ibytFHPycmTHp19Rr+pig6/UTl91Ah40TJA/v+H+sjEOkkBGAEgDVCOQIH4ugWCOgYQmkalParTkdPH2GD0tRsjZhsnYyBD9fU7sVfFUDA0q2wU5cFQmha5cOei8BDheZyP90XI+7777tPdC/GQPjbv9a9//UsXDMLg7rfffjJ+/Hidrgh1j8aAIy0CESEILEGzAOmHgQMH6o4Ek9+32wG93It5tPUQ4AAsXLhQOxnq36Z07733Xqz+3Wj4STw4XG2DCvoOkBnXzpVkZvmqD+Qmf0vfCSPPkvNOuSLs8WhZnPXETeYlpICXS5JDB4CExN8xMEAZmOHqMd+E5239fwz++e1vfxswQMZwGQ0Brw6Awb62HWYPt/LFcTCmP/vZz7RzYgNH5dNPP9XRgEh4TSG4pQ+AHVWw7x8gH4/uCBh/fA3RBDOTYerUqboFz+4OMCt3r6kOpzOgUjqI6iz2a0EQEi/wB41agC7o28dqPxlBgeHld55qr+gj1jbA+MMJ8AMZ46SS/XWDKQASEn9qQOeLlTPQs7y8vKCmpmaACiMXwNBg9Tpq1CjXFastsOPMYdtTAkEbF3EgLwV/Jv+OYxCCh4MCDQI4A9iPyATSByYU7ry2eW7fJ4rucFzfvn0Djodby579aIfpzWtzjrlHRAjGjBmjoyjmNaIccFCgYYBoglulvgHXw88N52NDBAHXMPdo3lv9O5WqjYafNBXw7GH8xipj2AUFfBef/vuE0OuPhnmvPhRk/EFFxbYG3wcchfdWLNKthcuWv2l/KemNP2AEgERNUVFRtjJmBVOmTClQRranchR6KiOkRf/dVsYAK3NU2iN/DoOMiXJXXHGFFrmJV2geQHgHOvfYYCRN+iDcOTCuEAXC/aHK37QFXnLJJVoS2U362PncXvWHWp3DyOPngPcww47gQBnpYjgsbvMTcH+vv/56IP1i3hMOxcyZM7WzokBfIwr7aPhJc4BIwBFq6w9tgD9Mfdi1JiARsUP/NogAwAlY/s3HfoP/eqhuhBJJ8v5/Ax0AEhfUqhNWC1GCfBUhgLZAPjQGMjMzYdzyJ0yYkP38889n26vjG264QRs1Q6QVv8G58rb3O1fiNqF65mF0MagHOXq7CA+GFbl+rNLtlr1QYflQ72Gww/tubYDALeyPgkg4J1BmNFoKVgqmRDlii9u1a1cihDQ/gQFByKOPH3FaQjsCm7aslxtmnWOv/qFvoGeYd+3aK5TBx/hffGGd/3GHpAh0AEhzk61WvHAW8l955RUU+WWrtEK2chSMog5aErOVE5GtjJz+GhwKVPZj9QvNe6yYjayws2XONo5eMA4Dahuw2kcKAUYW4XX03UO6N9xAIwCDjrQDig+xyofDgOiDHZ43htvujrAjBvbcALe6CXRG/PrXv9bhf4j3qOOL1TVWqvcrEUJaFsTNURxYgGjAIYXHJKQjgHD+rX+93B7yUyK+Qr6xjkNT1uA7oQNAkgZl+PPhEJx11lnZELaBY6AcBzgT9hZwJKx9EUP0ppMANQAw5kgdIA0QLi9v1ACfe+453Q2B9j5zHISB0IEAR8WJ3bLojASEUTWs/Oabb1YuXLiwWIX9N6j7ZA8/STT6i2+0r664PaD/oXLEkCItsRvtyODGYvT/MdVv9fqv1POVztU9Vv6oZYBxz/PfO55/K0k62jcW6ACQlMefnnA6B+Yx4Dwg8qDSFuYx4ghlGG1MSMQgobfeeitI3AfOA8bqogjRrT3SrVvAjmaIT6mvxL9tUPdTIoQkB2je3098eiKBcBZ09wv67i+56rF7p77SPrudFvLp7hf4Qc9/+3YdJSdCQeFGv66A0f438sAbt67Vhh6KgmH0/83q/iNJ4ZW9V9gFQLyAP2JMAiuRJMSveIetVKLE3wrpGmVAnUNeXl72ueeem41WQ5Wr1xEKlT7IPvPMM7VOArDz/Gbcr3/1X6mcDWwblGNQWVVVtaFTp06lKgqwwd+BQUgysl7qq+Rh3fHZ0UsZ5bYq/B65H9cCTgMIN9AnBOhWwPzyLeKT693sf95qVvdeYASAeAHjr+CWr1LbYiERsaIOrtDAk1YMPktg2bOsR+xrK/URAzsMkOV/tI03nsPIl0m9scfjZv8+GnoPMAJAvGD+AJEn+1JSpAe2KbGiDoSQYHYIw+8JQboQEplatf3E/9xEAgghhCQxdACIFzaKL5eX59+q/fsIIYQkKY2XYCOthfes5xD+aC+EEEKSFkYAiFcq/I+o6MXvTYH4UgG1QgghJOmgA0CiAcV/JhWAwsAcSdLWQEIIae3QASDRAiegn/jadbpY+2IFzkSB+IRD0DifI+wyIISQJoc6ACQWYPhPsV6jPmC5h/OMoBC2zv7rZLkc95F/I4QQ0kTQASCxMkh8A0AMiyW4PdBECLBB/cukDoKA0tegvQ+Wgr77ycIlT9mKXxQdIoSQJoQOAGkMgVGg4msN/FBtmH4DY9/FebDWAu/VX/rtcaD067uvMvxDpbs1MWzN2i/khlnn0wkghJBmgA4AaSyTxRr4YeMz9gPkwP6HyF599lVGf3+JBJyAP8653J7cVSI+J6BaCCGExA06AKQxQAtgonPn2SdfISOHjZe8CFO9QrFxy3q5ftY5thMAfW+M7qQTQAghcYJdAKQxFPi3IFZ9u1yt+PeTvj37SSzktsuT4YN/JkuXv2nSAegMgBTxd0IngBBC4gIdANIYUAioc/0HqHz+wP6HSsn3X0pNTbW88/Fr0qNLbxX2309iIYQTUCC+lACdAEIIaSR0AEhjGCo+wyyHDR4pvz79BpG63fL5174OvmWfLcJYPBm47yESC8YJWPHVR1K6HSO9dctggdAJIISQRkMHgMQK8v/DzItTjj1b+vbop6MAthPw+VcfNtoJOPqgY+Xjle85nQAUCFQIIYSQmKADQGIFYj57mxcXnHqDZLX1afq4OQFlFeUy9IAjJBYy1XVHH/l/snHzOp1iEJ8TsI/aSv0bIYSQKKEDQGIFPX098GSPvgPkxFFnBH0RTkBedq58/IVviOBXJZ+plMBiOWTAcMnJ6SCxMGzISNuxwO8uHBCOJiaEkBigA0Bixej2y9D9j/AZZwf9+w2RYYNHyEcr39WFfAjhv//pIpXXL4rZCXBGF8TXHQA4P4AQQqKAOgAkFiD8M9m8uPaCu5WhHxXyYGdfPxQBzzvlahk5bJzEyktvPiFznvuzvQuzCN4TQkirZdGiRfnqoafastVWiW3kyJElQlyhA0BiAVK/Y82L2dNeDJL0dQNOwMy/3yT/XfVBYN9pJ/xaJhx3ocSKi2ogBINeU1uZEEJaBcroZ2dkZAzfvXt3YZs2bfLdjqmrqytJT08v/ulPf1osJAAdABILGAIEDQDp2qmXPHzLK55PnPvS/TLvlYcCrw9QIf3LJt4sXSM4EKFwUQ3cIT7VQDoBhKQwxvCrp9iyvZyjHISS6urq+SoqwOJhYQ0AiY1C8U/2GzZklGv+PxSmOHDlt8u1YNCPm9fpuoAD+x8snTp0k2gJoRUA9SF2CBCSgiDMf+GFF45OS0sbI75uoAyv56pIQL5yGno+8sgjjAQIIwAkNi4wTy456/cx5fJdVu6NTgk4owuKj/wbISTJUYa/QIXxi5ThL5BGsmvXrsdYG8AIAIke5P8D+r5jiyZK9y59JFrMyr185w7T26/1Alav+1L232NgTF0CztZD8WkVIFKxTm21QghJOmD4zz333PF+458vcWD37t0rH3/88U3SyqEDQKIFUSMYVt0C+PmqDxsVvnf09su6DSU6JdCtc++Yhgk5Ww/FN6sAegElQvlgQpKG//znP4WTJ08eHU/DD9S1SkeMGPGiEKYASMwUqa0/nsSjrS/eKQG3rgPxtQkuF0JIQmIK+5SRLkS+XuIMugFqa2tZBOiHDgBpDAf7N00og412vTnP3a2M8loZtPehum7ADRjtuS89IIuWvRDY16NTL/nD1Idj7hJwqQtYpbYPhV0ChCQMsVT0R4My/MXK8Bcz7x8MHQDSWNAOeLh5ccLIs1Q04IrAFzcpo36DWtn/YK3s/3DJwyptcGjIC8IBmPPsn0wIX9OYaICLXgBaBRENKBFCSIvRxIYfQkBLd+3aVcwVvzt0AEg8QJ79WPFNCJSCvgPk+vPu0qt2GPNZT9wUdPAlE6fJyCPGh72gW0qgMdEAt+iC+NIB2BgNIKQZQWFfVlZWoVqVF0r8MYZ/qTL8lUJCwiJAEg8wlrdEbajaa2tr/t/71E1SvjPYvnbt3FuGHvjTsBdEgeC4ojODCgTLK8tk4eKnYhovbAoOe3TpLd+sW2miCxhmVCC+4sDNQghpUuyKfhWW7ynxBcb+HWX4/zlixIivH3/88V1CwsIIAIknaLkbIb4ugZCgWDBUHYAbzRQNoGYAIU1EPHv4nfgL+xDmp7hPlNABIE1BUHGgE4wPnnntXIkWl4K+RtUGfFj8ptw653J719Piqw8ghMQBtPIhzN+Ehn8xC/tihw4AaSrgAEAwCHUBEOJZ79+nV+8PRjE/wCae0YCd5TvkjGuOsnctFI4VJqTRvP3220XSdBX9NPxxgg4AaS4K1PYL8+Jvd7wtebl5Eitu0QB0IIwfcVpUjsBJvw2qQVosvjZBQkgMoKo/MzNzchPk99nK1wR4HqJASCMJKrL73/crw7YCRmLCCb+RUYefJLc9NFVK1vps9kuLnlBh/dfltDG/9ixKBBEjq90QHkmB+KIWqGPo4t+PtMAqoXNASFgyMjLiXdzHiv4mhF0ApLlApT00A/TvXLucfBl6wBHSGFDZP/rIXwZV9qNTYNlnizzPFNheukm+/DYgDgijD9ngn6gNKmRZ/s04Bv3930eVUFaYkAacd955hygHoKs0Hlb0NwNMAZDmJEg0CKv0s0++qlGpAEOIyn5PaQGc8/q78/XzvJw8dewe0q/vvjJo76EibdLdrgsH4FuhoiAhQagUQKGKAoyXGIFOP0L9XPE3D3QASHMTJBrUWKlfJy6qf/o9okkLuAEH46U3npB3P18UdG3xFTgyPUCIn7fffnu0+AoAPeMv7IPRXymk2aADQFqCIL0A5OHRzjduxBkSL1568wmZ/9ZTDRyBi876vQxqRO0BMBGD/37zsb0bdQLQEaAjQFo9iARkZmYWRRrow4r+loUOAGlJgvQCsEKfeNwFcYsGhEoLxOt9QlwfjgDaCZkaIK0eCACplECBvzDQtASWKqO/QT1uoOFvWegAkJamQUrgYrVKP7CRq3QbGGq7W8AQT0eAo4cJIckGuwBIS2PmCKDavguq+N9ctjAmvf9QuHULgJLvv9QzC8qqyqVnp54ROwbCXf9nqC+w5haIr5MAUFiIEJKQ0AEgiQBa6krEFz5HC1Hbz7/6UBa/t0APFIrVMDvp13c/PWDI2TaI94IjkJvbQR8TKwNV1ALXRhuiH9Q44HvbKIQQkmDQASCJBMSCSsSKBmD6X1lFuezRfY+4OgLDB/9McrNzgyYNwnDD6WiMI4Dz8tR1P/7iPbMLEwe/FuoGEEISDNYAkCbDP/N7wK5du3qiGrhNmzaoCK5Uz0szMjI2oAL4pz/9aagJXhDdQQ4gUBvQ2FY+N0IVCpr3gxZALDUC1886364JQKvgi0IIIQkEHQASd5Thz09PTx/vZQIYhD/UtjiEI4B2QXQJ9Dc7DlBh9ssm3hy3TgFDOEfgkMJjop4xgOvMeuIme9djwigAISSBoANA4s4777xzaaT+Xyf+fuD5I0eOLHX5MhyBseKPBoB4twwaQjkC5j29KhfiOhfedJy961/iS28QQkhCQAeAxJV33313gDLkEyRGVOSguKqqanEIRyAoLQCa2xE4Tb0XBhF5gZMGCSGJDB0AElfU6n+4Ws2PlsahJ4AdddRRi0N8vVkdgQ+KXw+oCl573t0yrHBUxPMgSXz57afbuyAOxJZAQkjCQAeAxBX/PPAp0aYA3IhQHwBcHYETRp4ue/fdX+LNjvIdngcXPfrMn+SFJU+ZlxAeeEoIISSBoANA4g6KAJUTMDkeTgBQTsCGmpqauSHSAqCBI4BiwWOGjY1714AXNqmowdTbfxkQHBLfjICPhBBCEgg6AKTJePvtt4uU8S6MlyMQoT4AFKhtoPiHDAFU8cMZaIr0gBsw/jfMOkd+qB9CBC/gWfGNECaEkISBDgBpUvwtgdoRkPgQqT4AmPZBOAINogKx9vZHYvmqD+S+p25yGn/k/ncIIYQkGHQASLPgdwRGK0dggMQBD/UBhv7+rbe9E6mBYYOKPBX0RQKGf+6rDzmHAUH859/ClT8hJEGhA0CaFa9zwr0CR6CmpuaxMGkBA6ICe6ptsFhRAZMigDMwaN9DJcdjkd/GTWvlg8+XyLufLnYafqz6PxS2/BFCEhw6AKRFUI7AcOUIDG/G+gAbjCAeJI4UASjoO0C6de0l3Tv1lfbZ7YJO2rhlg6z5fpV6XGsX+Bmw4i9R21fCVT8hJAmgA0BajCaoDwCLI9QHOOmltn5q6yz+SYQez4Os7zr/9q0wz08ISTLoAJAWpwXrA9xAdABOQKhcACYWYvnPVT4hJKmhA0AShhasDyCEkFYHHQCScMTZEajctWsXnIANQgghJEAbISTBUMa6GCt35QDEEsJ3kt22bdvGziYghJCUgxEAktDEo1AQUsJHHnnkg0IIISQAIwAkoUH+/uijj56vwvjzkdOXGFCRhBIhhBASBCMAJKmItj4AaQQ4EEIIISQIOgAk6fBPG0TLYCghoUq1f0NtbS2EgUqEEEJIA+gAkKRGOQPZ6qGn2rL9u5AmKFWGv1IIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIdHx/xCmqNNd3tOJAAAAAElFTkSuQmCC"
                                    id="empty-state_svg__b"
                                    width="512"
                                    height="512"
                                  ></image>
                                </defs>
                              </svg>
                              <p
                                class="pb-4 text-base font-medium leading-6 tracking-[-0.18px] text-dark-2"
                              >
                                There are no upcoming IPOs at the moment
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="mt-4 sm:mt-7">
                          <span
                            class="text-sm font-semibold leading-6 text-dark-7"
                            >Dates yet to be announced</span
                          >
                          <div class="mt-2">
                            <div class="block xl:hidden">
                              <div class="flex flex-col gap-2">
                                <div
                                  class="flex flex-col items-start self-stretch rounded-lg bg-light-10"
                                >
                                  <div
                                    class="flex items-center gap-2 self-stretch border-b border-b-light-4 px-4 py-3 border-none"
                                  >
                                    <div
                                      class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[1px] border-gray-300"
                                    >
                                      <img
                                        alt="ipo logo"
                                        loading="lazy"
                                        width="40"
                                        height="40"
                                        decoding="async"
                                        data-nimg="1"
                                        class="rounded-full"
                                        style="color: transparent"
                                        src="https://assets.upstox.com/content/assets/images/ipo_logo/arisinfra-1a53307b-6.png"
                                      />
                                    </div>
                                    <div
                                      class="mr-4 flex min-w-[104px] flex-1 items-center gap-4"
                                    >
                                      <div
                                        class="flex w-full flex-col overflow-hidden"
                                      >
                                        <span
                                          class="relative items-baseline text-left align-middle text-dark-1 outline-none text-[14px] leading-[20px] -tracking-[0.09px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap font-semibold"
                                          >Arisinfra Solutions Limited</span
                                        ><span
                                          class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] text-dark-2"
                                          >Cement &amp; Construction
                                          Materials</span
                                        >
                                      </div>
                                    </div>
                                    <span class="text-sm font-normal"
                                      >DRHP Filed</span
                                    >
                                  </div>
                                </div>
                                <div
                                  class="flex flex-col items-start self-stretch rounded-lg bg-light-10"
                                >
                                  <div
                                    class="flex items-center gap-2 self-stretch border-b border-b-light-4 px-4 py-3 border-none"
                                  >
                                    <div
                                      class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[1px] border-gray-300"
                                    >
                                      <img
                                        alt="ipo logo"
                                        loading="lazy"
                                        width="40"
                                        height="40"
                                        decoding="async"
                                        data-nimg="1"
                                        class="rounded-full"
                                        src="https://assets.upstox.com/content/assets/images/ipo_logo/ather-6e0715f0-6498.png"
                                        style="color: transparent"
                                      />
                                    </div>
                                    <div
                                      class="mr-4 flex min-w-[104px] flex-1 items-center gap-4"
                                    >
                                      <div
                                        class="flex w-full flex-col overflow-hidden"
                                      >
                                        <span
                                          class="relative items-baseline text-left align-middle text-dark-1 outline-none text-[14px] leading-[20px] -tracking-[0.09px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap font-semibold"
                                          >Ather Energy IPO</span
                                        ><span
                                          class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] text-dark-2"
                                          >Automobile Two &amp; Three
                                          Wheelers</span
                                        >
                                      </div>
                                    </div>
                                    <span class="text-sm font-normal"
                                      >DRHP Filed</span
                                    >
                                  </div>
                                </div>
                                <div
                                  class="flex flex-col items-start self-stretch rounded-lg bg-light-10"
                                >
                                  <div
                                    class="flex items-center gap-2 self-stretch border-b border-b-light-4 px-4 py-3 border-none"
                                  >
                                    <div
                                      class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[1px] border-gray-300"
                                    >
                                      <img
                                        alt="ipo logo"
                                        loading="lazy"
                                        width="40"
                                        height="40"
                                        decoding="async"
                                        data-nimg="1"
                                        class="rounded-full"
                                        src="https://assets.upstox.com/content/assets/images/ipo_logo/bharat-7933d4d5-bf84.png"
                                        style="color: transparent"
                                      />
                                    </div>
                                    <div
                                      class="mr-4 flex min-w-[104px] flex-1 items-center gap-4"
                                    >
                                      <div
                                        class="flex w-full flex-col overflow-hidden"
                                      >
                                        <span
                                          class="relative items-baseline text-left align-middle text-dark-1 outline-none text-[14px] leading-[20px] -tracking-[0.09px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap font-semibold"
                                          >Bharat FIH Limited</span
                                        ><span
                                          class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] text-dark-2"
                                        ></span>
                                      </div>
                                    </div>
                                    <span class="text-sm font-normal"
                                      >DRHP Filed</span
                                    >
                                  </div>
                                </div>
                                <div
                                  class="flex flex-col items-start self-stretch rounded-lg bg-light-10"
                                >
                                  <div
                                    class="flex items-center gap-2 self-stretch border-b border-b-light-4 px-4 py-3 border-none"
                                  >
                                    <div
                                      class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[1px] border-gray-300"
                                    >
                                      <img
                                        alt="ipo logo"
                                        loading="lazy"
                                        width="40"
                                        height="40"
                                        decoding="async"
                                        data-nimg="1"
                                        class="rounded-full"
                                        src="https://assets.upstox.com/content/assets/images/ipo_logo/biba-490598fa-65e7-4.png"
                                        style="color: transparent"
                                      />
                                    </div>
                                    <div
                                      class="mr-4 flex min-w-[104px] flex-1 items-center gap-4"
                                    >
                                      <div
                                        class="flex w-full flex-col overflow-hidden"
                                      >
                                        <span
                                          class="relative items-baseline text-left align-middle text-dark-1 outline-none text-[14px] leading-[20px] -tracking-[0.09px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap font-semibold"
                                          >Biba Fashions Limited</span
                                        ><span
                                          class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] text-dark-2"
                                        ></span>
                                      </div>
                                    </div>
                                    <span class="text-sm font-normal"
                                      >DRHP Filed</span
                                    >
                                  </div>
                                </div>
                                <div
                                  class="flex flex-col items-start self-stretch rounded-lg bg-light-10"
                                >
                                  <div
                                    class="flex items-center gap-2 self-stretch border-b border-b-light-4 px-4 py-3 border-none"
                                  >
                                    <div
                                      class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[1px] border-gray-300"
                                    >
                                      <img
                                        alt="ipo logo"
                                        loading="lazy"
                                        width="40"
                                        height="40"
                                        decoding="async"
                                        data-nimg="1"
                                        class="rounded-full"
                                        src="https://assets.upstox.com/content/assets/images/ipo_logo/BoAt%20%20logo.png"
                                        style="color: transparent"
                                      />
                                    </div>
                                    <div
                                      class="mr-4 flex min-w-[104px] flex-1 items-center gap-4"
                                    >
                                      <div
                                        class="flex w-full flex-col overflow-hidden"
                                      >
                                        <span
                                          class="relative items-baseline text-left align-middle text-dark-1 outline-none text-[14px] leading-[20px] -tracking-[0.09px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap font-semibold"
                                          >BoAt IPO </span
                                        ><span
                                          class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] text-dark-2"
                                        ></span>
                                      </div>
                                    </div>
                                    <span class="text-sm font-normal"
                                      >DRHP Filed</span
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="hidden xl:block">
                              <div
                                class="table-wrapper no-scrollbar overflow-x-auto"
                              >
                                <table class="min-w-full">
                                  <thead>
                                    <tr>
                                      <th
                                        class="bg-light-10 px-4 py-3 text-left cursor-pointer !shadow-none"
                                      >
                                        <div
                                          class="flex items-center gap-[2px]"
                                        >
                                          <span
                                            class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none -tracking-[0.09px] inter-display-font text-sm font-semibold text-primary-accent3"
                                            >Name</span
                                          ><span
                                            ><svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="none"
                                              viewBox="0 0 16 17"
                                              class="shrink-0"
                                            >
                                              <mask
                                                id="sort-up-arrow_svg__a"
                                                width="16"
                                                height="17"
                                                x="0"
                                                y="0"
                                                maskUnits="userSpaceOnUse"
                                                style="mask-type: alpha"
                                              >
                                                <path
                                                  fill="#D9D9D9"
                                                  d="M0 .5h16v16H0z"
                                                ></path>
                                              </mask>
                                              <g
                                                mask="url(#sort-up-arrow_svg__a)"
                                              >
                                                <path
                                                  fill="#7132B0"
                                                  d="M7.333 12.5V6.367l-2.4 2.4L4 7.833l4-4 4 4-.933.934-2.4-2.4V12.5z"
                                                ></path>
                                              </g></svg
                                          ></span>
                                        </div>
                                      </th>
                                      <th
                                        class="bg-light-10 px-4 py-3 text-left !shadow-none"
                                      >
                                        <div
                                          class="flex items-center gap-[2px]"
                                        >
                                          <span
                                            class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none -tracking-[0.09px] inter-display-font text-sm font-semibold text-dark-10"
                                            >Status</span
                                          >
                                        </div>
                                      </th>
                                      <th
                                        class="bg-light-10 px-4 py-3 text-left !shadow-none"
                                      >
                                        <div
                                          class="flex items-center gap-[2px]"
                                        >
                                          <span
                                            class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none -tracking-[0.09px] inter-display-font text-sm font-semibold text-dark-10"
                                          ></span>
                                        </div>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr class="cursor-pointer">
                                      <td
                                        data-key="name"
                                        class="px-4 py-3 !shadow-none"
                                      >
                                        <div class="flex max-w-[210px] gap-2">
                                          <div>
                                            <div
                                              class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[1px] border-light-3"
                                            >
                                              <img
                                                alt="ipo logo"
                                                loading="lazy"
                                                width="40"
                                                height="40"
                                                decoding="async"
                                                data-nimg="1"
                                                class="rounded-full"
                                                style="color: transparent"
                                                src="https://assets.upstox.com/content/assets/images/ipo_logo/arisinfra-1a53307b-6.png"
                                              />
                                            </div>
                                          </div>
                                          <div
                                            class="flex w-full flex-col overflow-hidden"
                                          >
                                            <span
                                              class="relative items-baseline text-left align-middle outline-none not-italic tracking-[-0.14px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-sm font-semibold text-dark-10"
                                              >Arisinfra Solutions Limited</span
                                            ><span
                                              class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-xs font-normal not-italic leading-[150%] tracking-[-0.12px] text-dark-7"
                                              >Mainboard, Cement &amp;
                                              Construction Materials</span
                                            >
                                          </div>
                                        </div>
                                      </td>
                                      <td
                                        data-key="upcomingStatus"
                                        class="px-4 py-3 !shadow-none"
                                      >
                                        <span class="text-sm font-normal"
                                          >DRHP Filed</span
                                        >
                                      </td>
                                      <td
                                        data-key="rhp"
                                        class="px-4 py-3 !shadow-none"
                                      >
                                        <a
                                          href="https://www.sebi.gov.in/filings/public-issues/nov-2024/arisinfra-solutions-limited-addendum-to-drhp_88526.html"
                                          target="_blank"
                                          class="text-inherit no-underline"
                                          ><div class="flex items-center gap-1">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="none"
                                              viewBox="0 0 16 16"
                                              class="shrink-0"
                                            >
                                              <mask
                                                id="link-purple_svg__a"
                                                width="16"
                                                height="16"
                                                x="0"
                                                y="0"
                                                maskUnits="userSpaceOnUse"
                                                style="mask-type: alpha"
                                              >
                                                <path
                                                  fill="#D9D9D9"
                                                  d="M0 0h16v16H0z"
                                                ></path>
                                              </mask>
                                              <g
                                                mask="url(#link-purple_svg__a)"
                                              >
                                                <path
                                                  fill="#7132B0"
                                                  d="M3.333 14q-.55 0-.941-.392A1.28 1.28 0 0 1 2 12.667V3.333q0-.55.392-.941Q2.783 2 3.333 2H8v1.333H3.333v9.334h9.334V8H14v4.667q0 .55-.392.941a1.28 1.28 0 0 1-.941.392zm3.134-3.533-.934-.934 6.2-6.2h-2.4V2H14v4.667h-1.333v-2.4z"
                                                ></path>
                                              </g></svg
                                            ><span
                                              class="text-xs font-bold text-primary-accent3"
                                              >DRHP</span
                                            >
                                          </div></a
                                        >
                                      </td>
                                    </tr>
                                    <tr class="cursor-pointer">
                                      <td
                                        data-key="name"
                                        class="px-4 py-3 !shadow-none"
                                      >
                                        <div class="flex max-w-[210px] gap-2">
                                          <div>
                                            <div
                                              class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[1px] border-light-3"
                                            >
                                              <img
                                                alt="ipo logo"
                                                loading="lazy"
                                                width="40"
                                                height="40"
                                                decoding="async"
                                                data-nimg="1"
                                                class="rounded-full"
                                                src="https://assets.upstox.com/content/assets/images/ipo_logo/ather-6e0715f0-6498.png"
                                                style="color: transparent"
                                              />
                                            </div>
                                          </div>
                                          <div
                                            class="flex w-full flex-col overflow-hidden"
                                          >
                                            <span
                                              class="relative items-baseline text-left align-middle outline-none not-italic tracking-[-0.14px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-sm font-semibold text-dark-10"
                                              >Ather Energy IPO</span
                                            ><span
                                              class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-xs font-normal not-italic leading-[150%] tracking-[-0.12px] text-dark-7"
                                              >Mainboard, Automobile Two &amp;
                                              Three Wheelers</span
                                            >
                                          </div>
                                        </div>
                                      </td>
                                      <td
                                        data-key="upcomingStatus"
                                        class="px-4 py-3 !shadow-none"
                                      >
                                        <span class="text-sm font-normal"
                                          >DRHP Filed</span
                                        >
                                      </td>
                                      <td
                                        data-key="rhp"
                                        class="px-4 py-3 !shadow-none"
                                      >
                                        <a
                                          href="https://www.sebi.gov.in/filings/public-issues/sep-2024/ather-energy-limited_86582.html"
                                          target="_blank"
                                          class="text-inherit no-underline"
                                          ><div class="flex items-center gap-1">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="none"
                                              viewBox="0 0 16 16"
                                              class="shrink-0"
                                            >
                                              <mask
                                                id="link-purple_svg__a"
                                                width="16"
                                                height="16"
                                                x="0"
                                                y="0"
                                                maskUnits="userSpaceOnUse"
                                                style="mask-type: alpha"
                                              >
                                                <path
                                                  fill="#D9D9D9"
                                                  d="M0 0h16v16H0z"
                                                ></path>
                                              </mask>
                                              <g
                                                mask="url(#link-purple_svg__a)"
                                              >
                                                <path
                                                  fill="#7132B0"
                                                  d="M3.333 14q-.55 0-.941-.392A1.28 1.28 0 0 1 2 12.667V3.333q0-.55.392-.941Q2.783 2 3.333 2H8v1.333H3.333v9.334h9.334V8H14v4.667q0 .55-.392.941a1.28 1.28 0 0 1-.941.392zm3.134-3.533-.934-.934 6.2-6.2h-2.4V2H14v4.667h-1.333v-2.4z"
                                                ></path>
                                              </g></svg
                                            ><span
                                              class="text-xs font-bold text-primary-accent3"
                                              >DRHP</span
                                            >
                                          </div></a
                                        >
                                      </td>
                                    </tr>
                                    <tr class="cursor-pointer">
                                      <td
                                        data-key="name"
                                        class="px-4 py-3 !shadow-none"
                                      >
                                        <div class="flex max-w-[210px] gap-2">
                                          <div>
                                            <div
                                              class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[1px] border-light-3"
                                            >
                                              <img
                                                alt="ipo logo"
                                                loading="lazy"
                                                width="40"
                                                height="40"
                                                decoding="async"
                                                data-nimg="1"
                                                class="rounded-full"
                                                src="https://assets.upstox.com/content/assets/images/ipo_logo/bharat-7933d4d5-bf84.png"
                                                style="color: transparent"
                                              />
                                            </div>
                                          </div>
                                          <div
                                            class="flex w-full flex-col overflow-hidden"
                                          >
                                            <span
                                              class="relative items-baseline text-left align-middle outline-none not-italic tracking-[-0.14px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-sm font-semibold text-dark-10"
                                              >Bharat FIH Limited</span
                                            ><span
                                              class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-xs font-normal not-italic leading-[150%] tracking-[-0.12px] text-dark-7"
                                              >Mainboard</span
                                            >
                                          </div>
                                        </div>
                                      </td>
                                      <td
                                        data-key="upcomingStatus"
                                        class="px-4 py-3 !shadow-none"
                                      >
                                        <span class="text-sm font-normal"
                                          >DRHP Filed</span
                                        >
                                      </td>
                                      <td
                                        data-key="rhp"
                                        class="px-4 py-3 !shadow-none"
                                      >
                                        <a
                                          href="https://www.sebi.gov.in/web/?file=https://www.sebi.gov.in/sebi_data/attachdocs/jun-2022/1655876827634.pdf#page=1&amp;zoom=page-width,-16,610"
                                          target="_blank"
                                          class="text-inherit no-underline"
                                          ><div class="flex items-center gap-1">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="none"
                                              viewBox="0 0 16 16"
                                              class="shrink-0"
                                            >
                                              <mask
                                                id="link-purple_svg__a"
                                                width="16"
                                                height="16"
                                                x="0"
                                                y="0"
                                                maskUnits="userSpaceOnUse"
                                                style="mask-type: alpha"
                                              >
                                                <path
                                                  fill="#D9D9D9"
                                                  d="M0 0h16v16H0z"
                                                ></path>
                                              </mask>
                                              <g
                                                mask="url(#link-purple_svg__a)"
                                              >
                                                <path
                                                  fill="#7132B0"
                                                  d="M3.333 14q-.55 0-.941-.392A1.28 1.28 0 0 1 2 12.667V3.333q0-.55.392-.941Q2.783 2 3.333 2H8v1.333H3.333v9.334h9.334V8H14v4.667q0 .55-.392.941a1.28 1.28 0 0 1-.941.392zm3.134-3.533-.934-.934 6.2-6.2h-2.4V2H14v4.667h-1.333v-2.4z"
                                                ></path>
                                              </g></svg
                                            ><span
                                              class="text-xs font-bold text-primary-accent3"
                                              >DRHP</span
                                            >
                                          </div></a
                                        >
                                      </td>
                                    </tr>
                                    <tr class="cursor-pointer">
                                      <td
                                        data-key="name"
                                        class="px-4 py-3 !shadow-none"
                                      >
                                        <div class="flex max-w-[210px] gap-2">
                                          <div>
                                            <div
                                              class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[1px] border-light-3"
                                            >
                                              <img
                                                alt="ipo logo"
                                                loading="lazy"
                                                width="40"
                                                height="40"
                                                decoding="async"
                                                data-nimg="1"
                                                class="rounded-full"
                                                src="https://assets.upstox.com/content/assets/images/ipo_logo/biba-490598fa-65e7-4.png"
                                                style="color: transparent"
                                              />
                                            </div>
                                          </div>
                                          <div
                                            class="flex w-full flex-col overflow-hidden"
                                          >
                                            <span
                                              class="relative items-baseline text-left align-middle outline-none not-italic tracking-[-0.14px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-sm font-semibold text-dark-10"
                                              >Biba Fashions Limited</span
                                            ><span
                                              class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-xs font-normal not-italic leading-[150%] tracking-[-0.12px] text-dark-7"
                                              >Mainboard</span
                                            >
                                          </div>
                                        </div>
                                      </td>
                                      <td
                                        data-key="upcomingStatus"
                                        class="px-4 py-3 !shadow-none"
                                      >
                                        <span class="text-sm font-normal"
                                          >DRHP Filed</span
                                        >
                                      </td>
                                      <td
                                        data-key="rhp"
                                        class="px-4 py-3 !shadow-none"
                                      >
                                        <a
                                          href="https://www.sebi.gov.in/web/?file=https://www.sebi.gov.in/sebi_data/attachdocs/jul-2022/1659005306568.pdf#page=1&amp;zoom=page-width,-16,764"
                                          target="_blank"
                                          class="text-inherit no-underline"
                                          ><div class="flex items-center gap-1">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="none"
                                              viewBox="0 0 16 16"
                                              class="shrink-0"
                                            >
                                              <mask
                                                id="link-purple_svg__a"
                                                width="16"
                                                height="16"
                                                x="0"
                                                y="0"
                                                maskUnits="userSpaceOnUse"
                                                style="mask-type: alpha"
                                              >
                                                <path
                                                  fill="#D9D9D9"
                                                  d="M0 0h16v16H0z"
                                                ></path>
                                              </mask>
                                              <g
                                                mask="url(#link-purple_svg__a)"
                                              >
                                                <path
                                                  fill="#7132B0"
                                                  d="M3.333 14q-.55 0-.941-.392A1.28 1.28 0 0 1 2 12.667V3.333q0-.55.392-.941Q2.783 2 3.333 2H8v1.333H3.333v9.334h9.334V8H14v4.667q0 .55-.392.941a1.28 1.28 0 0 1-.941.392zm3.134-3.533-.934-.934 6.2-6.2h-2.4V2H14v4.667h-1.333v-2.4z"
                                                ></path>
                                              </g></svg
                                            ><span
                                              class="text-xs font-bold text-primary-accent3"
                                              >DRHP</span
                                            >
                                          </div></a
                                        >
                                      </td>
                                    </tr>
                                    <tr class="cursor-pointer">
                                      <td
                                        data-key="name"
                                        class="px-4 py-3 !shadow-none"
                                      >
                                        <div class="flex max-w-[210px] gap-2">
                                          <div>
                                            <div
                                              class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[1px] border-light-3"
                                            >
                                              <img
                                                alt="ipo logo"
                                                loading="lazy"
                                                width="40"
                                                height="40"
                                                decoding="async"
                                                data-nimg="1"
                                                class="rounded-full"
                                                src="https://assets.upstox.com/content/assets/images/ipo_logo/BoAt  logo.png"
                                                style="color: transparent"
                                              />
                                            </div>
                                          </div>
                                          <div
                                            class="flex w-full flex-col overflow-hidden"
                                          >
                                            <span
                                              class="relative items-baseline text-left align-middle outline-none not-italic tracking-[-0.14px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-sm font-semibold text-dark-10"
                                              >BoAt IPO </span
                                            ><span
                                              class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-xs font-normal not-italic leading-[150%] tracking-[-0.12px] text-dark-7"
                                              >Mainboard</span
                                            >
                                          </div>
                                        </div>
                                      </td>
                                      <td
                                        data-key="upcomingStatus"
                                        class="px-4 py-3 !shadow-none"
                                      >
                                        <span class="text-sm font-normal"
                                          >DRHP Filed</span
                                        >
                                      </td>
                                      <td
                                        data-key="rhp"
                                        class="px-4 py-3 !shadow-none"
                                      >
                                        <a
                                          href="https://www.sebi.gov.in/web/?file=/sebi_data/attachdocs/jan-2022/1643353844101.PDF#page=2&amp;zoom=page-width,-15,379"
                                          target="_blank"
                                          class="text-inherit no-underline"
                                          ><div class="flex items-center gap-1">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="none"
                                              viewBox="0 0 16 16"
                                              class="shrink-0"
                                            >
                                              <mask
                                                id="link-purple_svg__a"
                                                width="16"
                                                height="16"
                                                x="0"
                                                y="0"
                                                maskUnits="userSpaceOnUse"
                                                style="mask-type: alpha"
                                              >
                                                <path
                                                  fill="#D9D9D9"
                                                  d="M0 0h16v16H0z"
                                                ></path>
                                              </mask>
                                              <g
                                                mask="url(#link-purple_svg__a)"
                                              >
                                                <path
                                                  fill="#7132B0"
                                                  d="M3.333 14q-.55 0-.941-.392A1.28 1.28 0 0 1 2 12.667V3.333q0-.55.392-.941Q2.783 2 3.333 2H8v1.333H3.333v9.334h9.334V8H14v4.667q0 .55-.392.941a1.28 1.28 0 0 1-.941.392zm3.134-3.533-.934-.934 6.2-6.2h-2.4V2H14v4.667h-1.333v-2.4z"
                                                ></path>
                                              </g></svg
                                            ><span
                                              class="text-xs font-bold text-primary-accent3"
                                              >DRHP</span
                                            >
                                          </div></a
                                        >
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="flex w-full justify-center pt-4 xl:hidden">
                          <button
                            class="group cursor-pointer px-4 py-2 text-sm disabled:cursor-not-allowed border border-primary-base text-primary-base hover:bg-primary-light active:bg-primary-base2 active:text-white disabled:border-primary-base/50 disabled:bg-white disabled:text-primary-base/50 rounded-full w-full pt-3 font-bold leading-6"
                          >
                            View more upcoming IPOs
                          </button>
                        </div>
                        <a
                          class="mt-3 hidden xl:block"
                          href="/ipo/sme/upcoming-sme-ipo/"
                          ><div class="flex items-center gap-[2px]">
                            <span
                              class="text-sm font-bold leading-[18px] text-primary-accent3"
                              >View more upcoming IPOs</span
                            ><svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              fill="none"
                              viewBox="0 0 20 20"
                              class="shrink-0 h-5 w-5"
                            >
                              <mask
                                id="right-purple_svg__a"
                                width="20"
                                height="20"
                                x="0"
                                y="0"
                                maskUnits="userSpaceOnUse"
                                style="mask-type: alpha"
                              >
                                <path fill="#D9D9D9" d="M0 0h20v20H0z"></path>
                              </mask>
                              <g mask="url(#right-purple_svg__a)">
                                <path
                                  fill="#7132B0"
                                  d="M11.665 15 10.5 13.792l2.958-2.959H3.332V9.167h10.125l-2.958-2.959L11.665 5l5 5z"
                                ></path>
                              </g>
                            </svg></div
                        ></a>
                      </div>
                      <hr class="my-8 h-[1px] w-full bg-light-4 xl:hidden" />
                      <div class="mt-8 flex flex-col gap-4">
                        <h2
                          class="inter-display-font text-xl font-semibold leading-6 text-dark-10"
                        >
                          Closed IPOs
                        </h2>
                        <div class="block xl:hidden">
                          <div class="flex flex-col gap-2">
                            <div
                              class="flex flex-col items-start self-stretch rounded-lg bg-light-10"
                            >
                              <div
                                class="flex items-center gap-2 self-stretch border-b border-b-light-4 px-4 py-3"
                              >
                                <div
                                  class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[1px] border-gray-300"
                                >
                                  <img
                                    alt="ipo logo"
                                    loading="lazy"
                                    width="40"
                                    height="40"
                                    decoding="async"
                                    data-nimg="1"
                                    class="rounded-full"
                                    style="color: transparent"
                                    src="https://assets.upstox.com/content/assets/images/ipo_logo/INE13VU01016.png"
                                  />
                                </div>
                                <div
                                  class="mr-4 flex min-w-[104px] flex-1 items-center gap-4"
                                >
                                  <div
                                    class="flex w-full flex-col overflow-hidden"
                                  >
                                    <span
                                      class="relative items-baseline text-left align-middle text-dark-1 outline-none text-[14px] leading-[20px] -tracking-[0.09px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap font-semibold"
                                      >Beezaasan Explotech IPO</span
                                    ><span
                                      class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] text-dark-2"
                                      >Mining &amp; Minerals, SME</span
                                    >
                                  </div>
                                </div>
                                <div
                                  class="z-[2] flex shrink-0 flex-col items-end"
                                >
                                  <span
                                    class="relative text-left align-middle outline-none tracking-[0.01px] flex items-center whitespace-nowrap text-xs font-bold text-success-1"
                                    ><div
                                      class="mb-0.5 h-[37px] w-[27px] absolute -bottom-[9px] -left-5 -z-10"
                                    >
                                      <div
                                        class=""
                                        style="
                                          width: 100%;
                                          height: 100%;
                                          line-height: 0;
                                        "
                                      >
                                        <canvas
                                          style="width: 100%; height: 100%"
                                          width="27"
                                          height="37"
                                        ></canvas>
                                      </div>
                                    </div>
                                    <p
                                      class="text-stroke-ipo-card font-inter-italic text-[14px] font-bold italic"
                                    >
                                      5.23<!-- -->x
                                    </p></span
                                  >
                                  <p
                                    class="text-stroke-ipo-card font-inter-italic -mt-1 text-[10px] font-bold italic text-dark-2"
                                  >
                                    subscribed
                                  </p>
                                </div>
                              </div>
                              <div
                                class="flex flex-col items-center self-stretch p-4"
                              >
                                <div
                                  class="flex items-center gap-6 self-stretch"
                                >
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Allotment Date</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] text-dark-7 whitespace-nowrap"
                                      >27 Feb 2025</span
                                    >
                                  </div>
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Demat Transfer</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle text-dark-1 outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] whitespace-nowrap"
                                      >28 Feb 2025</span
                                    >
                                  </div>
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Listing Date</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] text-dark-7 whitespace-nowrap"
                                      >03 Mar 2025</span
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="flex flex-col items-start self-stretch rounded-lg bg-light-10"
                            >
                              <div
                                class="flex items-center gap-2 self-stretch border-b border-b-light-4 px-4 py-3"
                              >
                                <div
                                  class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[1px] border-gray-300"
                                >
                                  <img
                                    alt="ipo logo"
                                    loading="lazy"
                                    width="40"
                                    height="40"
                                    decoding="async"
                                    data-nimg="1"
                                    class="rounded-full"
                                    style="color: transparent"
                                    src="https://assets.upstox.com/content/assets/images/ipo_logo/INE0VYX01018.png"
                                  />
                                </div>
                                <div
                                  class="mr-4 flex min-w-[104px] flex-1 items-center gap-4"
                                >
                                  <div
                                    class="flex w-full flex-col overflow-hidden"
                                  >
                                    <span
                                      class="relative items-baseline text-left align-middle text-dark-1 outline-none text-[14px] leading-[20px] -tracking-[0.09px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap font-semibold"
                                      >Nukleus Office Solutions Private
                                      IPO</span
                                    ><span
                                      class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] text-dark-2"
                                      >SME</span
                                    >
                                  </div>
                                </div>
                                <div
                                  class="z-[2] flex shrink-0 flex-col items-end"
                                >
                                  <span
                                    class="relative text-left align-middle outline-none tracking-[0.01px] flex items-center whitespace-nowrap text-xs font-bold text-success-1"
                                    ><div
                                      class="absolute mb-0.5 h-[16px] w-[12px] -ml-3 -z-10"
                                    >
                                      <div
                                        class=""
                                        style="
                                          width: 100%;
                                          height: 100%;
                                          line-height: 0;
                                        "
                                      >
                                        <canvas
                                          style="width: 100%; height: 100%"
                                          width="12"
                                          height="16"
                                        ></canvas>
                                      </div>
                                    </div>
                                    <p
                                      class="text-stroke-ipo-card font-inter-italic text-[14px] font-bold italic"
                                    >
                                      1.15<!-- -->x
                                    </p></span
                                  >
                                  <p
                                    class="text-stroke-ipo-card font-inter-italic -mt-1 text-[10px] font-bold italic text-dark-2"
                                  >
                                    subscribed
                                  </p>
                                </div>
                              </div>
                              <div
                                class="flex flex-col items-center self-stretch p-4"
                              >
                                <div
                                  class="flex items-center gap-6 self-stretch"
                                >
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Allotment Date</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] text-dark-7 whitespace-nowrap"
                                      >28 Feb 2025</span
                                    >
                                  </div>
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Demat Transfer</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle text-dark-1 outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] whitespace-nowrap"
                                      >03 Mar 2025</span
                                    >
                                  </div>
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Listing Date</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] text-dark-7 whitespace-nowrap"
                                      >04 Mar 2025</span
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="flex flex-col items-start self-stretch rounded-lg bg-light-10"
                            >
                              <div
                                class="flex items-center gap-2 self-stretch border-b border-b-light-4 px-4 py-3"
                              >
                                <div
                                  class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[1px] border-gray-300"
                                >
                                  <img
                                    alt="ipo logo"
                                    loading="lazy"
                                    width="40"
                                    height="40"
                                    decoding="async"
                                    data-nimg="1"
                                    class="rounded-full"
                                    style="color: transparent"
                                    src="https://assets.upstox.com/content/assets/images/ipo_logo/INE0RXS01018.png"
                                  />
                                </div>
                                <div
                                  class="mr-4 flex min-w-[104px] flex-1 items-center gap-4"
                                >
                                  <div
                                    class="flex w-full flex-col overflow-hidden"
                                  >
                                    <span
                                      class="relative items-baseline text-left align-middle text-dark-1 outline-none text-[14px] leading-[20px] -tracking-[0.09px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap font-semibold"
                                      >Shreenath Paper Products IPO</span
                                    ><span
                                      class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] text-dark-2"
                                      >Paper &amp; Paper Products, SME</span
                                    >
                                  </div>
                                </div>
                                <div
                                  class="z-[2] flex shrink-0 flex-col items-end"
                                >
                                  <span
                                    class="relative text-left align-middle outline-none tracking-[0.01px] flex items-center whitespace-nowrap text-xs font-bold text-success-1"
                                    ><div
                                      class="absolute mb-0.5 h-[16px] w-[12px] -ml-3 -z-10"
                                    >
                                      <div
                                        class=""
                                        style="
                                          width: 100%;
                                          height: 100%;
                                          line-height: 0;
                                        "
                                      >
                                        <canvas
                                          style="width: 100%; height: 100%"
                                          width="12"
                                          height="16"
                                        ></canvas>
                                      </div>
                                    </div>
                                    <p
                                      class="text-stroke-ipo-card font-inter-italic text-[14px] font-bold italic"
                                    >
                                      1.79<!-- -->x
                                    </p></span
                                  >
                                  <p
                                    class="text-stroke-ipo-card font-inter-italic -mt-1 text-[10px] font-bold italic text-dark-2"
                                  >
                                    subscribed
                                  </p>
                                </div>
                              </div>
                              <div
                                class="flex flex-col items-center self-stretch p-4"
                              >
                                <div
                                  class="flex items-center gap-6 self-stretch"
                                >
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Allotment Date</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] text-dark-7 whitespace-nowrap"
                                      >03 Mar 2025</span
                                    >
                                  </div>
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Demat Transfer</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle text-dark-1 outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] whitespace-nowrap"
                                      >04 Mar 2025</span
                                    >
                                  </div>
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Listing Date</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] text-dark-7 whitespace-nowrap"
                                      >05 Mar 2025</span
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="hidden xl:block">
                          <div
                            class="table-wrapper no-scrollbar overflow-x-auto"
                          >
                            <table class="min-w-full">
                              <thead>
                                <tr>
                                  <th
                                    class="bg-light-10 px-4 py-3 text-left cursor-pointer !shadow-none"
                                  >
                                    <div class="flex items-center gap-[2px]">
                                      <span
                                        class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none -tracking-[0.09px] inter-display-font text-sm font-semibold text-dark-10"
                                        >Name</span
                                      ><span
                                        ><svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="none"
                                          viewBox="0 0 16 17"
                                          class="shrink-0"
                                        >
                                          <mask
                                            id="default-sort_svg__a"
                                            width="16"
                                            height="17"
                                            x="0"
                                            y="0"
                                            maskUnits="userSpaceOnUse"
                                            style="mask-type: alpha"
                                          >
                                            <path
                                              fill="#D9D9D9"
                                              d="M0 .5h16v16H0z"
                                            ></path>
                                          </mask>
                                          <g mask="url(#default-sort_svg__a)">
                                            <path
                                              fill="#111"
                                              d="M5.333 9.167V4.383L3.617 6.1l-.95-.933L6 1.833l3.333 3.334-.95.933-1.716-1.717v4.784zm4.667 6-3.333-3.334.95-.933 1.716 1.717V7.833h1.334v4.784l1.716-1.717.95.933z"
                                            ></path>
                                          </g></svg
                                      ></span>
                                    </div>
                                  </th>
                                  <th
                                    class="bg-light-10 px-4 py-3 text-left cursor-pointer !shadow-none"
                                  >
                                    <div class="flex items-center gap-[2px]">
                                      <span
                                        class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none -tracking-[0.09px] inter-display-font text-sm font-semibold text-primary-accent3"
                                        >Allotment Date</span
                                      ><span
                                        ><svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="none"
                                          viewBox="0 0 16 17"
                                          class="shrink-0"
                                        >
                                          <mask
                                            id="sort-down-arrow_svg__a"
                                            width="16"
                                            height="17"
                                            x="0"
                                            y="0"
                                            maskUnits="userSpaceOnUse"
                                            style="mask-type: alpha"
                                          >
                                            <path
                                              fill="#D9D9D9"
                                              d="M16 16.5H0V.5h16z"
                                            ></path>
                                          </mask>
                                          <g
                                            mask="url(#sort-down-arrow_svg__a)"
                                          >
                                            <path
                                              fill="#7132B0"
                                              d="M8.667 4.5v6.133l2.4-2.4.933.934-4 4-4-4 .933-.934 2.4 2.4V4.5z"
                                            ></path>
                                          </g></svg
                                      ></span>
                                    </div>
                                  </th>
                                  <th
                                    class="bg-light-10 px-4 py-3 text-left cursor-pointer !shadow-none"
                                  >
                                    <div class="flex items-center gap-[2px]">
                                      <span
                                        class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none -tracking-[0.09px] inter-display-font text-sm font-semibold text-dark-10"
                                        >Demat Transfer</span
                                      ><span
                                        ><svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="none"
                                          viewBox="0 0 16 17"
                                          class="shrink-0"
                                        >
                                          <mask
                                            id="default-sort_svg__a"
                                            width="16"
                                            height="17"
                                            x="0"
                                            y="0"
                                            maskUnits="userSpaceOnUse"
                                            style="mask-type: alpha"
                                          >
                                            <path
                                              fill="#D9D9D9"
                                              d="M0 .5h16v16H0z"
                                            ></path>
                                          </mask>
                                          <g mask="url(#default-sort_svg__a)">
                                            <path
                                              fill="#111"
                                              d="M5.333 9.167V4.383L3.617 6.1l-.95-.933L6 1.833l3.333 3.334-.95.933-1.716-1.717v4.784zm4.667 6-3.333-3.334.95-.933 1.716 1.717V7.833h1.334v4.784l1.716-1.717.95.933z"
                                            ></path>
                                          </g></svg
                                      ></span>
                                    </div>
                                  </th>
                                  <th
                                    class="bg-light-10 px-4 py-3 text-left cursor-pointer !shadow-none"
                                  >
                                    <div class="flex items-center gap-[2px]">
                                      <span
                                        class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none -tracking-[0.09px] inter-display-font text-sm font-semibold text-dark-10"
                                        >Listing Date</span
                                      ><span
                                        ><svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="none"
                                          viewBox="0 0 16 17"
                                          class="shrink-0"
                                        >
                                          <mask
                                            id="default-sort_svg__a"
                                            width="16"
                                            height="17"
                                            x="0"
                                            y="0"
                                            maskUnits="userSpaceOnUse"
                                            style="mask-type: alpha"
                                          >
                                            <path
                                              fill="#D9D9D9"
                                              d="M0 .5h16v16H0z"
                                            ></path>
                                          </mask>
                                          <g mask="url(#default-sort_svg__a)">
                                            <path
                                              fill="#111"
                                              d="M5.333 9.167V4.383L3.617 6.1l-.95-.933L6 1.833l3.333 3.334-.95.933-1.716-1.717v4.784zm4.667 6-3.333-3.334.95-.933 1.716 1.717V7.833h1.334v4.784l1.716-1.717.95.933z"
                                            ></path>
                                          </g></svg
                                      ></span>
                                    </div>
                                  </th>
                                  <th
                                    class="bg-light-10 px-4 py-3 text-left cursor-pointer !shadow-none"
                                  >
                                    <div class="flex items-center gap-[2px]">
                                      <span
                                        class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none -tracking-[0.09px] inter-display-font text-sm font-semibold text-dark-10"
                                        >Subscription</span
                                      ><span
                                        ><svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="none"
                                          viewBox="0 0 16 17"
                                          class="shrink-0"
                                        >
                                          <mask
                                            id="default-sort_svg__a"
                                            width="16"
                                            height="17"
                                            x="0"
                                            y="0"
                                            maskUnits="userSpaceOnUse"
                                            style="mask-type: alpha"
                                          >
                                            <path
                                              fill="#D9D9D9"
                                              d="M0 .5h16v16H0z"
                                            ></path>
                                          </mask>
                                          <g mask="url(#default-sort_svg__a)">
                                            <path
                                              fill="#111"
                                              d="M5.333 9.167V4.383L3.617 6.1l-.95-.933L6 1.833l3.333 3.334-.95.933-1.716-1.717v4.784zm4.667 6-3.333-3.334.95-.933 1.716 1.717V7.833h1.334v4.784l1.716-1.717.95.933z"
                                            ></path>
                                          </g></svg
                                      ></span>
                                    </div>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr class="cursor-pointer">
                                  <td
                                    data-key="name"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <div class="flex max-w-[210px] gap-2">
                                      <div>
                                        <div
                                          class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[1px] border-light-3"
                                        >
                                          <img
                                            alt="ipo logo"
                                            loading="lazy"
                                            width="40"
                                            height="40"
                                            decoding="async"
                                            data-nimg="1"
                                            class="rounded-full"
                                            style="color: transparent"
                                            src="https://assets.upstox.com/content/assets/images/ipo_logo/INE0RXS01018.png"
                                          />
                                        </div>
                                      </div>
                                      <div
                                        class="flex w-full flex-col overflow-hidden"
                                      >
                                        <span
                                          class="relative items-baseline text-left align-middle outline-none not-italic tracking-[-0.14px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-sm font-semibold text-dark-10"
                                          >Shreenath Paper Products IPO</span
                                        ><span
                                          class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-xs font-normal not-italic leading-[150%] tracking-[-0.12px] text-dark-7"
                                          >SME, Paper &amp; Paper Products</span
                                        >
                                      </div>
                                    </div>
                                  </td>
                                  <td
                                    data-key="allotmentDate"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <span>03 Mar 2025</span>
                                  </td>
                                  <td
                                    data-key="dematTransferDate"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <span>04 Mar 2025</span>
                                  </td>
                                  <td
                                    data-key="listingDate"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <span>05 Mar 2025</span>
                                  </td>
                                  <td
                                    data-key="subscription"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <div
                                      class="flex items-center justify-start gap-1 py-1.5 z-0"
                                    >
                                      <div class="flex flex-col">
                                        <span
                                          class="relative items-baseline whitespace-normal align-middle outline-none font-bold tracking-[0.01px] flex w-full border-r-green-600 text-end text-base leading-[16px] z-0 text-success-1 -mt-3 italic justify-end"
                                          title="1.79x"
                                          ><div
                                            style="transform: scale(1)"
                                            class="h-[20px] w-[16px] text-end flex relative top-[5px] -right-[3px] shrink-0"
                                          >
                                            <div
                                              class=""
                                              style="
                                                width: 100%;
                                                height: 100%;
                                                line-height: 0;
                                              "
                                            >
                                              <canvas
                                                width="0"
                                                height="0"
                                                style="
                                                  width: 100%;
                                                  height: 100%;
                                                "
                                              ></canvas>
                                            </div>
                                          </div>
                                          <p
                                            class="text-stroke-ipo-card font-inter-italic text-xs font-bold italic leading-[22.15px]"
                                          >
                                            1.79<!-- -->x
                                          </p></span
                                        >
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr class="cursor-pointer">
                                  <td
                                    data-key="name"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <div class="flex max-w-[210px] gap-2">
                                      <div>
                                        <div
                                          class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[1px] border-light-3"
                                        >
                                          <img
                                            alt="ipo logo"
                                            loading="lazy"
                                            width="40"
                                            height="40"
                                            decoding="async"
                                            data-nimg="1"
                                            class="rounded-full"
                                            style="color: transparent"
                                            src="https://assets.upstox.com/content/assets/images/ipo_logo/INE0VYX01018.png"
                                          />
                                        </div>
                                      </div>
                                      <div
                                        class="flex w-full flex-col overflow-hidden"
                                      >
                                        <span
                                          class="relative items-baseline text-left align-middle outline-none not-italic tracking-[-0.14px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-sm font-semibold text-dark-10"
                                          >Nukleus Office Solutions Private
                                          IPO</span
                                        ><span
                                          class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-xs font-normal not-italic leading-[150%] tracking-[-0.12px] text-dark-7"
                                          >SME</span
                                        >
                                      </div>
                                    </div>
                                  </td>
                                  <td
                                    data-key="allotmentDate"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <span>28 Feb 2025</span>
                                  </td>
                                  <td
                                    data-key="dematTransferDate"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <span>03 Mar 2025</span>
                                  </td>
                                  <td
                                    data-key="listingDate"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <span>04 Mar 2025</span>
                                  </td>
                                  <td
                                    data-key="subscription"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <div
                                      class="flex items-center justify-start gap-1 py-1.5 z-0"
                                    >
                                      <div class="flex flex-col">
                                        <span
                                          class="relative items-baseline whitespace-normal align-middle outline-none font-bold tracking-[0.01px] flex w-full border-r-green-600 text-end text-base leading-[16px] z-0 text-success-1 -mt-3 italic justify-end"
                                          title="1.15x"
                                          ><div
                                            style="transform: scale(1)"
                                            class="h-[20px] w-[16px] text-end flex relative top-[5px] -right-[3px] shrink-0"
                                          >
                                            <div
                                              class=""
                                              style="
                                                width: 100%;
                                                height: 100%;
                                                line-height: 0;
                                              "
                                            >
                                              <canvas
                                                width="0"
                                                height="0"
                                                style="
                                                  width: 100%;
                                                  height: 100%;
                                                "
                                              ></canvas>
                                            </div>
                                          </div>
                                          <p
                                            class="text-stroke-ipo-card font-inter-italic text-xs font-bold italic leading-[22.15px]"
                                          >
                                            1.15<!-- -->x
                                          </p></span
                                        >
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr class="cursor-pointer">
                                  <td
                                    data-key="name"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <div class="flex max-w-[210px] gap-2">
                                      <div>
                                        <div
                                          class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[1px] border-light-3"
                                        >
                                          <img
                                            alt="ipo logo"
                                            loading="lazy"
                                            width="40"
                                            height="40"
                                            decoding="async"
                                            data-nimg="1"
                                            class="rounded-full"
                                            style="color: transparent"
                                            src="https://assets.upstox.com/content/assets/images/ipo_logo/INE13VU01016.png"
                                          />
                                        </div>
                                      </div>
                                      <div
                                        class="flex w-full flex-col overflow-hidden"
                                      >
                                        <span
                                          class="relative items-baseline text-left align-middle outline-none not-italic tracking-[-0.14px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-sm font-semibold text-dark-10"
                                          >Beezaasan Explotech IPO</span
                                        ><span
                                          class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-xs font-normal not-italic leading-[150%] tracking-[-0.12px] text-dark-7"
                                          >SME, Mining &amp; Minerals</span
                                        >
                                      </div>
                                    </div>
                                  </td>
                                  <td
                                    data-key="allotmentDate"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <span>27 Feb 2025</span>
                                  </td>
                                  <td
                                    data-key="dematTransferDate"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <span>28 Feb 2025</span>
                                  </td>
                                  <td
                                    data-key="listingDate"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <span>03 Mar 2025</span>
                                  </td>
                                  <td
                                    data-key="subscription"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <div
                                      class="flex items-center justify-start gap-1 py-1.5 z-0"
                                    >
                                      <div class="flex flex-col">
                                        <span
                                          class="relative items-baseline whitespace-normal align-middle outline-none font-bold tracking-[0.01px] flex w-full border-r-green-600 text-end text-base leading-[16px] z-0 text-success-1 -mt-6 italic justify-end"
                                          title="5.23x"
                                          ><div
                                            style="transform: scale(1.8)"
                                            class="h-[28px] w-[20px] relative -z-10 top-[6px] -right-[4px] shrink-0"
                                          >
                                            <div
                                              class=""
                                              style="
                                                width: 100%;
                                                height: 100%;
                                                line-height: 0;
                                              "
                                            >
                                              <canvas
                                                width="0"
                                                height="0"
                                                style="
                                                  width: 100%;
                                                  height: 100%;
                                                "
                                              ></canvas>
                                            </div>
                                          </div>
                                          <p
                                            class="text-stroke-ipo-card font-inter-italic text-xs font-bold italic leading-[22.15px]"
                                          >
                                            5.23<!-- -->x
                                          </p></span
                                        >
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <hr class="my-8 h-[1px] w-full bg-light-4 xl:hidden" />
                      <div class="mt-8 flex flex-col gap-4">
                        <h2
                          class="inter-display-font text-xl font-semibold leading-6 text-dark-10"
                        >
                          Listed IPOs
                        </h2>
                        <div class="block xl:hidden">
                          <div class="flex flex-col gap-2">
                            <div
                              class="flex flex-col items-start self-stretch rounded-lg bg-light-10"
                            >
                              <div
                                class="flex items-center gap-2 self-stretch border-b border-b-light-4 px-4 py-3"
                              >
                                <div
                                  class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[1px] border-gray-300"
                                >
                                  <img
                                    alt="ipo logo"
                                    loading="lazy"
                                    width="40"
                                    height="40"
                                    decoding="async"
                                    data-nimg="1"
                                    class="rounded-full"
                                    style="color: transparent"
                                    src="https://assets.upstox.com/content/assets/images/ipo_logo/INE0W2G01015.png"
                                  />
                                </div>
                                <div
                                  class="mr-4 flex min-w-[104px] flex-1 items-center gap-4"
                                >
                                  <div
                                    class="flex w-full flex-col overflow-hidden"
                                  >
                                    <span
                                      class="relative items-baseline text-left align-middle text-dark-1 outline-none text-[14px] leading-[20px] -tracking-[0.09px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap font-semibold"
                                      >SAGILITY INDIA LIMITED</span
                                    ><span
                                      class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] text-dark-2"
                                      >Hospital &amp; Healthcare Services</span
                                    >
                                  </div>
                                </div>
                              </div>
                              <div
                                class="no-scrollbar flex flex-col items-center self-stretch overflow-x-auto p-4 [mask-image:linear-gradient(270deg,transparent,#000_30px)]"
                              >
                                <div
                                  class="flex min-w-max items-center gap-6 self-stretch"
                                >
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Listing Date</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] text-dark-7 whitespace-nowrap"
                                      >12 Nov 2024</span
                                    >
                                  </div>
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Today's LTP</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle text-dark-1 outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] whitespace-nowrap"
                                      >---</span
                                    >
                                  </div>
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Listing price</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] text-dark-7 whitespace-nowrap"
                                      >₹31.06</span
                                    >
                                  </div>
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Listing gains</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] text-success-1 whitespace-nowrap"
                                      >3.53%</span
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="flex flex-col items-start self-stretch rounded-lg bg-light-10"
                            >
                              <div
                                class="flex items-center gap-2 self-stretch border-b border-b-light-4 px-4 py-3"
                              >
                                <div
                                  class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center rounded-full border-2 overflow-visible border-main-2 p-0.5"
                                  type="button"
                                  aria-haspopup="dialog"
                                  aria-expanded="false"
                                  aria-controls="radix-:r0:"
                                  data-state="closed"
                                >
                                  <img
                                    alt="ipo logo"
                                    loading="lazy"
                                    width="40"
                                    height="40"
                                    decoding="async"
                                    data-nimg="1"
                                    class="shrink-0 rounded-full"
                                    src="https://assets.upstox.com/content/assets/images/ipo_logo/INE00H001014.png"
                                    style="color: transparent"
                                  />
                                  <div
                                    class="z-1 absolute bottom-0 right-0 flex h-5 w-5 items-center justify-center rounded-full border border-light-1 bg-main-2"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="12"
                                      height="12"
                                      fill="none"
                                      viewBox="0 0 24 25"
                                      class="shrink-0 text-light-1"
                                      color="light-1"
                                    >
                                      <g filter="url(#play_svg__a)">
                                        <path
                                          fill="#fff"
                                          d="m19.376 12.987-10.6 7.066A.5.5 0 0 1 8 19.637V5.505a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832"
                                        ></path>
                                      </g>
                                      <defs>
                                        <filter
                                          id="play_svg__a"
                                          width="29"
                                          height="29"
                                          x="-2.5"
                                          y="-0.929"
                                          color-interpolation-filters="sRGB"
                                          filterUnits="userSpaceOnUse"
                                        >
                                          <feFlood
                                            flood-opacity="0"
                                            result="BackgroundImageFix"
                                          ></feFlood>
                                          <feColorMatrix
                                            in="SourceAlpha"
                                            result="hardAlpha"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                          ></feColorMatrix>
                                          <feMorphology
                                            in="SourceAlpha"
                                            operator="dilate"
                                            radius="0.5"
                                            result="effect1_dropShadow_2340_25414"
                                          ></feMorphology>
                                          <feOffset dy="1"></feOffset>
                                          <feGaussianBlur
                                            stdDeviation="1"
                                          ></feGaussianBlur>
                                          <feColorMatrix
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0"
                                          ></feColorMatrix>
                                          <feBlend
                                            in2="BackgroundImageFix"
                                            result="effect1_dropShadow_2340_25414"
                                          ></feBlend>
                                          <feBlend
                                            in="SourceGraphic"
                                            in2="effect1_dropShadow_2340_25414"
                                            result="shape"
                                          ></feBlend>
                                        </filter>
                                      </defs>
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  class="mr-4 flex min-w-[104px] flex-1 items-center gap-4"
                                >
                                  <div
                                    class="flex w-full flex-col overflow-hidden"
                                  >
                                    <span
                                      class="relative items-baseline text-left align-middle text-dark-1 outline-none text-[14px] leading-[20px] -tracking-[0.09px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap font-semibold"
                                      >Swiggy Limited</span
                                    ><span
                                      class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] text-dark-2"
                                      >Consumer Food</span
                                    >
                                  </div>
                                </div>
                              </div>
                              <div
                                class="no-scrollbar flex flex-col items-center self-stretch overflow-x-auto p-4 [mask-image:linear-gradient(270deg,transparent,#000_30px)]"
                              >
                                <div
                                  class="flex min-w-max items-center gap-6 self-stretch"
                                >
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Listing Date</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] text-dark-7 whitespace-nowrap"
                                      >13 Nov 2024</span
                                    >
                                  </div>
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Today's LTP</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle text-dark-1 outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] whitespace-nowrap"
                                      >---</span
                                    >
                                  </div>
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Listing price</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] text-dark-7 whitespace-nowrap"
                                      >₹412.00</span
                                    >
                                  </div>
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Listing gains</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] text-success-1 whitespace-nowrap"
                                      >5.64%</span
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="flex flex-col items-start self-stretch rounded-lg bg-light-10"
                            >
                              <div
                                class="flex items-center gap-2 self-stretch border-b border-b-light-4 px-4 py-3"
                              >
                                <div
                                  class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center rounded-full border-2 overflow-visible border-main-2 p-0.5"
                                  type="button"
                                  aria-haspopup="dialog"
                                  aria-expanded="false"
                                  aria-controls="radix-:r3:"
                                  data-state="closed"
                                >
                                  <img
                                    alt="ipo logo"
                                    loading="lazy"
                                    width="40"
                                    height="40"
                                    decoding="async"
                                    data-nimg="1"
                                    class="shrink-0 rounded-full"
                                    src="https://assets.upstox.com/content/assets/images/ipo_logo/INE622W01025.png"
                                    style="color: transparent"
                                  />
                                  <div
                                    class="z-1 absolute bottom-0 right-0 flex h-5 w-5 items-center justify-center rounded-full border border-light-1 bg-main-2"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="12"
                                      height="12"
                                      fill="none"
                                      viewBox="0 0 24 25"
                                      class="shrink-0 text-light-1"
                                      color="light-1"
                                    >
                                      <g filter="url(#play_svg__a)">
                                        <path
                                          fill="#fff"
                                          d="m19.376 12.987-10.6 7.066A.5.5 0 0 1 8 19.637V5.505a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832"
                                        ></path>
                                      </g>
                                      <defs>
                                        <filter
                                          id="play_svg__a"
                                          width="29"
                                          height="29"
                                          x="-2.5"
                                          y="-0.929"
                                          color-interpolation-filters="sRGB"
                                          filterUnits="userSpaceOnUse"
                                        >
                                          <feFlood
                                            flood-opacity="0"
                                            result="BackgroundImageFix"
                                          ></feFlood>
                                          <feColorMatrix
                                            in="SourceAlpha"
                                            result="hardAlpha"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                          ></feColorMatrix>
                                          <feMorphology
                                            in="SourceAlpha"
                                            operator="dilate"
                                            radius="0.5"
                                            result="effect1_dropShadow_2340_25414"
                                          ></feMorphology>
                                          <feOffset dy="1"></feOffset>
                                          <feGaussianBlur
                                            stdDeviation="1"
                                          ></feGaussianBlur>
                                          <feColorMatrix
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0"
                                          ></feColorMatrix>
                                          <feBlend
                                            in2="BackgroundImageFix"
                                            result="effect1_dropShadow_2340_25414"
                                          ></feBlend>
                                          <feBlend
                                            in="SourceGraphic"
                                            in2="effect1_dropShadow_2340_25414"
                                            result="shape"
                                          ></feBlend>
                                        </filter>
                                      </defs>
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  class="mr-4 flex min-w-[104px] flex-1 items-center gap-4"
                                >
                                  <div
                                    class="flex w-full flex-col overflow-hidden"
                                  >
                                    <span
                                      class="relative items-baseline text-left align-middle text-dark-1 outline-none text-[14px] leading-[20px] -tracking-[0.09px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap font-semibold"
                                      >ACME SOLAR HOLDINGS IPO</span
                                    ><span
                                      class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] text-dark-2"
                                      >Power Generation/Distribution</span
                                    >
                                  </div>
                                </div>
                              </div>
                              <div
                                class="no-scrollbar flex flex-col items-center self-stretch overflow-x-auto p-4 [mask-image:linear-gradient(270deg,transparent,#000_30px)]"
                              >
                                <div
                                  class="flex min-w-max items-center gap-6 self-stretch"
                                >
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Listing Date</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] text-dark-7 whitespace-nowrap"
                                      >13 Nov 2024</span
                                    >
                                  </div>
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Today's LTP</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle text-dark-1 outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] whitespace-nowrap"
                                      >---</span
                                    >
                                  </div>
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Listing price</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] text-dark-7 whitespace-nowrap"
                                      >₹259.00</span
                                    >
                                  </div>
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Listing gains</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] text-error-1 whitespace-nowrap"
                                      >-10.38%</span
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="flex flex-col items-start self-stretch rounded-lg bg-light-10"
                            >
                              <div
                                class="flex items-center gap-2 self-stretch border-b border-b-light-4 px-4 py-3"
                              >
                                <div
                                  class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center rounded-full border-2 overflow-visible border-main-2 p-0.5"
                                  type="button"
                                  aria-haspopup="dialog"
                                  aria-expanded="false"
                                  aria-controls="radix-:r6:"
                                  data-state="closed"
                                >
                                  <img
                                    alt="ipo logo"
                                    loading="lazy"
                                    width="40"
                                    height="40"
                                    decoding="async"
                                    data-nimg="1"
                                    class="shrink-0 rounded-full"
                                    src="https://assets.upstox.com/content/assets/images/ipo_logo/INE995S01015.png"
                                    style="color: transparent"
                                  />
                                  <div
                                    class="z-1 absolute bottom-0 right-0 flex h-5 w-5 items-center justify-center rounded-full border border-light-1 bg-main-2"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="12"
                                      height="12"
                                      fill="none"
                                      viewBox="0 0 24 25"
                                      class="shrink-0 text-light-1"
                                      color="light-1"
                                    >
                                      <g filter="url(#play_svg__a)">
                                        <path
                                          fill="#fff"
                                          d="m19.376 12.987-10.6 7.066A.5.5 0 0 1 8 19.637V5.505a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832"
                                        ></path>
                                      </g>
                                      <defs>
                                        <filter
                                          id="play_svg__a"
                                          width="29"
                                          height="29"
                                          x="-2.5"
                                          y="-0.929"
                                          color-interpolation-filters="sRGB"
                                          filterUnits="userSpaceOnUse"
                                        >
                                          <feFlood
                                            flood-opacity="0"
                                            result="BackgroundImageFix"
                                          ></feFlood>
                                          <feColorMatrix
                                            in="SourceAlpha"
                                            result="hardAlpha"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                          ></feColorMatrix>
                                          <feMorphology
                                            in="SourceAlpha"
                                            operator="dilate"
                                            radius="0.5"
                                            result="effect1_dropShadow_2340_25414"
                                          ></feMorphology>
                                          <feOffset dy="1"></feOffset>
                                          <feGaussianBlur
                                            stdDeviation="1"
                                          ></feGaussianBlur>
                                          <feColorMatrix
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0"
                                          ></feColorMatrix>
                                          <feBlend
                                            in2="BackgroundImageFix"
                                            result="effect1_dropShadow_2340_25414"
                                          ></feBlend>
                                          <feBlend
                                            in="SourceGraphic"
                                            in2="effect1_dropShadow_2340_25414"
                                            result="shape"
                                          ></feBlend>
                                        </filter>
                                      </defs>
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  class="mr-4 flex min-w-[104px] flex-1 items-center gap-4"
                                >
                                  <div
                                    class="flex w-full flex-col overflow-hidden"
                                  >
                                    <span
                                      class="relative items-baseline text-left align-middle text-dark-1 outline-none text-[14px] leading-[20px] -tracking-[0.09px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap font-semibold"
                                      >NIVA BUPA HEALTH INSURANCE COMPANY
                                      LIMITED</span
                                    ><span
                                      class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] text-dark-2"
                                      >Insurance</span
                                    >
                                  </div>
                                </div>
                              </div>
                              <div
                                class="no-scrollbar flex flex-col items-center self-stretch overflow-x-auto p-4 [mask-image:linear-gradient(270deg,transparent,#000_30px)]"
                              >
                                <div
                                  class="flex min-w-max items-center gap-6 self-stretch"
                                >
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Listing Date</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] text-dark-7 whitespace-nowrap"
                                      >14 Nov 2024</span
                                    >
                                  </div>
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Today's LTP</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle text-dark-1 outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] whitespace-nowrap"
                                      >---</span
                                    >
                                  </div>
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Listing price</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] text-dark-7 whitespace-nowrap"
                                      >₹78.50</span
                                    >
                                  </div>
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Listing gains</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] text-success-1 whitespace-nowrap"
                                      >6.08%</span
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="flex flex-col items-start self-stretch rounded-lg bg-light-10"
                            >
                              <div
                                class="flex items-center gap-2 self-stretch border-b border-b-light-4 px-4 py-3"
                              >
                                <div
                                  class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[1px] border-gray-300"
                                >
                                  <img
                                    alt="ipo logo"
                                    loading="lazy"
                                    width="40"
                                    height="40"
                                    decoding="async"
                                    data-nimg="1"
                                    class="rounded-full"
                                    style="color: transparent"
                                    src="https://assets.upstox.com/content/assets/images/ipo_logo/INE0SUH01015.png"
                                  />
                                </div>
                                <div
                                  class="mr-4 flex min-w-[104px] flex-1 items-center gap-4"
                                >
                                  <div
                                    class="flex w-full flex-col overflow-hidden"
                                  >
                                    <span
                                      class="relative items-baseline text-left align-middle text-dark-1 outline-none text-[14px] leading-[20px] -tracking-[0.09px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap font-semibold"
                                      >Envirotech Systems Limited</span
                                    ><span
                                      class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] text-dark-2"
                                      >SME</span
                                    >
                                  </div>
                                </div>
                              </div>
                              <div
                                class="no-scrollbar flex flex-col items-center self-stretch overflow-x-auto p-4 [mask-image:linear-gradient(270deg,transparent,#000_30px)]"
                              >
                                <div
                                  class="flex min-w-max items-center gap-6 self-stretch"
                                >
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Listing Date</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] text-dark-7 whitespace-nowrap"
                                      >24 Sep 2024</span
                                    >
                                  </div>
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Today's LTP</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle text-dark-1 outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] whitespace-nowrap"
                                      >---</span
                                    >
                                  </div>
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Listing price</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] text-dark-7 whitespace-nowrap"
                                      >₹106.40</span
                                    >
                                  </div>
                                  <div
                                    class="flex flex-[1_0_0] flex-col items-center gap-0.5"
                                  >
                                    <span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-[12px] font-medium leading-[16px] tracking-[0.01px] whitespace-nowrap text-dark-7"
                                      >Listing gains</span
                                    ><span
                                      class="relative inline-flex items-baseline text-left align-middle outline-none text-xs font-semibold not-italic leading-[150%] tracking-[-0.12px] text-success-1 whitespace-nowrap"
                                      >90.00%</span
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="hidden xl:block">
                          <div
                            class="table-wrapper no-scrollbar overflow-x-auto"
                          >
                            <table class="min-w-full">
                              <thead>
                                <tr>
                                  <th
                                    class="bg-light-10 px-4 py-3 text-left cursor-pointer !shadow-none"
                                  >
                                    <div class="flex items-center gap-[2px]">
                                      <span
                                        class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none -tracking-[0.09px] inter-display-font text-sm font-semibold text-dark-10"
                                        >Name</span
                                      ><span
                                        ><svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="none"
                                          viewBox="0 0 16 17"
                                          class="shrink-0"
                                        >
                                          <mask
                                            id="default-sort_svg__a"
                                            width="16"
                                            height="17"
                                            x="0"
                                            y="0"
                                            maskUnits="userSpaceOnUse"
                                            style="mask-type: alpha"
                                          >
                                            <path
                                              fill="#D9D9D9"
                                              d="M0 .5h16v16H0z"
                                            ></path>
                                          </mask>
                                          <g mask="url(#default-sort_svg__a)">
                                            <path
                                              fill="#111"
                                              d="M5.333 9.167V4.383L3.617 6.1l-.95-.933L6 1.833l3.333 3.334-.95.933-1.716-1.717v4.784zm4.667 6-3.333-3.334.95-.933 1.716 1.717V7.833h1.334v4.784l1.716-1.717.95.933z"
                                            ></path>
                                          </g></svg
                                      ></span>
                                    </div>
                                  </th>
                                  <th
                                    class="bg-light-10 px-4 py-3 text-left cursor-pointer !shadow-none"
                                  >
                                    <div class="flex items-center gap-[2px]">
                                      <span
                                        class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none -tracking-[0.09px] inter-display-font text-sm font-semibold text-primary-accent3"
                                        >Listing Date</span
                                      ><span
                                        ><svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="none"
                                          viewBox="0 0 16 17"
                                          class="shrink-0"
                                        >
                                          <mask
                                            id="sort-down-arrow_svg__a"
                                            width="16"
                                            height="17"
                                            x="0"
                                            y="0"
                                            maskUnits="userSpaceOnUse"
                                            style="mask-type: alpha"
                                          >
                                            <path
                                              fill="#D9D9D9"
                                              d="M16 16.5H0V.5h16z"
                                            ></path>
                                          </mask>
                                          <g
                                            mask="url(#sort-down-arrow_svg__a)"
                                          >
                                            <path
                                              fill="#7132B0"
                                              d="M8.667 4.5v6.133l2.4-2.4.933.934-4 4-4-4 .933-.934 2.4 2.4V4.5z"
                                            ></path>
                                          </g></svg
                                      ></span>
                                    </div>
                                  </th>
                                  <th
                                    class="bg-light-10 px-4 py-3 text-left !shadow-none"
                                  >
                                    <div class="flex items-center gap-[2px]">
                                      <span
                                        class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none -tracking-[0.09px] inter-display-font text-sm font-semibold text-dark-10"
                                        >Today's LTP</span
                                      >
                                    </div>
                                  </th>
                                  <th
                                    class="bg-light-10 px-4 py-3 text-left cursor-pointer !shadow-none"
                                  >
                                    <div class="flex items-center gap-[2px]">
                                      <span
                                        class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none -tracking-[0.09px] inter-display-font text-sm font-semibold text-dark-10"
                                        >Listing Price</span
                                      ><span
                                        ><svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="none"
                                          viewBox="0 0 16 17"
                                          class="shrink-0"
                                        >
                                          <mask
                                            id="default-sort_svg__a"
                                            width="16"
                                            height="17"
                                            x="0"
                                            y="0"
                                            maskUnits="userSpaceOnUse"
                                            style="mask-type: alpha"
                                          >
                                            <path
                                              fill="#D9D9D9"
                                              d="M0 .5h16v16H0z"
                                            ></path>
                                          </mask>
                                          <g mask="url(#default-sort_svg__a)">
                                            <path
                                              fill="#111"
                                              d="M5.333 9.167V4.383L3.617 6.1l-.95-.933L6 1.833l3.333 3.334-.95.933-1.716-1.717v4.784zm4.667 6-3.333-3.334.95-.933 1.716 1.717V7.833h1.334v4.784l1.716-1.717.95.933z"
                                            ></path>
                                          </g></svg
                                      ></span>
                                    </div>
                                  </th>
                                  <th
                                    class="bg-light-10 px-4 py-3 text-left cursor-pointer !shadow-none"
                                  >
                                    <div class="flex items-center gap-[2px]">
                                      <span
                                        class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none -tracking-[0.09px] inter-display-font text-sm font-semibold text-dark-10"
                                        >Listing gains/loss</span
                                      ><span
                                        ><svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="none"
                                          viewBox="0 0 16 17"
                                          class="shrink-0"
                                        >
                                          <mask
                                            id="default-sort_svg__a"
                                            width="16"
                                            height="17"
                                            x="0"
                                            y="0"
                                            maskUnits="userSpaceOnUse"
                                            style="mask-type: alpha"
                                          >
                                            <path
                                              fill="#D9D9D9"
                                              d="M0 .5h16v16H0z"
                                            ></path>
                                          </mask>
                                          <g mask="url(#default-sort_svg__a)">
                                            <path
                                              fill="#111"
                                              d="M5.333 9.167V4.383L3.617 6.1l-.95-.933L6 1.833l3.333 3.334-.95.933-1.716-1.717v4.784zm4.667 6-3.333-3.334.95-.933 1.716 1.717V7.833h1.334v4.784l1.716-1.717.95.933z"
                                            ></path>
                                          </g></svg
                                      ></span>
                                    </div>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr class="cursor-pointer">
                                  <td
                                    data-key="name"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <div class="flex max-w-[210px] gap-2">
                                      <div>
                                        <div
                                          class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center rounded-full border-2 overflow-visible border-main-2 p-0.5"
                                        >
                                          <img
                                            alt="ipo logo"
                                            loading="lazy"
                                            width="40"
                                            height="40"
                                            decoding="async"
                                            data-nimg="1"
                                            class="shrink-0 rounded-full"
                                            style="color: transparent"
                                            src="https://assets.upstox.com/content/assets/images/ipo_logo/INE995S01015.png"
                                          />
                                          <div
                                            class="z-1 absolute bottom-0 right-0 flex h-5 w-5 items-center justify-center rounded-full border border-light-1 bg-main-2"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="12"
                                              height="12"
                                              fill="none"
                                              viewBox="0 0 24 25"
                                              class="shrink-0 text-light-3"
                                              color="light-1"
                                            >
                                              <g filter="url(#play_svg__a)">
                                                <path
                                                  fill="#fff"
                                                  d="m19.376 12.987-10.6 7.066A.5.5 0 0 1 8 19.637V5.505a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832"
                                                ></path>
                                              </g>
                                              <defs>
                                                <filter
                                                  id="play_svg__a"
                                                  width="29"
                                                  height="29"
                                                  x="-2.5"
                                                  y="-0.929"
                                                  color-interpolation-filters="sRGB"
                                                  filterUnits="userSpaceOnUse"
                                                >
                                                  <feFlood
                                                    flood-opacity="0"
                                                    result="BackgroundImageFix"
                                                  ></feFlood>
                                                  <feColorMatrix
                                                    in="SourceAlpha"
                                                    result="hardAlpha"
                                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                  ></feColorMatrix>
                                                  <feMorphology
                                                    in="SourceAlpha"
                                                    operator="dilate"
                                                    radius="0.5"
                                                    result="effect1_dropShadow_2340_25414"
                                                  ></feMorphology>
                                                  <feOffset dy="1"></feOffset>
                                                  <feGaussianBlur
                                                    stdDeviation="1"
                                                  ></feGaussianBlur>
                                                  <feColorMatrix
                                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0"
                                                  ></feColorMatrix>
                                                  <feBlend
                                                    in2="BackgroundImageFix"
                                                    result="effect1_dropShadow_2340_25414"
                                                  ></feBlend>
                                                  <feBlend
                                                    in="SourceGraphic"
                                                    in2="effect1_dropShadow_2340_25414"
                                                    result="shape"
                                                  ></feBlend>
                                                </filter>
                                              </defs>
                                            </svg>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="flex w-full flex-col overflow-hidden"
                                      >
                                        <span
                                          class="relative items-baseline text-left align-middle outline-none not-italic tracking-[-0.14px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-sm font-semibold text-dark-10"
                                          >NIVA BUPA HEALTH INSURANCE COMPANY
                                          LIMITED</span
                                        ><span
                                          class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-xs font-normal not-italic leading-[150%] tracking-[-0.12px] text-dark-7"
                                          >Mainboard, Insurance</span
                                        >
                                      </div>
                                    </div>
                                  </td>
                                  <td
                                    data-key="listingDate"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <span>14 Nov 2024</span>
                                  </td>
                                  <td
                                    data-key="todayLTPPrice"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    ---
                                  </td>
                                  <td
                                    data-key="listingPrice"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <span
                                      class="text-sm font-normal text-dark-10"
                                      >₹78.50</span
                                    >
                                  </td>
                                  <td
                                    data-key="listingGains"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <span class="text-success-1"
                                      >6.08<!-- -->%</span
                                    >
                                  </td>
                                </tr>
                                <tr class="cursor-pointer">
                                  <td
                                    data-key="name"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <div class="flex max-w-[210px] gap-2">
                                      <div>
                                        <div
                                          class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center rounded-full border-2 overflow-visible border-main-2 p-0.5"
                                        >
                                          <img
                                            alt="ipo logo"
                                            loading="lazy"
                                            width="40"
                                            height="40"
                                            decoding="async"
                                            data-nimg="1"
                                            class="shrink-0 rounded-full"
                                            style="color: transparent"
                                            src="https://assets.upstox.com/content/assets/images/ipo_logo/INE00H001014.png"
                                          />
                                          <div
                                            class="z-1 absolute bottom-0 right-0 flex h-5 w-5 items-center justify-center rounded-full border border-light-1 bg-main-2"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="12"
                                              height="12"
                                              fill="none"
                                              viewBox="0 0 24 25"
                                              class="shrink-0 text-light-3"
                                              color="light-1"
                                            >
                                              <g filter="url(#play_svg__a)">
                                                <path
                                                  fill="#fff"
                                                  d="m19.376 12.987-10.6 7.066A.5.5 0 0 1 8 19.637V5.505a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832"
                                                ></path>
                                              </g>
                                              <defs>
                                                <filter
                                                  id="play_svg__a"
                                                  width="29"
                                                  height="29"
                                                  x="-2.5"
                                                  y="-0.929"
                                                  color-interpolation-filters="sRGB"
                                                  filterUnits="userSpaceOnUse"
                                                >
                                                  <feFlood
                                                    flood-opacity="0"
                                                    result="BackgroundImageFix"
                                                  ></feFlood>
                                                  <feColorMatrix
                                                    in="SourceAlpha"
                                                    result="hardAlpha"
                                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                  ></feColorMatrix>
                                                  <feMorphology
                                                    in="SourceAlpha"
                                                    operator="dilate"
                                                    radius="0.5"
                                                    result="effect1_dropShadow_2340_25414"
                                                  ></feMorphology>
                                                  <feOffset dy="1"></feOffset>
                                                  <feGaussianBlur
                                                    stdDeviation="1"
                                                  ></feGaussianBlur>
                                                  <feColorMatrix
                                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0"
                                                  ></feColorMatrix>
                                                  <feBlend
                                                    in2="BackgroundImageFix"
                                                    result="effect1_dropShadow_2340_25414"
                                                  ></feBlend>
                                                  <feBlend
                                                    in="SourceGraphic"
                                                    in2="effect1_dropShadow_2340_25414"
                                                    result="shape"
                                                  ></feBlend>
                                                </filter>
                                              </defs>
                                            </svg>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="flex w-full flex-col overflow-hidden"
                                      >
                                        <span
                                          class="relative items-baseline text-left align-middle outline-none not-italic tracking-[-0.14px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-sm font-semibold text-dark-10"
                                          >Swiggy Limited</span
                                        ><span
                                          class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-xs font-normal not-italic leading-[150%] tracking-[-0.12px] text-dark-7"
                                          >Mainboard, Consumer Food</span
                                        >
                                      </div>
                                    </div>
                                  </td>
                                  <td
                                    data-key="listingDate"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <span>13 Nov 2024</span>
                                  </td>
                                  <td
                                    data-key="todayLTPPrice"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    ---
                                  </td>
                                  <td
                                    data-key="listingPrice"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <span
                                      class="text-sm font-normal text-dark-10"
                                      >₹412.00</span
                                    >
                                  </td>
                                  <td
                                    data-key="listingGains"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <span class="text-success-1"
                                      >5.64<!-- -->%</span
                                    >
                                  </td>
                                </tr>
                                <tr class="cursor-pointer">
                                  <td
                                    data-key="name"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <div class="flex max-w-[210px] gap-2">
                                      <div>
                                        <div
                                          class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center rounded-full border-2 overflow-visible border-main-2 p-0.5"
                                        >
                                          <img
                                            alt="ipo logo"
                                            loading="lazy"
                                            width="40"
                                            height="40"
                                            decoding="async"
                                            data-nimg="1"
                                            class="shrink-0 rounded-full"
                                            style="color: transparent"
                                            src="https://assets.upstox.com/content/assets/images/ipo_logo/INE622W01025.png"
                                          />
                                          <div
                                            class="z-1 absolute bottom-0 right-0 flex h-5 w-5 items-center justify-center rounded-full border border-light-1 bg-main-2"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="12"
                                              height="12"
                                              fill="none"
                                              viewBox="0 0 24 25"
                                              class="shrink-0 text-light-3"
                                              color="light-1"
                                            >
                                              <g filter="url(#play_svg__a)">
                                                <path
                                                  fill="#fff"
                                                  d="m19.376 12.987-10.6 7.066A.5.5 0 0 1 8 19.637V5.505a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832"
                                                ></path>
                                              </g>
                                              <defs>
                                                <filter
                                                  id="play_svg__a"
                                                  width="29"
                                                  height="29"
                                                  x="-2.5"
                                                  y="-0.929"
                                                  color-interpolation-filters="sRGB"
                                                  filterUnits="userSpaceOnUse"
                                                >
                                                  <feFlood
                                                    flood-opacity="0"
                                                    result="BackgroundImageFix"
                                                  ></feFlood>
                                                  <feColorMatrix
                                                    in="SourceAlpha"
                                                    result="hardAlpha"
                                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                  ></feColorMatrix>
                                                  <feMorphology
                                                    in="SourceAlpha"
                                                    operator="dilate"
                                                    radius="0.5"
                                                    result="effect1_dropShadow_2340_25414"
                                                  ></feMorphology>
                                                  <feOffset dy="1"></feOffset>
                                                  <feGaussianBlur
                                                    stdDeviation="1"
                                                  ></feGaussianBlur>
                                                  <feColorMatrix
                                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0"
                                                  ></feColorMatrix>
                                                  <feBlend
                                                    in2="BackgroundImageFix"
                                                    result="effect1_dropShadow_2340_25414"
                                                  ></feBlend>
                                                  <feBlend
                                                    in="SourceGraphic"
                                                    in2="effect1_dropShadow_2340_25414"
                                                    result="shape"
                                                  ></feBlend>
                                                </filter>
                                              </defs>
                                            </svg>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="flex w-full flex-col overflow-hidden"
                                      >
                                        <span
                                          class="relative items-baseline text-left align-middle outline-none not-italic tracking-[-0.14px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-sm font-semibold text-dark-10"
                                          >ACME SOLAR HOLDINGS IPO</span
                                        ><span
                                          class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-xs font-normal not-italic leading-[150%] tracking-[-0.12px] text-dark-7"
                                          >Mainboard, Power
                                          Generation/Distribution</span
                                        >
                                      </div>
                                    </div>
                                  </td>
                                  <td
                                    data-key="listingDate"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <span>13 Nov 2024</span>
                                  </td>
                                  <td
                                    data-key="todayLTPPrice"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    ---
                                  </td>
                                  <td
                                    data-key="listingPrice"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <span
                                      class="text-sm font-normal text-dark-10"
                                      >₹259.00</span
                                    >
                                  </td>
                                  <td
                                    data-key="listingGains"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <span class="text-error-1"
                                      >-10.38<!-- -->%</span
                                    >
                                  </td>
                                </tr>
                                <tr class="cursor-pointer">
                                  <td
                                    data-key="name"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <div class="flex max-w-[210px] gap-2">
                                      <div>
                                        <div
                                          class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[1px] border-light-3"
                                        >
                                          <img
                                            alt="ipo logo"
                                            loading="lazy"
                                            width="40"
                                            height="40"
                                            decoding="async"
                                            data-nimg="1"
                                            class="rounded-full"
                                            style="color: transparent"
                                            src="https://assets.upstox.com/content/assets/images/ipo_logo/INE0W2G01015.png"
                                          />
                                        </div>
                                      </div>
                                      <div
                                        class="flex w-full flex-col overflow-hidden"
                                      >
                                        <span
                                          class="relative items-baseline text-left align-middle outline-none not-italic tracking-[-0.14px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-sm font-semibold text-dark-10"
                                          >SAGILITY INDIA LIMITED</span
                                        ><span
                                          class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-xs font-normal not-italic leading-[150%] tracking-[-0.12px] text-dark-7"
                                          >Mainboard, Hospital &amp; Healthcare
                                          Services</span
                                        >
                                      </div>
                                    </div>
                                  </td>
                                  <td
                                    data-key="listingDate"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <span>12 Nov 2024</span>
                                  </td>
                                  <td
                                    data-key="todayLTPPrice"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    ---
                                  </td>
                                  <td
                                    data-key="listingPrice"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <span
                                      class="text-sm font-normal text-dark-10"
                                      >₹31.06</span
                                    >
                                  </td>
                                  <td
                                    data-key="listingGains"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <span class="text-success-1"
                                      >3.53<!-- -->%</span
                                    >
                                  </td>
                                </tr>
                                <tr class="cursor-pointer">
                                  <td
                                    data-key="name"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <div class="flex max-w-[210px] gap-2">
                                      <div>
                                        <div
                                          class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[1px] border-light-3"
                                        >
                                          <img
                                            alt="ipo logo"
                                            loading="lazy"
                                            width="40"
                                            height="40"
                                            decoding="async"
                                            data-nimg="1"
                                            class="rounded-full"
                                            style="color: transparent"
                                            src="https://assets.upstox.com/content/assets/images/ipo_logo/INE0SUH01015.png"
                                          />
                                        </div>
                                      </div>
                                      <div
                                        class="flex w-full flex-col overflow-hidden"
                                      >
                                        <span
                                          class="relative items-baseline text-left align-middle outline-none not-italic tracking-[-0.14px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-sm font-semibold text-dark-10"
                                          >Envirotech Systems Limited</span
                                        ><span
                                          class="relative inline-flex items-baseline whitespace-normal text-left align-middle outline-none text-xs font-normal not-italic leading-[150%] tracking-[-0.12px] text-dark-7"
                                          >SME</span
                                        >
                                      </div>
                                    </div>
                                  </td>
                                  <td
                                    data-key="listingDate"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <span>24 Sep 2024</span>
                                  </td>
                                  <td
                                    data-key="todayLTPPrice"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    ---
                                  </td>
                                  <td
                                    data-key="listingPrice"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <span
                                      class="text-sm font-normal text-dark-10"
                                      >₹106.40</span
                                    >
                                  </td>
                                  <td
                                    data-key="listingGains"
                                    class="px-4 py-3 !shadow-none"
                                  >
                                    <span class="text-success-1"
                                      >90.00<!-- -->%</span
                                    >
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="flex w-full justify-center xl:hidden">
                          <button
                            class="group cursor-pointer px-4 py-2 text-sm disabled:cursor-not-allowed border border-primary-base text-primary-base hover:bg-primary-light active:bg-primary-base2 active:text-white disabled:border-primary-base/50 disabled:bg-white disabled:text-primary-base/50 rounded-full w-full pt-3 font-bold leading-6"
                          >
                            View more listed IPOs
                          </button>
                        </div>
                        <a
                          class="hidden xl:block"
                          href="/ipo/sme/recently-listed-sme-ipo/"
                          ><div class="flex items-center gap-[2px]">
                            <span
                              class="text-sm font-bold leading-[18px] text-primary-accent3"
                              >View more listed IPOs</span
                            ><svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              fill="none"
                              viewBox="0 0 20 20"
                              class="shrink-0 h-5 w-5"
                            >
                              <mask
                                id="right-purple_svg__a"
                                width="20"
                                height="20"
                                x="0"
                                y="0"
                                maskUnits="userSpaceOnUse"
                                style="mask-type: alpha"
                              >
                                <path fill="#D9D9D9" d="M0 0h20v20H0z"></path>
                              </mask>
                              <g mask="url(#right-purple_svg__a)">
                                <path
                                  fill="#7132B0"
                                  d="M11.665 15 10.5 13.792l2.958-2.959H3.332V9.167h10.125l-2.958-2.959L11.665 5l5 5z"
                                ></path>
                              </g>
                            </svg></div
                        ></a>
                      </div>
                      <hr class="my-8 h-[1px] w-full bg-light-4 xl:hidden" />
                    </div>
                  </div>
                  <div class="flex flex-col sm:mt-[60px] sm:gap-[60px]">
                    <div class="xl:hidden">
                      <div>
                        <h2
                          class="inter-display-font mb-6 font-semibold text-2xl text-gray-dark3"
                        >
                          How to apply for IPOs on Upstox
                        </h2>
                        <div class="flex flex-col gap-8 sm:gap-5">
                          <div class="relative flex items-start">
                            <div class="flex flex-col items-center">
                              <div class="h-2 w-2 rounded-full bg-main-7"></div>
                              <div
                                class="absolute top-5 h-full w-[2px] bg-dark-8 md:top-3"
                              ></div>
                            </div>
                            <div class="ml-4">
                              <p
                                class="text-[12px] font-semibold uppercase leading-[110%] tracking-[1.6px] text-dark-7 sm:text-[8px] sm:font-medium"
                              >
                                Step
                                <!-- -->1
                              </p>
                              <p
                                class="mt-2 text-base font-semibold leading-[150%] text-dark-10 sm:text-sm sm:font-medium"
                              >
                                Go to www.upstox.com/ipo or open the Upstox
                                mobile app and select the IPO you wish to apply
                                for from the 'Open IPO' section
                              </p>
                            </div>
                          </div>
                          <div class="relative flex items-start">
                            <div class="flex flex-col items-center">
                              <div class="h-2 w-2 rounded-full bg-main-7"></div>
                              <div
                                class="absolute top-5 h-full w-[2px] bg-dark-8 md:top-3"
                              ></div>
                            </div>
                            <div class="ml-4">
                              <p
                                class="text-[12px] font-semibold uppercase leading-[110%] tracking-[1.6px] text-dark-7 sm:text-[8px] sm:font-medium"
                              >
                                Step
                                <!-- -->2
                              </p>
                              <p
                                class="mt-2 text-base font-semibold leading-[150%] text-dark-10 sm:text-sm sm:font-medium"
                              >
                                Click on apply, enter the lot size, price and
                                provide your UPI mandate.
                              </p>
                            </div>
                          </div>
                          <div class="relative flex items-start">
                            <div class="flex flex-col items-center">
                              <div class="h-2 w-2 rounded-full bg-main-7"></div>
                            </div>
                            <div class="ml-4">
                              <p
                                class="text-[12px] font-semibold uppercase leading-[110%] tracking-[1.6px] text-dark-7 sm:text-[8px] sm:font-medium"
                              >
                                Step
                                <!-- -->3
                              </p>
                              <p
                                class="mt-2 text-base font-semibold leading-[150%] text-dark-10 sm:text-sm sm:font-medium"
                              >
                                Approve the UPI mandate on your UPI app and you
                                are all set!
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr class="my-8 h-[1px] w-full bg-light-4" />
                    </div>
                    <div data-section="true">
                      <h2
                        class="font-semibold -tracking-[0.47px] inter-display-font mb-6 text-2xl text-dark-10"
                      >
                        Latest News on IPO
                      </h2>
                      <div class="relative">
                        <div class="flex flex-col overflow-hidden">
                          <div
                            class="no-scrollbar z-0 snap-x snap-mandatory overflow-x-scroll scroll-smooth flex w-full flex-col sm:flex-row gap-6 sm:gap-5"
                          >
                            <a
                              class="flex min-w-full max-w-full cursor-pointer flex-row items-start gap-x-4 sm:min-w-[300px] sm:max-w-[300px] sm:flex-col"
                              href="/news/market-news/ipo/balaji-phosphates-ipo-booked-19-on-day-1-check-issue-size-price-band-and-more/article-149284/"
                              ><div
                                class="h-[60px] w-[110px] flex-shrink-0 overflow-hidden rounded-lg sm:h-[170px] sm:w-full"
                              >
                                <img
                                  alt="news logo"
                                  loading="lazy"
                                  width="300"
                                  height="170"
                                  decoding="async"
                                  data-nimg="1"
                                  class="h-full w-full object-cover"
                                  style="color: transparent"
                                  src="https://assets.upstox.com/content/assets/images/news/balaji-phosphates.webp"
                                />
                              </div>
                              <div class="flex flex-col items-start">
                                <span
                                  class="truncate-lines-2 min-h-[40px] text-base font-semibold leading-5 text-gray-dark3 sm:mb-3 sm:mt-4"
                                  >The phosphates manufacturer’s public offer is
                                  open for subscription until Tuesday, March 4.
                                  Through its maiden share sale, the company
                                  aims to raise ₹50.11 crore from the primary
                                  market. Balaji Phosphates's IPO listing date
                                  has been scheduled for March 7.</span
                                >
                                <p
                                  class="text-xs font-normal leading-5 tracking-[-0.12px] text-dark-2"
                                >
                                  4 min read
                                </p>
                              </div></a
                            ><a
                              class="flex min-w-full max-w-full cursor-pointer flex-row items-start gap-x-4 sm:min-w-[300px] sm:max-w-[300px] sm:flex-col"
                              href="/news/market-news/ipo/ipo-wrap-balaji-phosphates-ipo-opens-to-weak-demand-hp-telecom-india-makes-decent-debut-and-more/article-149286/"
                              ><div
                                class="h-[60px] w-[110px] flex-shrink-0 overflow-hidden rounded-lg sm:h-[170px] sm:w-full"
                              >
                                <img
                                  alt="news logo"
                                  loading="lazy"
                                  width="300"
                                  height="170"
                                  decoding="async"
                                  data-nimg="1"
                                  class="h-full w-full object-cover"
                                  style="color: transparent"
                                  src="https://assets.upstox.com/content/assets/images/news/ipos1.webp"
                                />
                              </div>
                              <div class="flex flex-col items-start">
                                <span
                                  class="truncate-lines-2 min-h-[40px] text-base font-semibold leading-5 text-gray-dark3 sm:mb-3 sm:mt-4"
                                  >Primary market investors on Friday witnessed
                                  the dull opening of another initial public
                                  offering (IPO) of a small and medium
                                  enterprise (SME). Additionally, two new stocks
                                  listed on the SME exchanges without generating
                                  any major gains for their subscribers.</span
                                >
                                <p
                                  class="text-xs font-normal leading-5 tracking-[-0.12px] text-dark-2"
                                >
                                  3 min read
                                </p>
                              </div></a
                            ><a
                              class="flex min-w-full max-w-full cursor-pointer flex-row items-start gap-x-4 sm:min-w-[300px] sm:max-w-[300px] sm:flex-col"
                              href="/news/market-news/ipo/naps-global-india-ipo-strengths-risks-strategies-and-financials/article-149208/"
                              ><div
                                class="h-[60px] w-[110px] flex-shrink-0 overflow-hidden rounded-lg sm:h-[170px] sm:w-full"
                              >
                                <img
                                  alt="news logo"
                                  loading="lazy"
                                  width="300"
                                  height="170"
                                  decoding="async"
                                  data-nimg="1"
                                  class="h-full w-full object-cover"
                                  style="color: transparent"
                                  src="https://assets.upstox.com/content/assets/images/news/naps-global-india-ipo-gmp-date.webp"
                                />
                              </div>
                              <div class="flex flex-col items-start">
                                <span
                                  class="truncate-lines-2 min-h-[40px] text-base font-semibold leading-5 text-gray-dark3 sm:mb-3 sm:mt-4"
                                  >NAPS Global India IPO: The initial share sale
                                  is a fresh issue of shares valued at ₹11.88
                                  crore. The net proceeds will be utilised for
                                  working capital requirements and corporate
                                  general purposes.
                                </span>
                                <p
                                  class="text-xs font-normal leading-5 tracking-[-0.12px] text-dark-2"
                                >
                                  2 min read
                                </p>
                              </div></a
                            ><a
                              class="flex min-w-full max-w-full cursor-pointer flex-row items-start gap-x-4 sm:min-w-[300px] sm:max-w-[300px] sm:flex-col"
                              href="/news/market-news/ipo/another-disappointing-debut-swasth-foodtech-india-shares-list-flat-on-bse-sme-platform/article-149111/"
                              ><div
                                class="h-[60px] w-[110px] flex-shrink-0 overflow-hidden rounded-lg sm:h-[170px] sm:w-full"
                              >
                                <img
                                  alt="news logo"
                                  loading="lazy"
                                  width="300"
                                  height="170"
                                  decoding="async"
                                  data-nimg="1"
                                  class="h-full w-full object-cover"
                                  style="color: transparent"
                                  src="https://assets.upstox.com/content/assets/images/news/swasthfoodtechindialtd.webp"
                                />
                              </div>
                              <div class="flex flex-col items-start">
                                <span
                                  class="truncate-lines-2 min-h-[40px] text-base font-semibold leading-5 text-gray-dark3 sm:mb-3 sm:mt-4"
                                  >Swasth Foodtech share price: As the listing
                                  price was the same as the issue price,
                                  investors who were allotted shares in the IPO
                                  did not make any gains after the stock started
                                  trading in the secondary market. Within
                                  minutes of trade, the stock price fell 5% to
                                  hit the lower circuit limit of ₹89.3
                                  apiece.</span
                                >
                                <p
                                  class="text-xs font-normal leading-5 tracking-[-0.12px] text-dark-2"
                                >
                                  3 min read
                                </p>
                              </div></a
                            ><a
                              class="flex min-w-full max-w-full cursor-pointer flex-row items-start gap-x-4 sm:min-w-[300px] sm:max-w-[300px] sm:flex-col"
                              href="/news/market-news/ipo/hp-telecom-india-shares-list-at-6-5-premium-at-115-05-on-nse-sme-check-details/article-149100/"
                              ><div
                                class="h-[60px] w-[110px] flex-shrink-0 overflow-hidden rounded-lg sm:h-[170px] sm:w-full"
                              >
                                <img
                                  alt="news logo"
                                  loading="lazy"
                                  width="300"
                                  height="170"
                                  decoding="async"
                                  data-nimg="1"
                                  class="h-full w-full object-cover"
                                  style="color: transparent"
                                  src="https://assets.upstox.com/content/assets/images/news/telecom-1.webp"
                                />
                              </div>
                              <div class="flex flex-col items-start">
                                <span
                                  class="truncate-lines-2 min-h-[40px] text-base font-semibold leading-5 text-gray-dark3 sm:mb-3 sm:mt-4"
                                  >At the listing price of ₹ 115.05 per share,
                                  the value of a single lot of equity shares
                                  bagged by IPO investors was ₹1,38,060 (₹115.05
                                  x 1,200). IPO investors could have made gains
                                  of ₹8,460 per lot as the minimum investment in
                                  a single lot was ₹1,29,600 (₹108 x 1,200).
                                </span>
                                <p
                                  class="text-xs font-normal leading-5 tracking-[-0.12px] text-dark-2"
                                >
                                  3 min read
                                </p>
                              </div></a
                            ><a
                              class="flex min-w-full max-w-full cursor-pointer flex-row items-start gap-x-4 sm:min-w-[300px] sm:max-w-[300px] sm:flex-col"
                              href="/news/market-news/ipo/balaji-phosphates-ipo-10-key-points-to-consider-before-50-crore-offer-opening/article-148844/"
                              ><div
                                class="h-[60px] w-[110px] flex-shrink-0 overflow-hidden rounded-lg sm:h-[170px] sm:w-full"
                              >
                                <img
                                  alt="news logo"
                                  loading="lazy"
                                  width="300"
                                  height="170"
                                  decoding="async"
                                  data-nimg="1"
                                  class="h-full w-full object-cover"
                                  style="color: transparent"
                                  src="https://assets.upstox.com/content/assets/images/news/balaji-phosphates-ipo-gmp-price-today.webp"
                                />
                              </div>
                              <div class="flex flex-col items-start">
                                <span
                                  class="truncate-lines-2 min-h-[40px] text-base font-semibold leading-5 text-gray-dark3 sm:mb-3 sm:mt-4"
                                  >Balaji Phosphates IPO: The ₹50.11 crore
                                  initial share sale is a mix of fresh issuance
                                  of 59.40 lakh shares valued at ₹41.58 crore
                                  and an offer-for-sale (OFS) of 8.43
                                  crore.</span
                                >
                                <p
                                  class="text-xs font-normal leading-5 tracking-[-0.12px] text-dark-2"
                                >
                                  2 min read
                                </p>
                              </div></a
                            ><a
                              class="flex min-w-full max-w-full cursor-pointer flex-row items-start gap-x-4 sm:min-w-[300px] sm:max-w-[300px] sm:flex-col"
                              href="/news/market-news/ipo/nukleus-office-solutions-ipo-booked-1-3-times-on-day-3-here-s-how-to-check-allotment-status-online/article-148916/"
                              ><div
                                class="h-[60px] w-[110px] flex-shrink-0 overflow-hidden rounded-lg sm:h-[170px] sm:w-full"
                              >
                                <img
                                  alt="news logo"
                                  loading="lazy"
                                  width="300"
                                  height="170"
                                  decoding="async"
                                  data-nimg="1"
                                  class="h-full w-full object-cover"
                                  style="color: transparent"
                                  src="https://assets.upstox.com/content/assets/images/news/nukleus.webp"
                                />
                              </div>
                              <div class="flex flex-col items-start">
                                <span
                                  class="truncate-lines-2 min-h-[40px] text-base font-semibold leading-5 text-gray-dark3 sm:mb-3 sm:mt-4"
                                  >Nukleus Office Solutions IPO was booked 1.3
                                  times on the final day, supported by higher
                                  subscriptions under the retail investors
                                  category. Nukleus Office Solutions IPO
                                  allotment is expected to be finalised on
                                  Friday, February 28. Investors can check the
                                  allotment status on the issue registrar
                                  Bigshare Services or the BSE website.</span
                                >
                                <p
                                  class="text-xs font-normal leading-5 tracking-[-0.12px] text-dark-2"
                                >
                                  4 min read
                                </p>
                              </div></a
                            ><a
                              class="flex min-w-full max-w-full cursor-pointer flex-row items-start gap-x-4 sm:min-w-[300px] sm:max-w-[300px] sm:flex-col"
                              href="/news/market-news/ipo/nukleus-office-solutions-sails-through-on-last-day-investors-await-beezaasan-explotech-ipo-allotment-check-primary-market-highlights/article-148956/"
                              ><div
                                class="h-[60px] w-[110px] flex-shrink-0 overflow-hidden rounded-lg sm:h-[170px] sm:w-full"
                              >
                                <img
                                  alt="news logo"
                                  loading="lazy"
                                  width="300"
                                  height="170"
                                  decoding="async"
                                  data-nimg="1"
                                  class="h-full w-full object-cover"
                                  style="color: transparent"
                                  src="https://assets.upstox.com/content/assets/images/news/ipo112.webp"
                                />
                              </div>
                              <div class="flex flex-col items-start">
                                <span
                                  class="truncate-lines-2 min-h-[40px] text-base font-semibold leading-5 text-gray-dark3 sm:mb-3 sm:mt-4"
                                  >The BSE SME issue of Nukleus Office Solutions
                                  was fully subscribed on the last day of
                                  bidding. On the other hand, the IPO investors
                                  waited for finalisation of Beezaasan Explotech
                                  IPO share allotment status. Here’s a look at
                                  the major developments happening in the IPO
                                  market on Thursday, February 27.</span
                                >
                                <p
                                  class="text-xs font-normal leading-5 tracking-[-0.12px] text-dark-2"
                                >
                                  3 min read
                                </p>
                              </div></a
                            ><a
                              class="flex min-w-full max-w-full cursor-pointer flex-row items-start gap-x-4 sm:min-w-[300px] sm:max-w-[300px] sm:flex-col"
                              href="/news/market-news/ipo/upcoming-mainboard-ipos-tata-capital-to-ather-energy-lg-zepto-phonepe-jsw-cement-hdb-financial-big-ticket-ipo-in-2025/article-148894/"
                              ><div
                                class="h-[60px] w-[110px] flex-shrink-0 overflow-hidden rounded-lg sm:h-[170px] sm:w-full"
                              >
                                <img
                                  alt="news logo"
                                  loading="lazy"
                                  width="300"
                                  height="170"
                                  decoding="async"
                                  data-nimg="1"
                                  class="h-full w-full object-cover"
                                  style="color: transparent"
                                  src="https://assets.upstox.com/content/assets/images/news/ipo.webp"
                                />
                              </div>
                              <div class="flex flex-col items-start">
                                <span
                                  class="truncate-lines-2 min-h-[40px] text-base font-semibold leading-5 text-gray-dark3 sm:mb-3 sm:mt-4"
                                  >Investors are waiting for the IPOs of several
                                  big companies, such as LG Electronics India,
                                  Tata Capital, Ather Energy, and JSW Cement.
                                  IPO activity has remained tepid in 2025, with
                                  nearly 10 mainboard public offers hitting the
                                  D-street.
                                </span>
                                <p
                                  class="text-xs font-normal leading-5 tracking-[-0.12px] text-dark-2"
                                >
                                  4 min read
                                </p>
                              </div></a
                            ><a
                              class="flex min-w-full max-w-full cursor-pointer flex-row items-start gap-x-4 sm:min-w-[300px] sm:max-w-[300px] sm:flex-col"
                              href="/news/market-news/ipo/shreenath-paper-ipo-subscribed-55-so-far-on-day-2-check-allotment-and-listing-date/article-148898/"
                              ><div
                                class="h-[60px] w-[110px] flex-shrink-0 overflow-hidden rounded-lg sm:h-[170px] sm:w-full"
                              >
                                <img
                                  alt="news logo"
                                  loading="lazy"
                                  width="300"
                                  height="170"
                                  decoding="async"
                                  data-nimg="1"
                                  class="h-full w-full object-cover"
                                  style="color: transparent"
                                  src="https://assets.upstox.com/content/assets/images/news/shreenath-paper-ipo-gmp-today.webp"
                                />
                              </div>
                              <div class="flex flex-col items-start">
                                <span
                                  class="truncate-lines-2 min-h-[40px] text-base font-semibold leading-5 text-gray-dark3 sm:mb-3 sm:mt-4"
                                  >Shreenath Paper IPO, which will conclude on
                                  February 28, is a fresh issuance of 53.10 lakh
                                  equity shares worth ₹23.36 crore. The issue
                                  price is ₹44 per share.</span
                                >
                                <p
                                  class="text-xs font-normal leading-5 tracking-[-0.12px] text-dark-2"
                                >
                                  2 min read
                                </p>
                              </div></a
                            ><a
                              class="flex min-w-full max-w-full cursor-pointer flex-row items-start gap-x-4 sm:min-w-[300px] sm:max-w-[300px] sm:flex-col"
                              href="/news/market-news/ipo/naps-global-india-ipo-opens-march-4-check-price-band-objectives-lot-size-key-dates-and-more/article-148821/"
                              ><div
                                class="h-[60px] w-[110px] flex-shrink-0 overflow-hidden rounded-lg sm:h-[170px] sm:w-full"
                              >
                                <img
                                  alt="news logo"
                                  loading="lazy"
                                  width="300"
                                  height="170"
                                  decoding="async"
                                  data-nimg="1"
                                  class="h-full w-full object-cover"
                                  style="color: transparent"
                                  src="https://assets.upstox.com/content/assets/images/news/shutterstock2436111829.webp"
                                />
                              </div>
                              <div class="flex flex-col items-start">
                                <span
                                  class="truncate-lines-2 min-h-[40px] text-base font-semibold leading-5 text-gray-dark3 sm:mb-3 sm:mt-4"
                                  >NAPS Global India IPO: The ₹11.88 crore
                                  initial public offer is a fresh issuance of
                                  13.20 lakh shares. There is no offer-for-sale
                                  component.</span
                                >
                                <p
                                  class="text-xs font-normal leading-5 tracking-[-0.12px] text-dark-2"
                                >
                                  2 min read
                                </p>
                              </div></a
                            ><a
                              class="flex min-w-full max-w-full cursor-pointer flex-row items-start gap-x-4 sm:min-w-[300px] sm:max-w-[300px] sm:flex-col"
                              href="/news/market-news/ipo/tata-capital-ipo-tata-investment-corporation-surges-10-10-things-you-need-to-know/article-148266/"
                              ><div
                                class="h-[60px] w-[110px] flex-shrink-0 overflow-hidden rounded-lg sm:h-[170px] sm:w-full"
                              >
                                <img
                                  alt="news logo"
                                  loading="lazy"
                                  width="300"
                                  height="170"
                                  decoding="async"
                                  data-nimg="1"
                                  class="h-full w-full object-cover"
                                  style="color: transparent"
                                  src="https://assets.upstox.com/content/assets/images/news/tata-group.webp"
                                />
                              </div>
                              <div class="flex flex-col items-start">
                                <span
                                  class="truncate-lines-2 min-h-[40px] text-base font-semibold leading-5 text-gray-dark3 sm:mb-3 sm:mt-4"
                                  >Tata Capital IPO: Tata Capital said that the
                                  board of directors of the company has approved
                                  the IPO of the equity shares of face value of
                                  ₹10 each, comprising a fresh issue of 23 crore
                                  shares and an OFS.</span
                                >
                                <p
                                  class="text-xs font-normal leading-5 tracking-[-0.12px] text-dark-2"
                                >
                                  4 min read
                                </p>
                              </div></a
                            ><a
                              class="flex min-w-full max-w-full cursor-pointer flex-row items-start gap-x-4 sm:min-w-[300px] sm:max-w-[300px] sm:flex-col"
                              href="/news/market-news/ipo/phonepe-appoints-4-investment-banks-for-much-awaited-ipo-seeks-15-billion-valuation-report/article-148468/"
                              ><div
                                class="h-[60px] w-[110px] flex-shrink-0 overflow-hidden rounded-lg sm:h-[170px] sm:w-full"
                              >
                                <img
                                  alt="news logo"
                                  loading="lazy"
                                  width="300"
                                  height="170"
                                  decoding="async"
                                  data-nimg="1"
                                  class="h-full w-full object-cover"
                                  style="color: transparent"
                                  src="https://assets.upstox.com/content/assets/images/news/shutterstock1748701286.webp"
                                />
                              </div>
                              <div class="flex flex-col items-start">
                                <span
                                  class="truncate-lines-2 min-h-[40px] text-base font-semibold leading-5 text-gray-dark3 sm:mb-3 sm:mt-4"
                                  >PhonePe IPO: PhonePe officially announced the
                                  company's listing plans on the Indian stock
                                  exchanges last week. The fintech said it has
                                  long aspired to be a public firm in India.
                                </span>
                                <p
                                  class="text-xs font-normal leading-5 tracking-[-0.12px] text-dark-2"
                                >
                                  2 min read
                                </p>
                              </div></a
                            ><a
                              class="flex min-w-full max-w-full cursor-pointer flex-row items-start gap-x-4 sm:min-w-[300px] sm:max-w-[300px] sm:flex-col"
                              href="/news/market-news/ipo/balaji-phosphates-ipo-opens-on-february-28-to-raise-50-11-crore-check-issue-size-price-band-and-more/article-148481/"
                              ><div
                                class="h-[60px] w-[110px] flex-shrink-0 overflow-hidden rounded-lg sm:h-[170px] sm:w-full"
                              >
                                <img
                                  alt="news logo"
                                  loading="lazy"
                                  width="300"
                                  height="170"
                                  decoding="async"
                                  data-nimg="1"
                                  class="h-full w-full object-cover"
                                  style="color: transparent"
                                  src="https://assets.upstox.com/content/assets/images/news/balaji-phosphates.webp"
                                />
                              </div>
                              <div class="flex flex-col items-start">
                                <span
                                  class="truncate-lines-2 min-h-[40px] text-base font-semibold leading-5 text-gray-dark3 sm:mb-3 sm:mt-4"
                                  >Balaji Phosphates IPO will open for
                                  subscription on February 28, 2025. The company
                                  aims to raise ₹50.11 crore with a price band
                                  of ₹66-70 per share. The IPO includes a fresh
                                  issue and offer-for-sale. Shares will be
                                  listed on the NSE SME platform.</span
                                >
                                <p
                                  class="text-xs font-normal leading-5 tracking-[-0.12px] text-dark-2"
                                >
                                  3 min read
                                </p>
                              </div></a
                            ><a
                              class="flex min-w-full max-w-full cursor-pointer flex-row items-start gap-x-4 sm:min-w-[300px] sm:max-w-[300px] sm:flex-col"
                              href="/news/market-news/ipo/beezaasan-explotech-ipo-booked-5x-on-day-3-sme-issue-of-shreenath-paper-products-opens-to-weak-demand-check-primary-market-highlights/article-148402/"
                              ><div
                                class="h-[60px] w-[110px] flex-shrink-0 overflow-hidden rounded-lg sm:h-[170px] sm:w-full"
                              >
                                <img
                                  alt="news logo"
                                  loading="lazy"
                                  width="300"
                                  height="170"
                                  decoding="async"
                                  data-nimg="1"
                                  class="h-full w-full object-cover"
                                  style="color: transparent"
                                  src="https://assets.upstox.com/content/assets/images/news/ipo.webp"
                                />
                              </div>
                              <div class="flex flex-col items-start">
                                <span
                                  class="truncate-lines-2 min-h-[40px] text-base font-semibold leading-5 text-gray-dark3 sm:mb-3 sm:mt-4"
                                  >The BSE SME issue of Shreenath Paper Products
                                  Ltd opened to weak demand on Tuesday. On the
                                  other hand, Beezaasan Explotech IPO closed
                                  with an overall subscription of more than 5
                                  times. Here’s a look at the major developments
                                  in the IPO market on Tuesday, February
                                  25.</span
                                >
                                <p
                                  class="text-xs font-normal leading-5 tracking-[-0.12px] text-dark-2"
                                >
                                  4 min read
                                </p>
                              </div></a
                            ><a
                              class="flex min-w-full max-w-full cursor-pointer flex-row items-start gap-x-4 sm:min-w-[300px] sm:max-w-[300px] sm:flex-col"
                              href="/news/market-news/ipo/shreenath-paper-ipo-booked-15-on-day-1-check-issue-size-price-band-and-more/article-148302/"
                              ><div
                                class="h-[60px] w-[110px] flex-shrink-0 overflow-hidden rounded-lg sm:h-[170px] sm:w-full"
                              >
                                <img
                                  alt="news logo"
                                  loading="lazy"
                                  width="300"
                                  height="170"
                                  decoding="async"
                                  data-nimg="1"
                                  class="h-full w-full object-cover"
                                  style="color: transparent"
                                  src="https://assets.upstox.com/content/assets/images/news/shreenath-paper-products.webp"
                                />
                              </div>
                              <div class="flex flex-col items-start">
                                <span
                                  class="truncate-lines-2 min-h-[40px] text-base font-semibold leading-5 text-gray-dark3 sm:mb-3 sm:mt-4"
                                  >Shreenath Paper Products' IPO subscription is
                                  open from February 25 to February 28. The
                                  company will likely announce the share
                                  allotment status on Monday, March 3. It plans
                                  to raise ₹23.36 crore from this IPO.
                                </span>
                                <p
                                  class="text-xs font-normal leading-5 tracking-[-0.12px] text-dark-2"
                                >
                                  3 min read
                                </p>
                              </div></a
                            ><a
                              class="flex min-w-full max-w-full cursor-pointer flex-row items-start gap-x-4 sm:min-w-[300px] sm:max-w-[300px] sm:flex-col"
                              href="/news/market-news/ipo/beezaasan-explotech-ipo-booked-over-5-4-times-on-day-3-shares-allotment-expected-on-feb-27-steps-to-check-status-online/article-148385/"
                              ><div
                                class="h-[60px] w-[110px] flex-shrink-0 overflow-hidden rounded-lg sm:h-[170px] sm:w-full"
                              >
                                <img
                                  alt="news logo"
                                  loading="lazy"
                                  width="300"
                                  height="170"
                                  decoding="async"
                                  data-nimg="1"
                                  class="h-full w-full object-cover"
                                  style="color: transparent"
                                  src="https://assets.upstox.com/content/assets/images/news/beezaasan-explotech.webp"
                                />
                              </div>
                              <div class="flex flex-col items-start">
                                <span
                                  class="truncate-lines-2 min-h-[40px] text-base font-semibold leading-5 text-gray-dark3 sm:mb-3 sm:mt-4"
                                  >Beezaasan Explotech IPO was a 100% book-built
                                  issue comprising a fresh issuance of 34.24
                                  lakh equity shares, aggregating to ₹59.93
                                  crore. The price band for the IPO was fixed at
                                  ₹165 to ₹175 per share. Beezaasan Explotech
                                  shares are scheduled to be listed on the BSE
                                  SME platform on March 3.</span
                                >
                                <p
                                  class="text-xs font-normal leading-5 tracking-[-0.12px] text-dark-2"
                                >
                                  5 min read
                                </p>
                              </div></a
                            ><a
                              class="flex min-w-full max-w-full cursor-pointer flex-row items-start gap-x-4 sm:min-w-[300px] sm:max-w-[300px] sm:flex-col"
                              href="/news/market-news/ipo/nukleus-office-ipo-issue-subscribed-42-so-far-on-day-2-check-objectives-allotment-and-listing-date/article-148270/"
                              ><div
                                class="h-[60px] w-[110px] flex-shrink-0 overflow-hidden rounded-lg sm:h-[170px] sm:w-full"
                              >
                                <img
                                  alt="news logo"
                                  loading="lazy"
                                  width="300"
                                  height="170"
                                  decoding="async"
                                  data-nimg="1"
                                  class="h-full w-full object-cover"
                                  style="color: transparent"
                                  src="https://assets.upstox.com/content/assets/images/news/nukleus.webp"
                                />
                              </div>
                              <div class="flex flex-col items-start">
                                <span
                                  class="truncate-lines-2 min-h-[40px] text-base font-semibold leading-5 text-gray-dark3 sm:mb-3 sm:mt-4"
                                  >Nukleus Office IPO: An investor can apply for
                                  at least one lot consisting of 600 shares
                                  worth ₹1,40,400, and high-net-worth
                                  individuals can apply for two lots valued at
                                  ₹2,80,800.
                                </span>
                                <p
                                  class="text-xs font-normal leading-5 tracking-[-0.12px] text-dark-2"
                                >
                                  2 min read
                                </p>
                              </div></a
                            ><a
                              class="flex min-w-full max-w-full cursor-pointer flex-row items-start gap-x-4 sm:min-w-[300px] sm:max-w-[300px] sm:flex-col"
                              href="/news/market-news/ipo/tata-capital-gets-board-nod-for-ipo-with-fresh-issue-and-ofs/article-148178/"
                              ><div
                                class="h-[60px] w-[110px] flex-shrink-0 overflow-hidden rounded-lg sm:h-[170px] sm:w-full"
                              >
                                <img
                                  alt="news logo"
                                  loading="lazy"
                                  width="300"
                                  height="170"
                                  decoding="async"
                                  data-nimg="1"
                                  class="h-full w-full object-cover"
                                  style="color: transparent"
                                  src="https://assets.upstox.com/content/assets/images/news/tata-capital-ipo.webp"
                                />
                              </div>
                              <div class="flex flex-col items-start">
                                <span
                                  class="truncate-lines-2 min-h-[40px] text-base font-semibold leading-5 text-gray-dark3 sm:mb-3 sm:mt-4"
                                  >Tata Capital IPO: According to the Reserve
                                  Bank of India's (RBI) guidelines, the Tata
                                  Group's financial services arm must list its
                                  shares by September 2025 as part of the "upper
                                  layer" non-banking financial companies (NBFCs)
                                  regulations.</span
                                >
                                <p
                                  class="text-xs font-normal leading-5 tracking-[-0.12px] text-dark-2"
                                >
                                  2 min read
                                </p>
                              </div></a
                            ><a
                              class="flex min-w-full max-w-full cursor-pointer flex-row items-start gap-x-4 sm:min-w-[300px] sm:max-w-[300px] sm:flex-col"
                              href="/news/market-news/ipo/shreenath-paper-ipo-opens-on-feb-25-check-price-band-lot-size-key-dates-and-more/article-148129/"
                              ><div
                                class="h-[60px] w-[110px] flex-shrink-0 overflow-hidden rounded-lg sm:h-[170px] sm:w-full"
                              >
                                <img
                                  alt="news logo"
                                  loading="lazy"
                                  width="300"
                                  height="170"
                                  decoding="async"
                                  data-nimg="1"
                                  class="h-full w-full object-cover"
                                  style="color: transparent"
                                  src="https://assets.upstox.com/content/assets/images/news/shreenath-paper-ipo-gmp.webp"
                                />
                              </div>
                              <div class="flex flex-col items-start">
                                <span
                                  class="truncate-lines-2 min-h-[40px] text-base font-semibold leading-5 text-gray-dark3 sm:mb-3 sm:mt-4"
                                  >Shreenath Paper IPO: The initial share sale,
                                  which will conclude on February 28, is
                                  completely a fresh issuance of 53.10 lakh
                                  shares worth ₹23.36 crore.</span
                                >
                                <p
                                  class="text-xs font-normal leading-5 tracking-[-0.12px] text-dark-2"
                                >
                                  2 min read
                                </p>
                              </div></a
                            ><a
                              class="flex min-w-full max-w-full cursor-pointer flex-row items-start gap-x-4 sm:min-w-[300px] sm:max-w-[300px] sm:flex-col"
                              href="/news/market-news/ipo/hp-telecom-india-ipo-booked-nearly-2-times-on-final-day-here-s-how-to-check-allotment-status-online/article-148049/"
                              ><div
                                class="h-[60px] w-[110px] flex-shrink-0 overflow-hidden rounded-lg sm:h-[170px] sm:w-full"
                              >
                                <img
                                  alt="news logo"
                                  loading="lazy"
                                  width="300"
                                  height="170"
                                  decoding="async"
                                  data-nimg="1"
                                  class="h-full w-full object-cover"
                                  style="color: transparent"
                                  src="https://assets.upstox.com/content/assets/images/news/telecom-1.webp"
                                />
                              </div>
                              <div class="flex flex-col items-start">
                                <span
                                  class="truncate-lines-2 min-h-[40px] text-base font-semibold leading-5 text-gray-dark3 sm:mb-3 sm:mt-4"
                                  >Shares of HP Telecom India are scheduled to
                                  be listed on the NSE Emerge platform on
                                  February 28. The IPO was a fixed-price issue,
                                  and shares were offered at ₹108 apiece in a
                                  lot size of 1,200 units. The ₹34.23-crore HP
                                  Telecom India IPO was open for bidding from
                                  February 20 to February 24.
                                </span>
                                <p
                                  class="text-xs font-normal leading-5 tracking-[-0.12px] text-dark-2"
                                >
                                  4 min read
                                </p>
                              </div></a
                            ><a
                              class="flex min-w-full max-w-full cursor-pointer flex-row items-start gap-x-4 sm:min-w-[300px] sm:max-w-[300px] sm:flex-col"
                              href="/news/market-news/ipo/ipo-wrap-nukleus-office-solutions-ipo-opens-to-weak-demand-quality-power-makes-muted-debut-and-more/article-148091/"
                              ><div
                                class="h-[60px] w-[110px] flex-shrink-0 overflow-hidden rounded-lg sm:h-[170px] sm:w-full"
                              >
                                <img
                                  alt="news logo"
                                  loading="lazy"
                                  width="300"
                                  height="170"
                                  decoding="async"
                                  data-nimg="1"
                                  class="h-full w-full object-cover"
                                  style="color: transparent"
                                  src="https://assets.upstox.com/content/assets/images/news/ipo112.webp"
                                />
                              </div>
                              <div class="flex flex-col items-start">
                                <span
                                  class="truncate-lines-2 min-h-[40px] text-base font-semibold leading-5 text-gray-dark3 sm:mb-3 sm:mt-4"
                                  >Shares of Quality Power Electrical Equipments
                                  Ltd made a muted trading debut on the NSE and
                                  BSE on Monday. The BSE SME issue of Nukleus
                                  Office Solutions Ltd opened to weak demand.
                                  Here’s a look at all the major developments in
                                  the IPO market on Monday, February 24.</span
                                >
                                <p
                                  class="text-xs font-normal leading-5 tracking-[-0.12px] text-dark-2"
                                >
                                  4 min read
                                </p>
                              </div></a
                            ><a
                              class="flex min-w-full max-w-full cursor-pointer flex-row items-start gap-x-4 sm:min-w-[300px] sm:max-w-[300px] sm:flex-col"
                              href="/news/market-news/ipo/nukleus-office-solutions-ipo-booked-41-on-day-1-check-issue-size-price-band-and-more/article-148011/"
                              ><div
                                class="h-[60px] w-[110px] flex-shrink-0 overflow-hidden rounded-lg sm:h-[170px] sm:w-full"
                              >
                                <img
                                  alt="news logo"
                                  loading="lazy"
                                  width="300"
                                  height="170"
                                  decoding="async"
                                  data-nimg="1"
                                  class="h-full w-full object-cover"
                                  style="color: transparent"
                                  src="https://assets.upstox.com/content/assets/images/news/nukleus-office-solutions-ltd.webp"
                                />
                              </div>
                              <div class="flex flex-col items-start">
                                <span
                                  class="truncate-lines-2 min-h-[40px] text-base font-semibold leading-5 text-gray-dark3 sm:mb-3 sm:mt-4"
                                  >Nukleus Office Solutions IPO comprises only a
                                  fresh issue of 13.55 lakh shares. The company
                                  has proposed to list shares on the BSE SME
                                  platform on Wednesday, March 4. The NSE SME
                                  issue is available for subscription till
                                  Thursday, February 27.</span
                                >
                                <p
                                  class="text-xs font-normal leading-5 tracking-[-0.12px] text-dark-2"
                                >
                                  4 min read
                                </p>
                              </div></a
                            ><a
                              class="flex min-w-full max-w-full cursor-pointer flex-row items-start gap-x-4 sm:min-w-[300px] sm:max-w-[300px] sm:flex-col"
                              href="/news/market-news/ipo/swasth-foodtech-ipo-booked-7-8-times-on-day-3-share-allotment-tomorrow-here-s-how-to-check-status-online/article-148023/"
                              ><div
                                class="h-[60px] w-[110px] flex-shrink-0 overflow-hidden rounded-lg sm:h-[170px] sm:w-full"
                              >
                                <img
                                  alt="news logo"
                                  loading="lazy"
                                  width="300"
                                  height="170"
                                  decoding="async"
                                  data-nimg="1"
                                  class="h-full w-full object-cover"
                                  style="color: transparent"
                                  src="https://assets.upstox.com/content/assets/images/news/swasth-foodtech-india-ltd.webp"
                                />
                              </div>
                              <div class="flex flex-col items-start">
                                <span
                                  class="truncate-lines-2 min-h-[40px] text-base font-semibold leading-5 text-gray-dark3 sm:mb-3 sm:mt-4"
                                  >Investors can check the IPO share allotment
                                  status on the official websites of the BSE and
                                  the IPO registrar, Mas Services Ltd. Swasth
                                  Foodtech India's tentative listing date has
                                  been fixed at February 28. The company's
                                  shares will be listed on the BSE SME
                                  platform.</span
                                >
                                <p
                                  class="text-xs font-normal leading-5 tracking-[-0.12px] text-dark-2"
                                >
                                  4 min read
                                </p>
                              </div></a
                            ><a
                              class="flex min-w-full max-w-full cursor-pointer flex-row items-start gap-x-4 sm:min-w-[300px] sm:max-w-[300px] sm:flex-col"
                              href="/news/market-news/ipo/boat-ipo-date-aman-gupta-led-company-preparing-to-file-confidential-drhp-for-2-000-crore-offer-potential-launch-in-fy-26/article-147942/"
                              ><div
                                class="h-[60px] w-[110px] flex-shrink-0 overflow-hidden rounded-lg sm:h-[170px] sm:w-full"
                              >
                                <img
                                  alt="news logo"
                                  loading="lazy"
                                  width="300"
                                  height="170"
                                  decoding="async"
                                  data-nimg="1"
                                  class="h-full w-full object-cover"
                                  style="color: transparent"
                                  src="https://assets.upstox.com/content/assets/images/news/boat-ipo-date.webp"
                                />
                              </div>
                              <div class="flex flex-col items-start">
                                <span
                                  class="truncate-lines-2 min-h-[40px] text-base font-semibold leading-5 text-gray-dark3 sm:mb-3 sm:mt-4"
                                  >boAt is a producer of consumer electronics,
                                  focusing on audio products such as earbuds,
                                  headphones, and speakers. It was founded by
                                  Aman Gupta and Sameer Mehta.</span
                                >
                                <p
                                  class="text-xs font-normal leading-5 tracking-[-0.12px] text-dark-2"
                                >
                                  2 min read
                                </p>
                              </div></a
                            >
                          </div>
                        </div>
                        <div class="hidden xl:block">
                          <button
                            style="position: absolute; right: 0"
                            class="absolute z-[7] mr-[-16px] flex h-8 w-8 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full border border-solid border-[rgba(0,0,0,0.20)] bg-white p-1 top-1/3"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="none"
                              viewBox="0 0 12 12"
                              class="shrink-0 rotate-180"
                            >
                              <g clip-path="url(#back-arrow_svg__a)">
                                <path
                                  fill="#6A6A6A"
                                  d="M10 5.5H3.915L6.71 2.705 6 2 2 6l4 4 .705-.705L3.915 6.5H10z"
                                ></path>
                              </g>
                              <defs>
                                <clipPath id="back-arrow_svg__a">
                                  <path fill="#fff" d="M0 0h12v12H0z"></path>
                                </clipPath>
                              </defs>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                    <hr class="my-8 h-[1px] w-full bg-light-4 xl:hidden" />
                    <div
                      class="flex flex-col gap-6 bg-light-10 py-10 max-xl:-mx-4 max-xl:w-screen max-xl:px-0 xl:mx-auto xl:rounded-[20px] xl:px-6"
                    >
                      <span
                        class="inter-display-font pl-4 text-2xl font-semibold leading-[26.4px] text-dark-10"
                        >What our users have to say</span
                      >
                      <div
                        class="no-scrollbar flex items-center gap-5 overflow-x-scroll"
                      >
                        <div
                          class="flex h-[280px] min-w-[260px] flex-col justify-between rounded-3xl bg-white p-6 first:ml-4 last:mr-4"
                        >
                          <span class="text-base font-normal text-dark-10"
                            >IPO section is awesome now.</span
                          >
                          <div class="flex flex-col gap-3">
                            <span
                              class="inter-display-font text-base font-semibold text-dark-10"
                              >⁠Kazi Bakibillah Twasin</span
                            >
                          </div>
                        </div>
                        <div
                          class="flex h-[280px] min-w-[260px] flex-col justify-between rounded-3xl bg-white p-6 first:ml-4 last:mr-4"
                        >
                          <span class="text-base font-normal text-dark-10"
                            >I have been using Upstox for the past three years,
                            and it is the best app for investing. I have secured
                            around 10 to 15 IPOs since last year, starting from
                            Tata Technologies to Vishal Mega Mart.</span
                          >
                          <div class="flex flex-col gap-3">
                            <span
                              class="inter-display-font text-base font-semibold text-dark-10"
                              >Shubham Kumbhar</span
                            >
                          </div>
                        </div>
                        <div
                          class="flex h-[280px] min-w-[260px] flex-col justify-between rounded-3xl bg-white p-6 first:ml-4 last:mr-4"
                        >
                          <span class="text-base font-normal text-dark-10"
                            >Excellent experience in trading with good chart and
                            a good access to ipo and its status.</span
                          >
                          <div class="flex flex-col gap-3">
                            <span
                              class="inter-display-font text-base font-semibold text-dark-10"
                              >Ulhas S</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="flex flex-col space-y-5 md:mt-0 pt-10 sm:pt-0">
                      <div>
                        <h2
                          class="inter-display-font text-xl font-semibold text-dark-10"
                        >
                          Why invest in SME IPOs?
                        </h2>
                        <div>
                          <div
                            class="react-markdown-container-website overflow-hidden pb-1 transition-all !truncate-lines text-sm font-normal leading-[21px] tracking-[-0.16px] text-dark-7 mt-2"
                          >
                            <!--$-->
                            <p>
                              Investing in Small and Medium Enterprise (SME)
                              IPOs provides an opportunity to capitalise on
                              growing businesses while benefiting from their
                              potential for expansion and profitability. These
                              initial public offerings allow SMEs to raise
                              capital by listing shares on stock exchanges. SME
                              IPOs provide long-term capital for the company,
                              which can be utilised for expansion, marketing,
                              meeting working capital needs, or other strategic
                              investments. Unlike loans, this capital does not
                              require repayment, offering more financial
                              flexibility. Additionally, public listing enhances
                              the SME’s visibility and reputation, attracting
                              institutional investors and improving corporate
                              governance. The SME IPOs hold immense potential
                              for early investors as many recently listed SME
                              issues have given multifold returns after market
                              debut.
                            </p>
                            <!--/$-->
                          </div>
                        </div>
                      </div>
                      <div>
                        <h2
                          class="inter-display-font text-xl font-semibold text-dark-10"
                        >
                          How to apply for SME IPOs with Upstox?
                        </h2>
                        <div>
                          <div
                            class="react-markdown-container-website overflow-hidden pb-1 transition-all !truncate-lines text-sm font-normal leading-[21px] tracking-[-0.16px] text-dark-7 mt-2"
                          >
                            <p>
                              <strong>Web</strong>: You can apply for an IPO on
                              the Upstox website. Go to
                              <a href="/ipo/sme"
                                >https://upstox.com/ipo/sme</a
                              >
                              and log in with your credentials. From the list of
                              open IPOs, select the IPO you want to apply for
                              and click Apply. Enter details like the cutoff
                              price, lot size, and UPI ID for the mandate.
                              Approve the UPI mandate on your UPI application.
                              You can track your application status from the
                              <strong>My Application</strong> tab.
                            </p>
                            <p><strong>App</strong>: To get started</p>
                            <ul>
                              <li>
                                Open the Upstox app and log in using your
                                6-digit PIN or Biometrics.
                              </li>
                              <li>
                                From the bottom menu, tap on the
                                <strong>More</strong> tab and select the
                                <strong>IPO</strong> option.
                              </li>
                              <li>
                                In the <strong>Explore</strong> section, check
                                the <strong>Show SME IPOs</strong> box to see
                                all the available SME IPOs.
                              </li>
                              <li>
                                Browse through the listed SME IPOs and click on
                                <strong>Pre-apply now</strong> or
                                <strong>Apply Now</strong> for your desired IPO.
                              </li>
                              <li>
                                Enter the required details like quantity and
                                price, then click on
                                <strong>Continue to apply</strong>.
                              </li>
                              <li>
                                Provide your UPI ID linked to your bank account
                                and click <strong>Continue to apply</strong>.
                              </li>
                              <li>
                                Monitor your application status by selecting
                                <strong>Timeline</strong> or
                                <strong>Summary</strong>. A message will appear
                                regarding the pending UPI mandate.
                              </li>
                              <li>
                                Open your UPI app and approve the payment
                                mandate.
                              </li>
                              <li>
                                Once the mandate is accepted, track your
                                application under the
                                <strong>View Application</strong> tab.
                              </li>
                              <li>
                                To see a detailed IPO timeline, check the
                                <strong>Timeline</strong> section for date-wise
                                updates.
                              </li>
                            </ul>
                          </div>
                          <span
                            ><button
                              class="mt-4 text-sm font-bold leading-[150%] tracking-[-0.14px] text-primary-accent3"
                              aria-expanded="false"
                            >
                              Read More
                            </button></span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="w-full mt-8 xl:mt-0 mb-[-32px]">
                      <h2
                        class="font-semibold -tracking-[0.47px] inter-display-font mb-4 text-[24px] text-gray-dark3 sm:mb-10"
                      >
                        Frequently asked questions
                      </h2>
                      <div class="">
                        <div class="flex flex-col gap-1">
                          <div
                            class="flex flex-col mb-4 border-b border-b-light-4 pb-4 sm:mb-8 sm:pb-8"
                          >
                            <div
                              class="flex w-full cursor-pointer flex-row items-center justify-between gap-2"
                            >
                              <h3
                                class="inter-display-font flex w-full items-start justify-between text-left text-base font-semibold leading-[120%] tracking-[-0.2px] text-gray-dark3 sm:text-xl md:items-center"
                              >
                                How does the size of an SME IPO differ from that
                                of a mainboard IPO?
                              </h3>
                              <span class="ml-2 flex-shrink-0 text-lg font-bold"
                                ><svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  fill="none"
                                  viewBox="0 0 24 25"
                                  class="shrink-0 cursor-pointer"
                                >
                                  <path
                                    fill="#111"
                                    d="M5 11.947v2h14v-2z"
                                  ></path></svg
                              ></span>
                            </div>
                            <div
                              class="overflow-y-hidden text-sm leading-[150%] tracking-[-0.14px] text-dark-7 transition-all"
                              style="height: 92px"
                            >
                              <div>
                                <div
                                  class="flex flex-col justify-between gap-4 pt-2 text-sm leading-[150%] tracking-[-0.14px] desktop-sm:flex-row"
                                >
                                  <div>
                                    An IPO refers to the first time a company
                                    offers its shares to the public to raise
                                    capital from the primary market. The main
                                    difference between SME IPOs and mainboard
                                    IPOs lies in the issue size. Mainboard IPOs
                                    tend to have larger issue sizes, while SME
                                    IPOs involve smaller issue sizes. To qualify
                                    for an SME IPO in India, the Securities and
                                    Exchange Board of India (SEBI) has issued a
                                    set of guidelines. For instance, the SMEs
                                    should have an operating profit of ₹1 crore
                                    for two out of three financial years before
                                    applying for an IPO, the offer-for-sale is
                                    capped at 20% of the issue size, or 50% of
                                    the holding, whichever is lower, and the
                                    maximum post-issue capital is ₹25 crore,
                                    among others.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="flex flex-col mb-4 border-b border-b-light-4 pb-4 sm:mb-8 sm:pb-8"
                          >
                            <div
                              class="flex w-full cursor-pointer flex-row items-center justify-between gap-2"
                            >
                              <h3
                                class="inter-display-font flex w-full items-start justify-between text-left text-base font-semibold leading-[120%] tracking-[-0.2px] text-gray-dark3 sm:text-xl md:items-center"
                              >
                                Which SME IPO is expected to launch next?
                              </h3>
                              <span class="ml-2 flex-shrink-0 text-lg font-bold"
                                ><svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  fill="none"
                                  viewBox="0 0 24 25"
                                  class="shrink-0 cursor-pointer"
                                >
                                  <path
                                    fill="#111"
                                    d="M11 11.947v-6h2v6h6v2h-6v6h-2v-6H5v-2z"
                                  ></path></svg
                              ></span>
                            </div>
                            <div
                              class="overflow-y-hidden text-sm leading-[150%] tracking-[-0.14px] text-dark-7 transition-all"
                              style="height: 0px"
                            >
                              <div>
                                <div
                                  class="flex flex-col justify-between gap-4 pt-2 text-sm leading-[150%] tracking-[-0.14px] desktop-sm:flex-row"
                                >
                                  <div>
                                    Some of the upcoming SME IPOs are: Solar91
                                    Cleantech IPO
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <div class="pt-8 sm:pt-0 xl:hidden">
                  <div>
                    <span
                      class="relative inline-flex items-baseline whitespace-normal text-left align-middle text-dark-1 outline-none text-2xl font-semibold not-italic leading-[110%] tracking-[-0.24px] xl:hidden"
                      >Other IPO Links</span
                    ><span
                      class="inter-display-font hidden text-xs font-medium tracking-[2.4px] text-dark-7 xl:block"
                      >OTHER IPO LINKS</span
                    >
                    <div class="flex flex-col">
                      <a
                        target="_blank"
                        rel="noreferrer"
                        class="flex items-center justify-between border-b border-light-4 py-4"
                        href="/ipo/sme/"
                        ><span class="text-xs font-bold text-primary-accent3"
                          >All SME IPOs</span
                        ><svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          fill="none"
                          viewBox="0 0 20 20"
                          class="shrink-0 h-5 w-5"
                        >
                          <mask
                            id="right-purple_svg__a"
                            width="20"
                            height="20"
                            x="0"
                            y="0"
                            maskUnits="userSpaceOnUse"
                            style="mask-type: alpha"
                          >
                            <path fill="#D9D9D9" d="M0 0h20v20H0z"></path>
                          </mask>
                          <g mask="url(#right-purple_svg__a)">
                            <path
                              fill="#7132B0"
                              d="M11.665 15 10.5 13.792l2.958-2.959H3.332V9.167h10.125l-2.958-2.959L11.665 5l5 5z"
                            ></path>
                          </g></svg></a
                      ><a
                        target="_blank"
                        rel="noreferrer"
                        class="flex items-center justify-between border-b border-light-4 py-4"
                        href="/ipo/mainboard/"
                        ><span class="text-xs font-bold text-primary-accent3"
                          >All Mainboard IPOs</span
                        ><svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          fill="none"
                          viewBox="0 0 20 20"
                          class="shrink-0 h-5 w-5"
                        >
                          <mask
                            id="right-purple_svg__a"
                            width="20"
                            height="20"
                            x="0"
                            y="0"
                            maskUnits="userSpaceOnUse"
                            style="mask-type: alpha"
                          >
                            <path fill="#D9D9D9" d="M0 0h20v20H0z"></path>
                          </mask>
                          <g mask="url(#right-purple_svg__a)">
                            <path
                              fill="#7132B0"
                              d="M11.665 15 10.5 13.792l2.958-2.959H3.332V9.167h10.125l-2.958-2.959L11.665 5l5 5z"
                            ></path>
                          </g></svg
                      ></a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pt-12 sm:pt-15">
                <div
                  class="mt-4 flex items-center md:mt-5 !mt-0 py-3 sm:py-5"
                  aria-label="Breadcrumb"
                >
                  <a
                    class="mr-8 hidden whitespace-nowrap capitalize text-gray-accent3 hover:text-breadcrumb-link-hover sm:flex"
                    href="/ipo/"
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="none"
                      viewBox="0 0 12 12"
                      class="shrink-0"
                    >
                      <g clip-path="url(#back-arrow_svg__a)">
                        <path
                          fill="#6A6A6A"
                          d="M10 5.5H3.915L6.71 2.705 6 2 2 6l4 4 .705-.705L3.915 6.5H10z"
                        ></path>
                      </g>
                      <defs>
                        <clipPath id="back-arrow_svg__a">
                          <path fill="#fff" d="M0 0h12v12H0z"></path>
                        </clipPath>
                      </defs></svg
                  ></a>
                  <ol class="inline-flex items-center">
                    <li>
                      <div class="flex items-center text-sm font-normal">
                        <a
                          class="whitespace-nowrap text-gray-accent3 hover:text-breadcrumb-link-hover"
                          href="https://upstox.com"
                          >Home</a
                        >
                        <div class="px-2">/</div>
                      </div>
                    </li>
                    <li>
                      <div class="flex items-center text-sm font-normal">
                        <a
                          class="whitespace-nowrap text-gray-accent3 hover:text-breadcrumb-link-hover"
                          href="/ipo/"
                          >IPO</a
                        >
                        <div class="px-2">/</div>
                      </div>
                    </li>
                    <li
                      class="w-28 whitespace-nowrap pr-7 text-sm font-normal capitalize text-gray-dark3 sm:w-72"
                    >
                      sme ipos
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="xs:hidden w-[1px] bg-light-4 xl:block"></div>
        <div class="xs:hidden w-[360px] flex-shrink-0 xl:block">
          <div class="sticky flex flex-col gap-8 px-4 py-5 top-[70px]">
            <a
              class="flex items-center justify-between gap-4 rounded-xl bg-light-10 p-3"
              href="/ipo/balaji-phosphates-limited-ipo/"
              ><div class="flex min-w-0 gap-2">
                <div
                  class="relative flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[1px] border-light-3 border-none bg-light-4"
                >
                  <img
                    alt="ipo logo"
                    loading="lazy"
                    width="40"
                    height="40"
                    decoding="async"
                    data-nimg="1"
                    class="rounded-full object-none"
                    style="color: transparent"
                    src="/next-ipo-assets/icons/company-logo.svg"
                  />
                </div>
                <div class="flex w-full flex-col overflow-hidden">
                  <span
                    class="relative items-baseline text-left align-middle outline-none not-italic tracking-[-0.14px] inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-sm font-semibold text-dark-10"
                    >Balaji Phosphates IPO</span
                  >
                  <div class="flex items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="none"
                      viewBox="0 0 16 17"
                      class="shrink-0"
                    >
                      <path fill="#008858" d="m8 4.5 5 8H3z"></path></svg
                    ><span class="text-[11px] font-semibold text-success-9"
                      >Trending</span
                    >
                  </div>
                </div>
              </div>
              <div class="flex shrink-0 items-center gap-1">
                <span class="text-xs font-bold text-primary-accent4"
                  >View IPO</span
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="none"
                  viewBox="0 0 20 20"
                  class="shrink-0"
                >
                  <mask
                    id="right-purple_svg__a"
                    width="20"
                    height="20"
                    x="0"
                    y="0"
                    maskUnits="userSpaceOnUse"
                    style="mask-type: alpha"
                  >
                    <path fill="#D9D9D9" d="M0 0h20v20H0z"></path>
                  </mask>
                  <g mask="url(#right-purple_svg__a)">
                    <path
                      fill="#7132B0"
                      d="M11.665 15 10.5 13.792l2.958-2.959H3.332V9.167h10.125l-2.958-2.959L11.665 5l5 5z"
                    ></path>
                  </g>
                </svg></div
            ></a>
            <div>
              <h2
                class="inter-display-font mb-6 text-xl font-semibold text-dark-10 leading-[24px]"
              >
                How to apply for IPOs on Upstox
              </h2>
              <div class="flex flex-col gap-8 sm:gap-5">
                <div class="relative flex items-start">
                  <div class="flex flex-col items-center">
                    <div class="h-2 w-2 rounded-full bg-main-7"></div>
                    <div
                      class="absolute top-5 h-full w-[2px] bg-dark-8 md:top-3"
                    ></div>
                  </div>
                  <div class="ml-4">
                    <p
                      class="text-[12px] font-semibold uppercase leading-[110%] tracking-[1.6px] text-dark-7 sm:text-[8px] sm:font-medium"
                    >
                      Step
                      <!-- -->1
                    </p>
                    <p
                      class="mt-2 text-base font-semibold leading-[150%] text-dark-10 sm:text-sm sm:font-medium"
                    >
                      Go to www.upstox.com/ipo or open the Upstox mobile app and
                      select the IPO you wish to apply for from the 'Open IPO'
                      section
                    </p>
                  </div>
                </div>
                <div class="relative flex items-start">
                  <div class="flex flex-col items-center">
                    <div class="h-2 w-2 rounded-full bg-main-7"></div>
                    <div
                      class="absolute top-5 h-full w-[2px] bg-dark-8 md:top-3"
                    ></div>
                  </div>
                  <div class="ml-4">
                    <p
                      class="text-[12px] font-semibold uppercase leading-[110%] tracking-[1.6px] text-dark-7 sm:text-[8px] sm:font-medium"
                    >
                      Step
                      <!-- -->2
                    </p>
                    <p
                      class="mt-2 text-base font-semibold leading-[150%] text-dark-10 sm:text-sm sm:font-medium"
                    >
                      Click on apply, enter the lot size, price and provide your
                      UPI mandate.
                    </p>
                  </div>
                </div>
                <div class="relative flex items-start">
                  <div class="flex flex-col items-center">
                    <div class="h-2 w-2 rounded-full bg-main-7"></div>
                  </div>
                  <div class="ml-4">
                    <p
                      class="text-[12px] font-semibold uppercase leading-[110%] tracking-[1.6px] text-dark-7 sm:text-[8px] sm:font-medium"
                    >
                      Step
                      <!-- -->3
                    </p>
                    <p
                      class="mt-2 text-base font-semibold leading-[150%] text-dark-10 sm:text-sm sm:font-medium"
                    >
                      Approve the UPI mandate on your UPI app and you are all
                      set!
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="global-hz-margin border-border-light mt-0 border-b"
            ></div>
            <div>
              <span
                class="relative inline-flex items-baseline whitespace-normal text-left align-middle text-dark-1 outline-none text-2xl font-semibold not-italic leading-[110%] tracking-[-0.24px] xl:hidden"
                >Other IPO Links</span
              ><span
                class="inter-display-font hidden text-xs font-medium tracking-[2.4px] text-dark-7 xl:block"
                >OTHER IPO LINKS</span
              >
              <div class="flex flex-col">
                <a
                  target="_blank"
                  rel="noreferrer"
                  class="flex items-center justify-between border-b border-light-4 py-4"
                  href="/ipo/sme/"
                  ><span class="text-xs font-bold text-primary-accent3"
                    >All SME IPOs</span
                  ><svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 20 20"
                    class="shrink-0 h-5 w-5"
                  >
                    <mask
                      id="right-purple_svg__a"
                      width="20"
                      height="20"
                      x="0"
                      y="0"
                      maskUnits="userSpaceOnUse"
                      style="mask-type: alpha"
                    >
                      <path fill="#D9D9D9" d="M0 0h20v20H0z"></path>
                    </mask>
                    <g mask="url(#right-purple_svg__a)">
                      <path
                        fill="#7132B0"
                        d="M11.665 15 10.5 13.792l2.958-2.959H3.332V9.167h10.125l-2.958-2.959L11.665 5l5 5z"
                      ></path>
                    </g></svg></a
                ><a
                  target="_blank"
                  rel="noreferrer"
                  class="flex items-center justify-between border-b border-light-4 py-4"
                  href="/ipo/mainboard/"
                  ><span class="text-xs font-bold text-primary-accent3"
                    >All Mainboard IPOs</span
                  ><svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 20 20"
                    class="shrink-0 h-5 w-5"
                  >
                    <mask
                      id="right-purple_svg__a"
                      width="20"
                      height="20"
                      x="0"
                      y="0"
                      maskUnits="userSpaceOnUse"
                      style="mask-type: alpha"
                    >
                      <path fill="#D9D9D9" d="M0 0h20v20H0z"></path>
                    </mask>
                    <g mask="url(#right-purple_svg__a)">
                      <path
                        fill="#7132B0"
                        d="M11.665 15 10.5 13.792l2.958-2.959H3.332V9.167h10.125l-2.958-2.959L11.665 5l5 5z"
                      ></path>
                    </g></svg
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<style scoped>
</style>
